var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 215.6 352.84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    cx: 0,
    cy: 0,
    rx: 26.9,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 451.57 423.18)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_831",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 429.35,
    y1: 371,
    x2: 306.85,
    y2: 371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(204,204,240)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    style: {
      stopColor: "rgb(208,208,241)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    style: {
      stopColor: "rgb(230,230,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_831)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-368.55, -371)",
    d: "M 307.3 328 h 122.5 v 86 H 307.3 V 328 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.68 414.44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.8, -363.2)",
    d: "M 341.1 365.9 l 83.1 48 a 10.6 10.6 0 0 0 9.2 0 l 83.1 -48 c 2.6 -1.5 2.6 -3.9 0 -5.4 l -83.1 -48 a 10.6 10.6 0 0 0 -9.2 0 l -83.1 48 c -2.6 1.5 -2.6 3.9 0 5.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.86 401.29)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_832",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 519.14,
    y1: 351.45,
    x2: 339.89,
    y2: 351.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(247,247,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(238,238,246)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_832)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.95, -351.45)",
    d: "M 341.2 354.1 l 83.1 48 c 2.9 1.5 6.4 1.5 9.3 0 l 83.1 -48 c 2.5 -1.4 2.5 -3.8 0 -5.3 l -83.1 -48 c -2.9 -1.5 -6.4 -1.5 -9.3 0 l -83.1 48 c -2.5 1.5 -2.5 3.9 0 5.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 580.84 401.29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-473.64, -351.46)",
    d: "M 433 402.1 l 83.1 -48 c 2.6 -1.4 2.6 -3.8 0 -5.3 l -83.1 -48 c -1.3 -0.7 -2.8 -1 -4.3 -1.1 c 1.7 0 3.4 0.3 4.9 1.1 l 83.1 48 c 2.5 1.5 2.5 3.9 0 5.3 l -83.1 48 c -1.5 0.9 -3.2 1.2 -4.9 1.1 a 9.16 9.16 0 0 0 4.3 -1.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.88 401.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.96, -351.5)",
    d: "M 440.6 377.2 l -43.7 -6.8 c -0.2 0 -0.3 -0.1 -0.4 -0.3 l -11.7 -25.2 c -0.1 -0.2 0 -0.4 0.2 -0.6 l 32 -18.5 h 0.3 l 43.7 6.7 l 0.4 0.3 l 11.7 25.2 c 0.1 0.2 0.1 0.5 -0.1 0.6 h -0.1 l -32 18.5 l -0.3 0.1 h 0 h 0 z m 20 -43.8 l -43.3 -6.7 l -31.5 18.2 l 11.5 24.6 l 43.3 6.7 L 472 358 l -11.4 -24.6 h 0 z m -31.9 35.7 l -29.8 -17.2 l -0.2 -0.4 c 0 -0.2 0.1 -0.4 0.2 -0.4 l 29.8 -17.2 h 0.5 l 29.7 17.2 c 0.2 0 0.3 0.2 0.3 0.4 s -0.1 0.3 -0.3 0.4 l -29.7 17.2 h -0.5 z m 0.2 -34.3 l -28.8 16.7 l 28.8 16.6 l 28.9 -16.6 l -28.9 -16.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 544.14 391.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 2.1,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 544.17 391.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-443.83, -342.89)",
    d: "M 442.1 344.1 a 1.3 1.3 0 0 1 -0.8 -1.2 c 0 -0.5 0.3 -1 0.8 -1.3 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.3 1 1 0.8 1.7 c -0.1 0.4 -0.4 0.7 -0.8 0.8 c -1.1 0.6 -2.3 0.6 -3.4 0 z m 0.5 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.5 c 0.8 0.3 1.7 0.3 2.5 0 c 0.2 -0.2 0.4 -0.4 0.4 -0.5 c -0.1 -0.2 -0.2 -0.4 -0.4 -0.5 c -0.4 -0.2 -0.8 -0.3 -1.3 -0.3 c -0.4 0 -0.8 0.1 -1.2 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 507.59 410.91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-414.09, -360.05)",
    d: "M 412.6 359.2 c -0.8 0.5 -0.8 1.2 0 1.7 a 2.99 2.99 0 0 0 2.9 0 c 0.9 -0.5 0.9 -1.2 0 -1.7 a 2.99 2.99 0 0 0 -2.9 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 507.47 410.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-413.99, -360.09)",
    d: "M 412.4 361.3 c -0.7 -0.2 -1.1 -0.9 -0.9 -1.6 c 0.1 -0.4 0.5 -0.8 0.9 -0.9 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.4 0.9 1.2 0.6 1.9 h 0 c -0.1 0.2 -0.4 0.5 -0.6 0.6 c -1.1 0.6 -2.3 0.6 -3.4 0 z m 0.4 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.4 c 0.8 0.4 1.7 0.4 2.5 0 c 0.3 -0.1 0.4 -0.3 0.4 -0.4 s -0.2 -0.5 -0.4 -0.5 l -1.2 -0.3 c -0.5 0 -0.9 0.1 -1.3 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 562.46 401.34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 2.1,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 562.46 401.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-458.7, -351.56)",
    d: "M 457 352.7 c -0.7 -0.3 -0.9 -1.1 -0.6 -1.7 v -0.1 h 0 c 0.1 -0.2 0.4 -0.5 0.6 -0.6 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.4 0.9 1.2 0.6 1.9 h 0 c -0.1 0.2 -0.4 0.5 -0.6 0.6 c -1.1 0.6 -2.4 0.5 -3.4 -0.1 h 0 z m 0.4 -1.7 c -0.2 0.1 -0.4 0.3 -0.4 0.5 l 0.4 0.4 a 2.97 2.97 0 0 0 2.6 0 l 0.4 -0.4 c -0.1 -0.2 -0.2 -0.4 -0.4 -0.5 a 2.97 2.97 0 0 0 -2.6 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.82 382.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.91, -334.29)",
    d: "M 427.5 333.4 c -0.9 0.5 -0.9 1.3 0 1.7 a 2.99 2.99 0 0 0 2.9 0 c 0.8 -0.4 0.8 -1.2 0 -1.7 c -0.9 -0.4 -2 -0.4 -2.9 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.87 382.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.95, -334.29)",
    d: "M 427.2 335.5 a 1.3 1.3 0 0 1 -0.8 -1.2 c 0 -0.5 0.3 -1 0.8 -1.3 a 4.04 4.04 0 0 1 3.4 0 c 0.6 0.4 0.9 0.8 0.9 1.3 c 0 0.6 -0.4 1 -0.9 1.2 c -1.1 0.6 -2.3 0.6 -3.4 0 z m 0.5 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.5 c 0.8 0.3 1.7 0.3 2.5 0 c 0.3 -0.2 0.4 -0.4 0.4 -0.5 s -0.2 -0.5 -0.4 -0.5 c -0.4 -0.2 -0.8 -0.3 -1.3 -0.3 l -1.2 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 507.6 391.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 2.1,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 507.51 391.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-414.02, -342.89)",
    d: "M 412.4 344.1 c -0.7 -0.2 -1.1 -0.9 -0.9 -1.6 a 1.96 1.96 0 0 1 0.9 -0.9 a 4.04 4.04 0 0 1 3.4 0 c 0.4 0.3 0.7 0.8 0.8 1.3 a 1.3 1.3 0 0 1 -0.8 1.2 c -1.1 0.6 -2.3 0.6 -3.4 0 z m 0.4 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.5 c 0.8 0.3 1.7 0.3 2.5 0 c 0.3 -0.2 0.4 -0.4 0.4 -0.5 s -0.2 -0.5 -0.4 -0.5 l -1.2 -0.3 c -0.5 0 -0.9 0.1 -1.3 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 489.28 401.34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 2.1,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 489.17 401.32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-399.12, -351.49)",
    d: "M 397.5 352.7 c -0.5 -0.2 -0.9 -0.7 -0.9 -1.2 c 0.1 -0.5 0.4 -1 0.9 -1.3 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.4 0.9 1.2 0.6 1.9 h 0 c -0.1 0.2 -0.4 0.5 -0.6 0.6 c -1.1 0.6 -2.3 0.6 -3.4 0 z m 0.4 -1.7 c -0.2 0.1 -0.4 0.3 -0.4 0.5 l 0.4 0.4 c 0.8 0.4 1.7 0.4 2.5 0 c 0.3 -0.1 0.4 -0.3 0.4 -0.4 s -0.2 -0.5 -0.4 -0.5 l -1.2 -0.3 c -0.5 0 -0.9 0.1 -1.3 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 544.14 410.91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-443.8, -360.05)",
    d: "M 442.3 359.2 c -0.8 0.5 -0.8 1.2 0 1.7 a 3.19 3.19 0 0 0 3 0 c 0.8 -0.5 0.8 -1.2 0 -1.7 a 3.19 3.19 0 0 0 -3 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 544.26 411.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-443.91, -360.16)",
    d: "M 442.1 361.3 c -0.7 -0.3 -0.9 -1.1 -0.6 -1.7 v -0.1 h 0 c 0.1 -0.2 0.4 -0.5 0.6 -0.6 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.2 1.1 0.9 0.9 1.6 c -0.1 0.4 -0.5 0.8 -0.9 0.9 c -1.1 0.6 -2.4 0.5 -3.4 -0.1 h 0 z m 0.5 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.4 c 0.8 0.4 1.7 0.4 2.5 0 c 0.2 -0.1 0.4 -0.3 0.4 -0.4 c -0.1 -0.2 -0.2 -0.4 -0.4 -0.5 c -0.4 -0.2 -0.8 -0.3 -1.3 -0.3 c -0.4 0 -0.8 0.1 -1.2 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.82 401.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.91, -351.45)",
    d: "M 427.5 350.6 c -0.9 0.5 -0.9 1.2 0 1.7 a 2.99 2.99 0 0 0 2.9 0 c 0.8 -0.5 0.8 -1.2 0 -1.7 a 2.99 2.99 0 0 0 -2.9 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.94 401.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-429.01, -351.56)",
    d: "M 427.2 352.7 c -0.7 -0.3 -0.9 -1.1 -0.6 -1.7 v -0.1 h 0 c 0.1 -0.2 0.4 -0.5 0.6 -0.6 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.2 1.1 0.9 0.9 1.6 c -0.1 0.4 -0.5 0.8 -0.9 0.9 c -1.1 0.6 -2.4 0.5 -3.4 -0.1 h 0 z m 0.5 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.4 c 0.8 0.4 1.7 0.4 2.5 0 c 0.3 -0.1 0.4 -0.3 0.4 -0.4 s -0.2 -0.5 -0.4 -0.5 c -0.4 -0.2 -0.8 -0.3 -1.3 -0.3 c -0.4 0 -0.8 0.1 -1.2 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.82 420.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-428.91, -368.65)",
    d: "M 427.5 367.8 c -0.9 0.5 -0.9 1.2 0 1.7 a 2.99 2.99 0 0 0 2.9 0 c 0.8 -0.5 0.8 -1.2 0 -1.7 a 2.99 2.99 0 0 0 -2.9 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.94 420.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-429.01, -351.56)",
    d: "M 427.2 352.7 c -0.7 -0.3 -0.9 -1.1 -0.6 -1.7 v -0.1 h 0 c 0.1 -0.2 0.4 -0.5 0.6 -0.6 a 4.04 4.04 0 0 1 3.4 0 c 0.7 0.2 1.1 0.9 0.9 1.6 c -0.1 0.4 -0.5 0.8 -0.9 0.9 c -1.1 0.6 -2.4 0.5 -3.4 -0.1 h 0 z m 0.5 -1.7 c -0.2 0 -0.4 0.3 -0.4 0.5 s 0.1 0.3 0.4 0.4 c 0.8 0.4 1.7 0.4 2.5 0 c 0.3 -0.1 0.4 -0.3 0.4 -0.4 s -0.2 -0.5 -0.4 -0.5 c -0.4 -0.2 -0.8 -0.3 -1.3 -0.3 c -0.4 0 -0.8 0.1 -1.2 0.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 565.21 380.62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-460.94, -333)",
    d: "M 458.5 334.4 a 5.1 5.1 0 0 0 4.8 0 c 1.4 -0.8 1.4 -2 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 565.09 380.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-460.84, -333.04)",
    d: "M 458.3 334.8 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 a 6.95 6.95 0 0 1 5.3 0 c 1 0.5 1.4 1.7 0.9 2.7 a 1.96 1.96 0 0 1 -0.9 0.9 c -0.8 0.4 -1.8 0.6 -2.7 0.6 s -1.8 -0.2 -2.6 -0.6 h 0 h 0 z m 0.5 -2.8 c -0.5 0.3 -0.8 0.6 -0.8 1 a 1.59 1.59 0 0 0 0.8 1 a 5.36 5.36 0 0 0 4.3 0 a 1.59 1.59 0 0 0 0.8 -1 c 0 -0.4 -0.3 -0.7 -0.8 -1 c -0.7 -0.3 -1.4 -0.4 -2.2 -0.5 c -0.7 0 -1.4 0.2 -2.1 0.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 580.09 408.66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-473.04, -358.04)",
    d: "M 470.6 359.4 a 5.1 5.1 0 0 0 4.8 0 c 1.4 -0.8 1.4 -2 0 -2.8 a 5.75 5.75 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 579.97 408.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-472.94, -358.04)",
    d: "M 470.4 359.8 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 a 6.95 6.95 0 0 1 5.3 0 c 1 0.5 1.4 1.7 0.9 2.7 a 1.96 1.96 0 0 1 -0.9 0.9 c -0.8 0.4 -1.8 0.6 -2.7 0.6 s -1.8 -0.2 -2.6 -0.6 h 0 h 0 z m 0.4 -2.8 c -0.4 0.3 -0.7 0.6 -0.7 1 s 0.3 0.7 0.7 1 a 4.87 4.87 0 0 0 4.4 0 c 0.5 -0.3 0.8 -0.6 0.8 -1 a 1.59 1.59 0 0 0 -0.8 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 511.91 372.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-417.6, -326.04)",
    d: "M 415.2 327.4 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 a 5.75 5.75 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 511.87 372.78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-417.57, -326)",
    d: "M 415 327.8 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 c 1.6 -0.8 3.6 -0.8 5.2 0 a 2.06 2.06 0 0 1 1.2 2.5 c -0.2 0.5 -0.7 0.9 -1.2 1.1 c -1.6 0.8 -3.6 0.8 -5.2 0 h 0 z m 0.4 -2.8 c -0.4 0.3 -0.7 0.6 -0.7 1 s 0.2 0.7 0.7 1 a 4.87 4.87 0 0 0 4.4 0 c 0.5 -0.3 0.7 -0.6 0.7 -1 c -0.1 -0.4 -0.4 -0.7 -0.7 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 539.83 429.83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-440.3, -376.94)",
    d: "M 437.9 378.3 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 a 5.75 5.75 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 539.87 429.83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-440.34, -376.94)",
    d: "M 437.6 378.7 c -1 -0.5 -1.4 -1.7 -0.9 -2.7 a 1.96 1.96 0 0 1 0.9 -0.9 a 6.95 6.95 0 0 1 5.3 0 c 1 0.4 1.5 1.4 1.2 2.4 a 1.8 1.8 0 0 1 -1.2 1.2 c -0.8 0.4 -1.7 0.6 -2.6 0.6 s -1.9 -0.2 -2.7 -0.6 h 0 h 0 z m 0.5 -2.8 a 1.59 1.59 0 0 0 -0.8 1 c 0 0.4 0.3 0.7 0.8 1 a 4.87 4.87 0 0 0 4.4 0 c 0.4 -0.3 0.7 -0.6 0.7 -1 c -0.1 -0.4 -0.4 -0.7 -0.7 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 486.51 421.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-396.95, -369.94)",
    d: "M 394.5 371.3 c 1.5 0.8 3.4 0.8 4.9 0 c 1.3 -0.7 1.3 -2 0 -2.8 c -1.6 -0.7 -3.3 -0.7 -4.9 0 c -1.3 0.8 -1.3 2.1 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 486.37 422.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-396.84, -370)",
    d: "M 394.3 371.7 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 a 6.95 6.95 0 0 1 5.3 0 c 1 0.5 1.4 1.7 0.9 2.7 a 1.96 1.96 0 0 1 -0.9 0.9 c -0.8 0.5 -1.7 0.7 -2.6 0.7 c -1 0.1 -1.9 -0.2 -2.7 -0.7 h 0 h 0 z m 0.5 -2.7 c -0.4 0.2 -0.7 0.5 -0.8 0.9 c 0 0.4 0.3 0.7 0.8 1 c 1.3 0.7 3 0.7 4.3 0 c 0.5 -0.3 0.8 -0.6 0.8 -1 c -0.1 -0.4 -0.4 -0.7 -0.8 -0.9 c -0.6 -0.4 -1.4 -0.6 -2.1 -0.6 c -0.8 0 -1.5 0.2 -2.2 0.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 472.18 393.72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-385.3, -344.7)",
    d: "M 382.9 346.1 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2.1 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.7 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 472.15 393.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-385.28, -344.66)",
    d: "M 382.7 346.5 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 c 1.7 -0.9 3.6 -0.9 5.3 0 c 0.7 0.4 1.1 1 1.2 1.8 c -0.1 0.8 -0.5 1.4 -1.2 1.8 c -0.8 0.4 -1.8 0.6 -2.7 0.6 s -1.8 -0.2 -2.6 -0.6 h 0 h 0 z m 0.4 -2.8 c -0.4 0.3 -0.7 0.6 -0.7 1 s 0.3 0.8 0.7 0.9 a 4.87 4.87 0 0 0 4.4 0 c 0.4 -0.1 0.7 -0.5 0.8 -0.9 c 0 -0.4 -0.3 -0.7 -0.8 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.86 436.3)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_833",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(179.3 0 0 -62.42 -4162.48 49476.84)",
    x1: 26.118,
    y1: 785.228,
    x2: 25.718,
    y2: 783.768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_833)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-486.75, -531.21)",
    d: "M 399 502.6 l 83.1 48 c 2.9 1.5 6.4 1.5 9.3 0 l 83.1 -48 c 1.1 -0.4 1.9 -1.4 1.9 -2.6 v 10.6 c -0.1 1.2 -0.8 2.2 -1.9 2.7 l -83.1 48 c -2.9 1.5 -6.4 1.5 -9.3 0 l -83.1 -48 c -1.1 -0.5 -1.8 -1.5 -1.9 -2.7 V 500 c 0 1.2 0.8 2.2 1.9 2.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 525.86 436.89)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_834",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 574.008,
    y1: 532.594,
    x2: 394.749,
    y2: 528.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,152,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    style: {
      stopColor: "rgb(250,150,71)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    style: {
      stopColor: "rgb(239,145,76)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    style: {
      stopColor: "rgb(220,135,86)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    style: {
      stopColor: "rgb(193,122,99)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    style: {
      stopColor: "rgb(159,105,115)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(119,85,135)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_834)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-486.75, -531.74)",
    d: "M 575.3 508.3 l -83.1 48 a 12.29 12.29 0 0 1 -10.9 0 l -83.1 -48 l -1.1 -0.8 v -1.6 c 0.4 0.6 1 1.1 1.6 1.5 l 83.2 48 c 1.5 0.8 3.1 1.1 4.8 1.1 c 1.7 0.1 3.4 -0.3 4.9 -1.1 l 83.1 -48 c 0.7 -0.4 1.2 -0.9 1.7 -1.5 v 1.6 l -1.1 0.8 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 73.59 312.52)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_835",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 179.85,
    y1: 420.7,
    x2: 57.35,
    y2: 420.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(204,204,240)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    style: {
      stopColor: "rgb(208,208,241)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    style: {
      stopColor: "rgb(230,230,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_835)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-119.05, -420.7)",
    d: "M 57.8 377.7 h 122.5 v 86 H 57.8 v -86 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 147.82 304.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-121.6, -265.31)",
    d: "M 33.9 268 l 83.1 48 a 10.6 10.6 0 0 0 9.2 0 l 83.1 -48 c 2.6 -1.5 2.6 -3.9 0 -5.4 l -83.1 -47.9 c -2.9 -1.5 -6.3 -1.5 -9.2 0 l -83.1 47.9 c -2.6 1.5 -2.6 3.9 0 5.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 149.87 291.66)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_836",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 269.626,
    y1: 401.15,
    x2: 90.326,
    y2: 401.15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(247,247,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(238,238,246)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_836)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.4, -401.15)",
    d: "M 91.7 403.8 l 83.1 48 c 2.9 1.5 6.3 1.5 9.2 0 l 83.1 -48 c 2.6 -1.4 2.6 -3.8 0 -5.3 l -83.1 -48 c -2.9 -1.5 -6.3 -1.5 -9.2 0 l -83.1 48 c -2.6 1.5 -2.6 3.9 0 5.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 147.76 325.64)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_837",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(179.3 0 0 -62.42 -4469.88 49377.41)",
    x1: 26.12,
    y1: 785.227,
    x2: 25.72,
    y2: 783.767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_837)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.35, -432.41)",
    d: "M 91.7 403.8 l 83.1 48 c 2.9 1.5 6.3 1.5 9.2 0 l 83.1 -48 c 1.1 -0.4 1.9 -1.4 1.9 -2.6 v 10.6 c -0.1 1.2 -0.8 2.2 -1.9 2.7 l -83.1 48 c -2.9 1.5 -6.3 1.5 -9.2 0 l -83.1 -48 c -1.1 -0.4 -1.9 -1.5 -2 -2.7 v -10.6 c 0.1 1.2 0.9 2.2 2 2.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 147.76 326.23)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_838",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 266.321,
    y1: 433.788,
    x2: 87.062,
    y2: 430.172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,152,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    style: {
      stopColor: "rgb(250,150,71)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    style: {
      stopColor: "rgb(239,145,76)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52%",
    style: {
      stopColor: "rgb(220,135,86)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    style: {
      stopColor: "rgb(193,122,99)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    style: {
      stopColor: "rgb(159,105,115)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(119,85,135)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_838)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.35, -432.94)",
    d: "M 267.9 409.5 l -83.1 48 c -3.4 1.7 -7.4 1.7 -10.8 0 l -83.1 -48 l -1.2 -0.8 v -1.6 c 0.5 0.6 1 1.1 1.7 1.5 l 83.1 47.9 a 10.6 10.6 0 0 0 9.8 0 l 83.1 -47.9 c 0.6 -0.4 1.2 -0.9 1.6 -1.5 v 1.6 l -1.1 0.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 148.2 290.62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-121.9, -252.65)",
    d: "M 112.5 279.6 l -36.7 -21.2 c -0.2 -0.1 -0.3 -0.2 -0.3 -0.4 v -10.7 c 0 -0.2 0.1 -0.3 0.3 -0.4 l 36.7 -21.2 h 18.9 l 36.7 21.2 l 0.2 0.4 V 258 c 0 0.2 -0.1 0.3 -0.2 0.4 l -36.7 21.2 c 0 0 -18.9 0 -18.9 0 z m 54.9 -21.9 v -10.1 l -36.4 -21 h -18.2 l -36.3 21 v 10.1 l 36.3 21 H 131 l 36.4 -21 z m -48.9 9.5 l -4.4 -0.7 c -0.2 0 -0.4 -0.3 -0.4 -0.5 l 0.2 -1.6 l -4 -1.3 l -2.8 1.1 h -0.4 l -3.2 -1.9 c -0.2 -0.1 -0.2 -0.2 -0.2 -0.4 c 0 -0.1 0 -0.3 0.1 -0.4 l 1.4 -1.2 c -0.8 -0.6 -1.6 -1.3 -2.2 -2.1 h -3.1 c -0.2 0 -0.4 -0.1 -0.4 -0.3 l -1.2 -2.5 c -0.1 -0.1 -0.1 -0.2 0 -0.4 s 0.1 -0.2 0.3 -0.2 l 2.4 -0.7 c -0.2 -0.8 -0.2 -1.7 -0.1 -2.5 l -2.5 -0.7 l -0.3 -0.2 c -0.1 -0.2 -0.1 -0.3 0 -0.4 l 1.2 -2.6 l 0.4 -0.2 h 2.8 c 0.6 -0.9 1.4 -1.6 2.2 -2.3 l -1.4 -1.2 c -0.1 -0.1 -0.1 -0.2 -0.1 -0.4 s 0.1 -0.3 0.2 -0.3 l 3.2 -1.9 h 0.4 l 2.5 0.9 l 4.1 -1.4 l -0.2 -1.5 c 0 -0.2 0.1 -0.5 0.4 -0.5 l 4.4 -0.7 l 0.4 0.2 l 1.3 1.5 h 4.8 l 1.4 -1.6 l 0.4 -0.2 l 4.4 0.7 c 0.3 0 0.4 0.2 0.4 0.5 l -0.2 1.6 l 3.8 1.3 l 3 -1.1 h 0.4 l 3.2 1.9 c 0.1 0 0.2 0.2 0.2 0.3 s -0.1 0.3 -0.1 0.4 l -1.7 1.5 l 1.9 1.9 h 3.7 l 0.5 0.2 l 1.1 2.6 c 0.1 0.1 0.1 0.2 0 0.4 s -0.1 0.2 -0.3 0.2 l -3.1 0.9 c 0.1 0.7 0.1 1.3 0.1 2 l 3.2 1 c 0.2 0 0.3 0.1 0.3 0.2 s 0.1 0.3 0 0.4 l -1.1 2.5 c -0.1 0.2 -0.3 0.4 -0.5 0.3 h -3.7 l -1.7 1.8 l 1.8 1.6 c 0.1 0.2 0.1 0.3 0.2 0.4 s -0.1 0.3 -0.3 0.4 l -3.2 1.9 h -0.4 l -3.1 -1.2 c -1.1 0.6 -2.3 1 -3.5 1.3 l 0.2 1.9 c 0 0.2 -0.2 0.5 -0.4 0.5 l -4.4 0.7 l -0.4 -0.2 l -1.5 -1.8 c -1.5 0.2 -3 0.3 -4.5 0.1 l -1.5 1.8 l -0.4 0.2 h 0 h 0 z m 1.8 -2.9 c 1.6 0.1 3.2 0.1 4.8 -0.1 c 0.1 0 0.2 0 0.3 0.2 l 1.6 1.7 l 3.6 -0.6 v -1.8 c -0.1 -0.2 0.1 -0.4 0.3 -0.5 h 0 l 3.9 -1.4 h 0.4 l 3 1.1 l 2.5 -1.4 l -1.8 -1.5 c -0.1 -0.1 -0.1 -0.2 -0.1 -0.4 c 0 -0.1 0 -0.2 0.1 -0.3 c 0.8 -0.7 1.6 -1.4 2.2 -2.3 c 0.1 -0.1 0.2 -0.2 0.4 -0.2 l 3.6 0.2 l 0.9 -1.8 l -3.2 -0.9 c -0.2 0 -0.3 -0.2 -0.3 -0.5 c 0.1 -0.8 0.1 -1.7 -0.1 -2.5 c -0.1 -0.3 0.1 -0.5 0.4 -0.6 h 0 l 3 -0.8 l -0.8 -1.8 h -4.1 c -0.7 -0.8 -1.5 -1.6 -2.3 -2.3 c -0.2 -0.1 -0.2 -0.2 -0.2 -0.4 s 0.1 -0.3 0.2 -0.3 l 1.6 -1.4 l -2.5 -1.5 l -2.9 1.2 h -0.4 c -1.4 -0.6 -2.8 -1.1 -4.2 -1.4 c -0.2 -0.1 -0.4 -0.3 -0.3 -0.5 v -1.7 l -3.7 -0.5 l -1.4 1.6 l -0.4 0.2 h -5 l -0.4 -0.2 l -1.3 -1.5 l -3.7 0.5 v 1.5 c 0.1 0.2 0.1 0.3 0 0.4 h -0.3 c -1.6 0.4 -3.1 0.9 -4.5 1.6 h -0.4 l -2.4 -1 l -2.5 1.5 l 1.3 1.1 l 0.2 0.4 l -0.2 0.3 c -1 0.7 -1.8 1.6 -2.5 2.6 l -0.4 0.2 h -2.7 l -0.8 1.8 l 2.3 0.7 c 0.3 0 0.4 0.2 0.4 0.5 c -0.2 1 -0.2 2 0.1 2.9 c 0.1 0.2 -0.1 0.4 -0.3 0.5 h 0 l -2.4 0.7 l 0.9 1.8 h 3.4 c 0.7 1 1.6 1.9 2.6 2.5 c 0.2 0.1 0.2 0.2 0.2 0.4 s -0.1 0.3 -0.1 0.4 l -1.4 1.1 l 2.5 1.4 l 2.7 -1 h 0.4 c 1.4 0.6 2.9 1.1 4.4 1.3 c 0.2 0.1 0.4 0.3 0.3 0.5 v 1.6 l 3.7 0.6 l 1.5 -1.7 l 0.3 -0.2 h 0 h 0 z m -7.3 -6.2 c -2.5 -1.4 -3.9 -3.4 -3.9 -5.4 s 1.4 -4 3.9 -5.5 c 5.6 -2.8 12.3 -2.8 17.9 0 c 2.4 1.5 3.8 3.4 3.8 5.5 s -1.4 4 -3.8 5.4 c -5.6 2.8 -12.3 2.8 -17.9 0 z m 0.4 -10.1 c -2.1 1.3 -3.3 2.9 -3.3 4.7 s 1.2 3.3 3.3 4.6 c 5.3 2.7 11.7 2.7 17 0 c 2.2 -1.3 3.4 -2.9 3.4 -4.6 s -1.2 -3.4 -3.4 -4.7 a 19.5 19.5 0 0 0 -17 0 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 148.58 290.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-122.22, -252.63)",
    d: "M 143 253.1 l 35.3 -0.7 h 0.2 l 8.4 -4.9 c 0.2 -0.1 0.3 -0.3 0.2 -0.5 v -0.1 c -0.1 -0.2 -0.4 -0.3 -0.6 -0.2 h 0 l -8.4 4.8 l -35.1 0.6 a 0.47 0.47 0 1 0 0 1 h 0 h 0 z M 121.6 241 c 0.2 0 0.5 -0.2 0.5 -0.4 l 1.4 -20.2 l 8.3 -4.7 c 0.2 -0.1 0.2 -0.4 0.1 -0.7 s -0.4 -0.3 -0.5 -0.1 h -0.1 l -8.4 4.8 c -0.2 0.1 -0.3 0.2 -0.3 0.4 l -1.4 20.4 c -0.1 0.2 0.1 0.5 0.4 0.5 z m 20.7 0.7 h 0.2 l 17.1 -9.9 c 0.2 -0.1 0.3 -0.3 0.2 -0.5 v -0.1 c -0.2 -0.2 -0.4 -0.3 -0.7 -0.2 l -17 9.9 c -0.2 0.1 -0.3 0.4 -0.2 0.5 h 0 c 0 0.2 0.2 0.3 0.4 0.3 z m -37.2 1.6 c 0.2 0 0.3 -0.1 0.4 -0.3 s 0 -0.4 -0.2 -0.6 l -20.2 -11.7 c -0.3 0 -0.5 0 -0.6 0.2 s -0.1 0.4 0 0.6 h 0.1 l 20.3 11.7 l 0.2 0.1 z m -47.3 15.3 h 0.2 l 8.3 -4.8 l 34.6 -0.5 c 0.3 0 0.5 -0.2 0.5 -0.4 v -0.1 c 0 -0.2 -0.2 -0.4 -0.4 -0.4 h -0.1 l -34.7 0.4 H 66 l -8.5 4.9 c -0.2 0.1 -0.3 0.4 -0.1 0.5 h 0 c -0.1 0.2 0.1 0.4 0.3 0.4 c 0 0 0.1 0 0.1 0 z m 55.1 31.9 h 0.3 l 8.4 -4.9 c 0.1 0 0.2 -0.2 0.2 -0.3 l 1.9 -20.4 c 0 -0.2 -0.2 -0.5 -0.4 -0.5 s -0.5 0.2 -0.5 0.4 l -1.9 20.1 l -8.2 4.7 c -0.2 0.2 -0.3 0.4 -0.2 0.6 s 0.2 0.3 0.4 0.3 h 0 h 0 z m -27.5 -16 h 0.2 l 17 -9.8 c 0.2 -0.1 0.2 -0.4 0.1 -0.7 h 0 c -0.1 -0.2 -0.4 -0.3 -0.5 -0.1 h -0.1 l -16.9 9.7 c -0.2 0.2 -0.3 0.4 -0.2 0.7 h 0 c 0.1 0.2 0.2 0.2 0.4 0.2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 194.3 266.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-159.38, -231.35)",
    d: "M 157 232.7 a 5.1 5.1 0 0 0 4.8 0 c 0.7 -0.2 1.1 -1 1 -1.7 a 2.41 2.41 0 0 0 -1 -1 a 5.1 5.1 0 0 0 -4.8 0 c -1.4 0.7 -1.4 2 0 2.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 194.27 266.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-159.36, -231.39)",
    d: "M 156.7 233.1 c -0.9 -0.3 -1.4 -1.2 -1.1 -2.1 c 0 -0.1 0.1 -0.2 0.1 -0.3 c 0.2 -0.5 0.5 -0.9 1 -1.1 a 6.95 6.95 0 0 1 5.3 0 c 0.6 0.4 1.1 1 1.2 1.7 c 0 0.8 -0.5 1.5 -1.2 1.8 c -0.8 0.4 -1.7 0.6 -2.6 0.6 s -1.9 -0.2 -2.7 -0.6 h 0 z m 0.5 -2.8 a 1.59 1.59 0 0 0 -0.8 1 c 0 0.5 0.3 0.9 0.8 1.1 c 1.4 0.6 3 0.6 4.4 0 c 0.4 -0.2 0.7 -0.6 0.7 -1.1 c -0.1 -0.4 -0.4 -0.7 -0.7 -1 c -1.4 -0.6 -3 -0.6 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 103.31 314.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-85.4, -274.05)",
    d: "M 83 275.4 a 5.1 5.1 0 0 0 4.8 0 c 0.7 -0.2 1.1 -1 1 -1.7 a 2.41 2.41 0 0 0 -1 -1 a 5.1 5.1 0 0 0 -4.8 0 c -0.7 0.2 -1.1 1 -1 1.7 c 0.1 0.5 0.5 0.9 1 1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 103.27 314.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-85.38, -274.05)",
    d: "M 82.8 275.8 c -0.7 -0.3 -1.2 -0.9 -1.2 -1.7 s 0.5 -1.5 1.2 -1.8 c 1.6 -0.8 3.6 -0.8 5.2 0 c 1 0.4 1.4 1.5 1 2.5 c -0.2 0.5 -0.6 0.8 -1 1 c -1.6 0.8 -3.6 0.8 -5.2 0 z m 0.4 -2.8 c -0.4 0.2 -0.7 0.6 -0.8 1.1 a 1.59 1.59 0 0 0 0.8 1 c 1.4 0.6 3 0.6 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c -0.1 -0.4 -0.4 -0.8 -0.8 -1.1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 160.05 248.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.54, -215.3)",
    d: "M 129.1 216.7 a 5.1 5.1 0 0 0 4.8 0 c 1.4 -0.8 1.4 -2.1 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.7 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 160.06 248.83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.54, -215.33)",
    d: "M 128.9 217 c -0.8 -0.2 -1.3 -0.9 -1.2 -1.7 c 0 -0.8 0.5 -1.5 1.2 -1.8 c 1.6 -0.8 3.6 -0.8 5.2 0 c 0.7 0.4 1.2 1 1.3 1.8 c -0.1 0.8 -0.6 1.4 -1.3 1.7 a 4.88 4.88 0 0 1 -5.2 0 z m 0.4 -2.7 c -0.5 0.2 -0.8 0.6 -0.7 1 c 0 0.4 0.3 0.8 0.7 1 c 1.4 0.6 3 0.6 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c -0.1 -0.5 -0.4 -0.8 -0.8 -1 a 4.33 4.33 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 102.64 266.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-84.86, -231.14)",
    d: "M 82.5 232.5 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 a 5.75 5.75 0 0 0 -4.8 0 c -1.4 0.8 -1.4 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 103.69 274.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-85.72, -238.66)",
    d: "M 82.2 232.9 c -0.7 -0.3 -1.2 -1 -1.2 -1.8 c 0.1 -0.7 0.5 -1.4 1.2 -1.7 c 1.7 -0.9 3.6 -0.9 5.3 0 c 0.7 0.3 1.2 0.9 1.2 1.7 s -0.5 1.5 -1.2 1.8 c -0.8 0.4 -1.7 0.6 -2.6 0.6 s -1.9 -0.2 -2.7 -0.6 z m 0.5 -2.8 a 1.59 1.59 0 0 0 -0.8 1 c 0 0.4 0.3 0.7 0.8 1 a 4.87 4.87 0 0 0 4.4 0 c 0.5 -0.3 0.7 -0.6 0.7 -1 c -0.1 -0.4 -0.4 -0.7 -0.7 -1 c -1.4 -0.6 -3 -0.6 -4.4 0 z m 13.2 18.5 l 0.4 -0.2 c 0.1 -0.3 0 -0.5 -0.2 -0.7 L 75.9 236 c -0.3 -0.1 -0.5 0 -0.7 0.2 s -0.1 0.5 0.1 0.7 h 0.1 l 20.2 11.6 l 0.3 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 91.27 272.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-75.62, -236.45)",
    d: "M 73.2 237.8 a 5.1 5.1 0 0 0 4.8 0 c 1.4 -0.7 1.4 -2 0 -2.7 a 5.1 5.1 0 0 0 -4.8 0 c -0.7 0.2 -1.1 1 -1 1.7 c 0.1 0.5 0.5 0.9 1 1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 113 267.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-93.29, -232.07)",
    d: "M 73 238.2 c -0.7 -0.3 -1.2 -0.9 -1.2 -1.7 s 0.5 -1.5 1.2 -1.8 a 6.95 6.95 0 0 1 5.3 0 c 0.9 0.5 1.4 1.5 1 2.5 a 1.65 1.65 0 0 1 -1 1 c -0.8 0.4 -1.8 0.6 -2.7 0.6 s -1.8 -0.2 -2.6 -0.6 z m 0.4 -2.8 c -0.4 0.2 -0.7 0.6 -0.7 1.1 c 0 0.4 0.3 0.8 0.7 1 c 1.4 0.6 3 0.6 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c -0.1 -0.4 -0.4 -0.8 -0.8 -1.1 c -1.4 -0.6 -3 -0.6 -4.4 0 z m 40.9 2.5 l 0.4 -0.2 c 0.1 -0.2 0.1 -0.4 0 -0.6 h -0.1 l -20.3 -11.7 c -0.2 -0.1 -0.5 -0.1 -0.6 0.1 v 0.1 c -0.1 0.3 -0.1 0.5 0.2 0.6 l 20.2 11.7 h 0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 114.01 260.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-94.1, -225.8)",
    d: "M 91.7 227.2 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 152.4 286.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-125.31, -249.1)",
    d: "M 91.5 227.6 c -1 -0.5 -1.4 -1.7 -0.9 -2.7 a 1.96 1.96 0 0 1 0.9 -0.9 c 1.6 -0.8 3.6 -0.8 5.2 0 c 1 0.5 1.4 1.7 0.9 2.7 a 1.96 1.96 0 0 1 -0.9 0.9 c -1.6 0.8 -3.6 0.8 -5.2 0 z m 0.4 -2.8 c -0.5 0.3 -0.8 0.6 -0.8 1 a 1.59 1.59 0 0 0 0.8 1 a 4.87 4.87 0 0 0 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c 0 -0.4 -0.3 -0.7 -0.8 -1 a 4.87 4.87 0 0 0 -4.4 0 z m 67.8 50 l 0.5 -0.2 c 0.1 -0.2 0 -0.4 -0.2 -0.6 l -20.2 -11.7 c -0.3 -0.1 -0.6 -0.1 -0.7 0.1 c -0.1 0.3 0 0.5 0.2 0.7 l 20.2 11.7 h 0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 194.76 314.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-159.75, -274.35)",
    d: "M 162.2 273 c -1.5 -0.8 -3.4 -0.8 -4.9 0 c -0.7 0.2 -1.1 1 -1 1.7 c 0.1 0.5 0.5 0.9 1 1 c 1.5 0.8 3.4 0.8 4.9 0 c 0.7 -0.2 1.1 -1 1 -1.7 a 2.41 2.41 0 0 0 -1 -1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 193.68 306.26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-158.88, -266.61)",
    d: "M 157.1 276.1 c -0.7 -0.3 -1.2 -0.9 -1.2 -1.7 s 0.5 -1.5 1.2 -1.8 a 6.95 6.95 0 0 1 5.3 0 c 1 0.4 1.4 1.5 1 2.5 c -0.2 0.5 -0.6 0.8 -1 1 c -0.8 0.5 -1.7 0.8 -2.7 0.7 c -0.9 0 -1.8 -0.2 -2.6 -0.7 z m 0.5 -2.8 c -0.4 0.2 -0.7 0.6 -0.8 1.1 a 1.59 1.59 0 0 0 0.8 1 a 5.36 5.36 0 0 0 4.3 0 a 1.59 1.59 0 0 0 0.8 -1 c -0.1 -0.4 -0.4 -0.8 -0.8 -1.1 c -0.7 -0.3 -1.4 -0.5 -2.2 -0.5 c -0.7 0 -1.4 0.2 -2.1 0.5 z M 169 269 c 0.2 0 0.3 -0.1 0.4 -0.3 s 0 -0.4 -0.2 -0.6 L 149 256.4 c -0.3 0 -0.5 0 -0.6 0.2 s -0.1 0.4 0 0.6 h 0.1 l 20.3 11.7 c 0 0.1 0.1 0.1 0.2 0.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 206.13 308.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-169, -269.04)",
    d: "M 171.4 267.6 a 5.75 5.75 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 184.36 313.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-151.3, -273.41)",
    d: "M 166.4 270.8 c -1 -0.2 -1.6 -1.2 -1.3 -2.2 c 0.2 -0.7 0.7 -1.2 1.3 -1.3 c 1.6 -0.9 3.6 -0.9 5.2 0 c 0.7 0.3 1.2 0.9 1.2 1.7 s -0.5 1.5 -1.2 1.8 c -1.6 0.8 -3.6 0.8 -5.2 0 z m 0.4 -2.8 a 1.59 1.59 0 0 0 -0.8 1 c 0 0.5 0.3 0.9 0.8 1 a 4.87 4.87 0 0 0 4.4 0 c 0.5 -0.1 0.8 -0.5 0.8 -1 a 1.59 1.59 0 0 0 -0.8 -1 c -1.4 -0.6 -3 -0.6 -4.4 0 z m -16.3 12.2 c 0.2 0 0.3 -0.1 0.4 -0.3 s 0 -0.4 -0.1 -0.6 h -0.1 l -20.2 -11.7 c -0.3 -0.1 -0.6 0 -0.7 0.3 c 0 0.2 0 0.4 0.2 0.5 h 0.1 l 20.2 11.7 l 0.2 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 183.38 320.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-150.5, -279.7)",
    d: "M 152.9 278.3 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2 0 2.8 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 183.24 320.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-150.39, -279.7)",
    d: "M 147.9 281.5 c -1 -0.3 -1.5 -1.3 -1.3 -2.2 c 0 -0.1 0 -0.1 0.1 -0.2 a 1.8 1.8 0 0 1 1.2 -1.2 c 1.6 -0.8 3.6 -0.8 5.2 0 c 1 0.5 1.4 1.7 0.9 2.7 a 1.96 1.96 0 0 1 -0.9 0.9 c -1.6 0.8 -3.6 0.8 -5.2 0 h 0 z m 0.4 -2.8 c -0.5 0.3 -0.8 0.6 -0.8 1 a 1.59 1.59 0 0 0 0.8 1 a 4.87 4.87 0 0 0 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c 0 -0.4 -0.3 -0.7 -0.8 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 69.36 296.78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-57.8, -258.14)",
    d: "M 55.4 259.5 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.7 1.3 -2 0 -2.8 a 5.75 5.75 0 0 0 -4.8 0 c -1.3 0.8 -1.3 2.1 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 69.36 296.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-57.8, -258.11)",
    d: "M 55.2 259.9 c -0.8 -0.3 -1.2 -1 -1.2 -1.8 s 0.5 -1.4 1.2 -1.7 c 1.6 -0.9 3.6 -0.9 5.2 0 c 0.7 0.3 1.2 0.9 1.2 1.7 s -0.5 1.5 -1.2 1.8 c -1.6 0.8 -3.6 0.8 -5.2 0 z m 0.4 -2.8 a 1.59 1.59 0 0 0 -0.8 1 c 0 0.5 0.3 0.9 0.8 1 a 4.87 4.87 0 0 0 4.4 0 c 0.5 -0.1 0.8 -0.5 0.8 -1 a 1.59 1.59 0 0 0 -0.8 -1 a 4.87 4.87 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 137.2 332.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-112.96, -290)",
    d: "M 110.6 291.4 a 5.1 5.1 0 0 0 4.8 0 c 1.3 -0.8 1.3 -2 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.4 0.8 -1.4 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 137.19 332.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-112.95, -290.03)",
    d: "M 110.4 291.7 c -0.7 -0.3 -1.2 -0.9 -1.3 -1.7 c 0.1 -0.8 0.6 -1.4 1.3 -1.8 c 1.6 -0.8 3.6 -0.8 5.2 0 c 0.7 0.3 1.1 1 1.2 1.8 c 0 0.8 -0.5 1.5 -1.2 1.7 a 4.88 4.88 0 0 1 -5.2 0 z m 0.4 -2.7 c -0.5 0.1 -0.8 0.5 -0.8 1 a 1.59 1.59 0 0 0 0.8 1 a 4.87 4.87 0 0 0 4.4 0 c 0.4 -0.2 0.6 -0.6 0.7 -1 c 0 -0.4 -0.3 -0.8 -0.7 -1 a 4.33 4.33 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 230.04 283.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,242,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-188.44, -246.2)",
    d: "M 186 247.6 a 5.1 5.1 0 0 0 4.8 0 c 1.4 -0.8 1.4 -2.1 0 -2.8 a 5.1 5.1 0 0 0 -4.8 0 c -1.3 0.7 -1.3 2 0 2.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 230.05 283.44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.54, -215.33)",
    d: "M 128.9 217 c -0.8 -0.2 -1.3 -0.9 -1.2 -1.7 c 0 -0.8 0.5 -1.5 1.2 -1.8 c 1.6 -0.8 3.6 -0.8 5.2 0 c 0.7 0.4 1.2 1 1.3 1.8 c -0.1 0.8 -0.6 1.4 -1.3 1.7 a 4.88 4.88 0 0 1 -5.2 0 z m 0.4 -2.7 c -0.5 0.2 -0.8 0.6 -0.7 1 c 0 0.4 0.3 0.8 0.7 1 c 1.4 0.6 3 0.6 4.4 0 a 1.59 1.59 0 0 0 0.8 -1 c -0.1 -0.5 -0.4 -0.8 -0.8 -1 a 4.33 4.33 0 0 0 -4.4 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 360.38 341.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-296.54, -279.71)",
    d: "M 307.3 312.9 l -17.4 -10.1 c -0.5 -0.2 -0.7 -0.8 -0.5 -1.3 l 0.5 -0.5 l 17.4 -10.1 c 0.7 -0.3 1.6 -0.3 2.3 0 L 327 301 c 0.5 0.2 0.7 0.8 0.5 1.3 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10.1 c -0.4 0.2 -0.8 0.3 -1.2 0.3 c -0.4 0.1 -0.8 0 -1.1 -0.3 z m 0.4 -21.2 l -17.4 10.1 h -0.1 c 0 0.1 0 0.1 0.1 0.1 l 17.4 10.1 a 1.71 1.71 0 0 0 1.4 0 l 17.4 -10.1 h 0 l -17.4 -10.1 h -1.4 v -0.1 z m -75.6 -23.4 l -17.4 -10 c -0.4 -0.1 -0.7 -0.5 -0.7 -0.9 c 0 -0.1 0 -0.1 0.1 -0.2 c 0 -0.1 0.1 -0.2 0.1 -0.3 c 0.1 -0.2 0.3 -0.4 0.5 -0.5 l 17.4 -10 c 0.7 -0.3 1.6 -0.3 2.3 0 l 17.4 10 c 0.5 0.3 0.7 0.9 0.5 1.4 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10 c -0.4 0.2 -0.8 0.3 -1.2 0.3 c -0.4 0.1 -0.8 0 -1.1 -0.3 z m 0.4 -21.1 l -17.3 10 h -0.2 l 0.2 0.2 l 17.3 10 a 1.71 1.71 0 0 0 1.4 0 l 17.4 -10 l 0.2 -0.2 h -0.2 l -17.4 -10 l -0.7 -0.2 l -0.7 0.2 z m 126.3 63.5 l -17.4 -10.1 c -0.5 -0.2 -0.7 -0.8 -0.5 -1.3 l 0.5 -0.5 l 17.4 -10.1 c 0.7 -0.3 1.6 -0.3 2.3 0 l 17.4 10.1 c 0.5 0.2 0.7 0.8 0.5 1.3 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10.1 c -0.4 0.2 -0.7 0.4 -1.1 0.3 c -0.4 0 -0.8 -0.1 -1.2 -0.3 h 0 h 0 z m 0.5 -21.2 l -17.4 10.1 h 0 l 17.4 10.3 a 1.71 1.71 0 0 0 1.4 0 l 17.3 -10.1 h 0 l -17.3 -10.1 h -1.4 v -0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 416.4 163.21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(243,227,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-339.95, -138.88)",
    d: "M 303.6 231 l 72.7 42 c 7.7 4.5 13.9 0.9 13.9 -8 V 70.8 c 0 -8.9 -6.2 -19.7 -13.9 -24.1 l -72.7 -42 c -7.7 -4.4 -13.9 -0.8 -13.9 8 V 207 c 0 8.8 6.2 19.6 13.9 24 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 416.39 163.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(215,15,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-339.95, -138.87)",
    d: "M 303.6 10.1 l 14 8.1 v 2.1 c 0.2 3.2 1.9 6.2 4.6 8 l 35.5 20.5 c 2.6 1.5 4.6 0.3 4.6 -2.7 V 44 l 14 8.1 c 5.2 2.9 9.3 10.1 9.3 16 v 194.2 c 0 5.9 -4.1 8.3 -9.3 5.4 l -72.7 -42 c -5.1 -3 -9.3 -10.2 -9.3 -16.1 V 15.4 c 0 -5.9 4.2 -8.3 9.3 -5.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 416.39 226.74)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_839",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 339.95,
    y1: 241.722,
    x2: 339.95,
    y2: 139.102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(50,42,141)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_839)",
      fillRule: "nonzero",
      opacity: 0.4
    },
    transform: " translate(-339.95, -195.6)",
    d: "M 345.2 223.1 l -1.5 -0.9 l -0.8 -2 l 0.8 -1.2 l 1.5 0.9 l 0.8 2.1 l -0.8 1.1 h 0 z m -2.9 4.6 l -0.8 -2.1 l -1.6 -0.9 l -0.8 1.1 l 0.8 2.2 l 1.6 0.9 l 0.8 -1.2 z m 3.1 -52.5 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.2 l 0.9 0.6 l 0.5 -0.7 z m 0.9 67.5 l -0.9 -2.3 l -1.9 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.9 1 l 0.9 -1.3 h 0 z m -0.1 -5.2 l -0.9 -2.2 l -1.7 -1.1 l -0.9 1.3 l 0.9 2.3 l 1.7 1 l 0.9 -1.3 z m -0.2 -20.7 l -0.8 -2 l -1.5 -0.8 l -0.7 1 l 0.7 2 l 1.5 0.8 l 0.8 -1 z m -0.5 -36.4 l -0.5 -1.3 l -1.1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1.1 0.6 l 0.5 -0.7 z m 0.1 5.2 l -0.6 -1.4 l -1.1 -0.7 l -0.5 0.8 l 0.5 1.4 l 1.1 0.7 l 0.6 -0.8 z m 0.8 62.3 l -1 -2.4 l -1.9 -1.1 l -0.9 1.3 l 0.9 2.5 l 1.9 1.1 l 1 -1.4 h 0 z m -0.5 -36.3 l -0.7 -1.9 l -1.5 -0.8 l -0.7 1 l 0.7 1.9 l 1.5 0.8 l 0.7 -1 z m -0.3 -20.8 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.1 0.7 l 0.6 -0.8 z m 0.1 5.2 l -0.6 -1.6 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.3 0.8 l 0.6 -0.9 z m 0.1 10.4 l -0.7 -1.8 l -1.3 -0.8 l -0.7 1 l 0.7 1.8 l 1.3 0.7 l 0.7 -0.9 z m 0 -5.2 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m 0.4 31.2 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -4.1 -25.4 l -0.7 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.7 l 1.4 0.8 l 0.7 -0.9 z m -0.1 -5.2 l -0.6 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.6 l 1.3 0.8 l 0.6 -0.9 h 0 z m -0.1 -5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.8 z m 0.4 25.9 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 1 l 0.8 -1.2 h 0 z m -0.2 -10.4 l -0.7 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.9 l 0.7 -1.1 h 0 z m -0.2 -20.7 l -0.6 -1.5 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.6 -0.8 z m 0.3 25.9 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m -0.7 -51.9 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.5 l 0.4 -0.6 z m 0 -5.2 l -0.4 -1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1 l 0.8 0.4 l 0.4 -0.5 z m 0.3 26 l -0.6 -1.4 l -1 -0.7 l -0.6 0.8 l 0.6 1.4 l 1 0.6 l 0.6 -0.7 h 0 z m -0.8 -36 l 0.3 -0.4 l -0.3 -0.8 l -0.6 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.6 0.3 h 0 z m 0.4 4.8 l -0.4 -0.9 l -0.6 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.6 0.4 l 0.4 -0.5 z m 0.3 26 l -0.5 -1.4 l -1 -0.5 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.5 -0.7 h 0 z m -0.1 -10.4 l -0.5 -1.2 l -0.8 -0.5 l -0.5 0.7 l 0.5 1.1 l 0.8 0.5 l 0.5 -0.6 z m 0.1 5.2 l -0.5 -1.3 l -1 -0.5 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.5 -0.7 z m 4.4 51.4 l -0.8 -2.1 l -1.7 -1 l -0.8 1.2 l 0.8 2.1 l 1.7 0.9 l 0.8 -1.1 h 0 z m 2.9 -57.5 l -0.4 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.5 l 0.4 -0.6 z m 0 -5.2 l -0.4 -0.9 l -0.8 -0.5 l -0.3 0.6 l 0.3 0.9 l 0.8 0.5 l 0.4 -0.6 z m -17.7 74.8 l -0.9 -2.5 l -1.9 -1.1 l -1 1.4 l 1 2.4 l 1.9 1.1 l 0.9 -1.3 h 0 z m 17.9 -59.2 l -0.5 -1.2 l -1 -0.6 l -0.4 0.7 l 0.4 1.2 l 1 0.6 l 0.5 -0.7 z m -0.1 -5.2 l -0.4 -1.1 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.1 l 0.9 0.6 l 0.4 -0.7 h 0 z m 0.1 10.4 l -0.5 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1 0.5 l 0.5 -0.7 h 0 z m -0.3 -26 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m 4.6 67 l -0.7 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.7 -1.1 z m 0.4 26 l -1 -2.5 l -1.9 -1.1 l -0.9 1.4 l 0.9 2.4 l 1.9 1.1 l 1 -1.3 h 0 z m -0.3 -20.8 l -0.8 -2.1 l -1.6 -1 l -0.9 1.2 l 0.9 2.1 l 1.6 1 l 0.8 -1.2 z m -0.1 -10.4 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m -4.2 -30.6 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.7 l 0.6 1.5 l 1.1 0.6 l 0.5 -0.8 z m 4.5 56.6 l -0.9 -2.4 l -1.8 -1 l -1 1.3 l 1 2.3 l 1.8 1.1 l 0.9 -1.3 h 0 z m -0.1 -5.2 l -0.8 -2.3 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.8 -1.2 z m 0 -5.2 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -8.3 -66.7 l -0.5 -1.1 l -0.9 -0.6 l -0.4 0.7 l 0.4 1.1 l 0.9 0.5 l 0.5 -0.6 h 0 z m -0.2 -15.6 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.4 -0.5 z m 4.8 93.3 l -0.9 -2.4 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1.1 l 0.9 -1.3 z m 0 -5.2 l -0.9 -2.3 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.9 -1.2 z m -4.7 -77.7 l -0.4 -1.1 l -0.9 -0.4 l -0.4 0.6 l 0.4 1 l 0.9 0.5 l 0.4 -0.6 z m 4.6 72.5 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m -5.1 -87.6 l 0.3 -0.5 v -0.2 l -1.1 -0.6 h -0.1 l 0.3 0.8 l 0.6 0.5 h 0 z m 0.4 9.9 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.5 l 0.4 -0.6 z m 4.3 46.5 l -0.6 -1.7 l -1.3 -0.7 l -0.7 0.9 l 0.7 1.7 l 1.3 0.7 l 0.6 -0.9 z m -0.1 -10.4 l -0.6 -1.5 l -1.2 -0.7 l -0.5 0.9 l 0.5 1.5 l 1.2 0.6 l 0.6 -0.8 z m 0 5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m 0.4 31.2 l -0.8 -2.1 l -1.6 -1 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.8 -1.1 h 0 z m -0.2 -20.8 l -0.7 -1.8 l -1.4 -0.8 l -0.6 1 l 0.6 1.8 l 1.4 0.8 l 0.7 -1 z m 0.2 15.6 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m -0.2 -10.4 l -0.7 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.9 l 1.4 0.8 l 0.7 -1 z m 0.1 5.2 l -0.7 -2 l -1.5 -0.8 l -0.8 1.1 l 0.8 1.9 l 1.5 0.8 l 0.7 -1 z m -15.8 -71 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.4 -0.5 z m -3.6 10.6 l -0.4 -1.1 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.1 l 0.9 0.6 l 0.4 -0.7 h 0 z M 335 239 l -0.9 -2.4 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1.1 l 0.9 -1.3 h 0 z m -0.1 -10.4 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m 0.1 5.2 l -0.9 -2.3 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.9 -1.2 z m -4.7 -77.7 l -0.5 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.5 l 0.5 -0.6 z m -0.6 -15.1 l 0.4 -0.5 v -0.2 l -1.1 -0.6 h -0.1 l 0.3 0.8 l 0.5 0.5 h 0 z m 0.5 9.9 l -0.4 -0.9 l -0.7 -0.5 l -0.4 0.6 l 0.4 0.9 l 0.7 0.5 l 0.4 -0.6 z m 12.2 82 l -0.8 -2.2 l -1.7 -0.9 l -0.9 1.2 l 0.9 2.2 l 1.7 0.9 l 0.8 -1.2 z m -7.9 -35.5 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m -0.1 -5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m 0.4 31.2 l -0.8 -2.1 l -1.6 -1 l -0.8 1.2 l 0.8 2.1 l 1.6 1 l 0.8 -1.2 z m -0.2 -20.8 l -0.7 -1.7 l -1.4 -0.8 l -0.7 0.9 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 z m 0.2 15.6 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m -0.1 -5.2 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m -0.1 -5.2 l -0.7 -1.8 l -1.4 -0.9 l -0.7 1.1 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 h 0 z m -4.5 -62.1 l -0.3 -0.8 l -0.7 -0.5 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 h 0 z m 0.3 20.8 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.3 l 0.9 0.5 l 0.5 -0.7 z m 0.5 36.4 l -0.8 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.9 l 1.4 0.8 l 0.8 -1 z m 0 5.2 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m 0.1 5.2 l -0.8 -2 l -1.6 -0.9 l -0.7 1.1 l 0.7 2 l 1.6 0.9 l 0.8 -1.1 z m 0.3 20.8 l -1 -2.4 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1.1 l 1 -1.3 z m -0.2 -10.4 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m 0.1 5.2 l -0.9 -2.3 l -1.8 -1 l -0.8 1.2 l 0.8 2.3 l 1.8 1 l 0.9 -1.2 z m -0.1 -10.4 l -0.9 -2.1 l -1.6 -1 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.9 -1.1 h 0 z m -0.6 -41.6 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.8 z m 0 -5.2 l -0.6 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1 0.6 l 0.6 -0.8 h 0 z m 0.1 10.4 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.1 0.6 l 0.6 -0.8 z m 0.1 10.4 l -0.6 -1.7 l -1.3 -0.7 l -0.7 0.9 l 0.7 1.7 l 1.3 0.7 l 0.6 -0.9 z m 0 -5.2 l -0.7 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.7 -0.9 z m 0.1 10.4 l -0.7 -1.8 l -1.4 -0.7 l -0.6 0.9 l 0.6 1.8 l 1.4 0.8 l 0.7 -1 z m 3.6 -10.7 l -0.6 -1.5 l -1.2 -0.6 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.6 -0.9 z m 3.7 -0.6 l -0.6 -1.4 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.1 0.7 l 0.6 -0.9 h 0 z m -0.1 -5.1 l -0.5 -1.5 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.7 z m 0 -5.2 l -0.5 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1.1 0.6 l 0.5 -0.7 h 0 z m 0.2 20.7 l -0.6 -1.6 l -1.3 -0.8 l -0.7 0.9 l 0.7 1.7 l 1.3 0.8 l 0.6 -1 h 0 z m 0.2 10.4 l -0.7 -1.8 l -1.5 -0.8 l -0.7 1 l 0.7 1.8 l 1.5 0.8 l 0.7 -1 z m -0.1 -5.2 l -0.7 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.7 l 1.3 0.8 l 0.7 -1 z m -0.4 -31.1 l -0.5 -1.3 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.2 l 0.9 0.5 l 0.5 -0.6 h 0 z m 0.3 20.7 l -0.6 -1.5 l -1.3 -0.8 l -0.6 0.9 l 0.6 1.6 l 1.3 0.7 l 0.6 -0.9 z m 4.3 51.7 l -0.9 -2.3 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1 l 0.9 -1.3 h 0 z m -4.9 -93.2 l -0.3 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.3 -0.5 z m 0.2 15.6 l -0.4 -1.2 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.4 -0.6 z m 4.7 72.4 l -0.9 -2.3 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1 l 0.9 -1.3 z m -4.7 -77.6 l -0.4 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.9 0.5 l 0.4 -0.6 z m -0.5 -15.2 l 0.3 -0.4 v -0.3 l -1.1 -0.6 v 0.2 l 0.3 0.8 l 0.5 0.3 h 0 z m 0.4 10 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.4 l 0.4 -0.5 z m -3.7 5.8 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.4 l 0.4 -0.5 z m -0.1 -5.2 l -0.3 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.4 l 0.3 -0.5 z m 0.4 25.9 l -0.6 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.8 z m -0.8 -35.9 l 0.3 -0.4 l -0.3 -0.8 l -0.6 -0.4 l -0.3 0.4 l 0.3 0.8 l 0.6 0.4 z m 0.6 20.3 l -0.5 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.7 z m 4.3 46.2 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m 15 3.5 l -0.7 -1.8 l -1.4 -0.9 l -0.8 1.1 l 0.8 1.8 l 1.4 0.8 l 0.7 -1 h 0 z m -19.2 -44.5 l -0.5 -1.2 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.5 l 0.5 -0.7 z m 0 5.2 l -0.5 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1 0.6 l 0.5 -0.8 h 0 z m 4.6 67 l -0.9 -2.5 l -1.9 -1 l -1 1.3 l 1 2.5 l 1.9 1.1 l 0.9 -1.4 h 0 z m -0.3 -26 l -0.8 -2 l -1.5 -0.9 l -0.8 1.1 l 0.8 2 l 1.5 0.9 l 0.8 -1.1 z m 0.1 10.4 l -0.8 -2.2 l -1.7 -1 l -0.9 1.3 l 0.9 2.1 l 1.7 1 l 0.8 -1.2 h 0 z m 0 -5.2 l -0.8 -2.1 l -1.7 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.7 1 l 0.8 -1.2 h 0 z m 0.1 10.4 l -0.9 -2.3 l -1.7 -1 l -0.9 1.3 l 0.9 2.2 l 1.7 1.1 l 0.9 -1.3 z m 0.1 5.2 l -0.9 -2.4 l -1.9 -1 l -0.9 1.3 l 0.9 2.3 l 1.9 1.1 l 0.9 -1.3 h 0 z m 9.7 -83.8 l 0.3 -0.5 l -0.3 -0.8 l -0.6 -0.3 l -0.3 0.4 l 0.3 0.8 l 0.6 0.4 h 0 z m 30.3 43.6 l 0.4 -0.7 l -0.4 -1.3 l -1 -0.5 l -0.5 0.7 l 0.5 1.2 l 1 0.6 z m 0.5 4.5 l -0.5 -1.4 l -1 -0.6 l -0.6 0.8 l 0.6 1.3 l 1 0.6 l 0.5 -0.7 h 0 z m 0.1 5.2 l -0.6 -1.5 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.7 z m 3.9 60.1 l -0.3 -0.8 l -1.9 -1.1 l -1 1.3 l 0.6 1.5 c 0.9 0 1.9 -0.3 2.6 -0.9 h 0 h 0 z m -3.9 -54.9 l -0.5 -1.5 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.5 -0.8 z m 4 15 l -0.7 -1.8 l -1.4 -0.8 l -0.6 1 l 0.6 1.7 l 1.4 0.8 l 0.7 -0.9 z m -3.9 -9.9 l -0.6 -1.5 l -1.2 -0.7 l -0.7 0.8 l 0.7 1.6 l 1.2 0.7 l 0.6 -0.9 h 0 z m 4.1 25.4 l -0.8 -2 l -1.6 -0.9 l -0.7 1.1 l 0.7 2.1 l 1.6 0.9 l 0.8 -1.2 h 0 z m -4 -15 l -0.6 -1.7 l -1.4 -0.8 l -0.7 1 l 0.7 1.7 l 1.4 0.8 l 0.6 -1 z m 3.9 9.9 l -0.7 -2 l -1.5 -0.8 l -0.8 1 l 0.8 2 l 1.5 0.8 l 0.7 -1 z m 0 -5.2 l -0.8 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.9 l 0.8 -1 z m 0.3 25.9 l -0.9 -2.2 l -1.8 -1.1 l -0.8 1.3 l 0.8 2.3 l 1.8 1 l 0.9 -1.3 h 0 z m 0.1 5.2 l -1 -2.3 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1 l 1 -1.3 z m -0.2 -15.6 l -0.9 -2.1 l -1.6 -0.9 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.9 -1.2 z m 0 5.2 l -0.8 -2.2 l -1.7 -0.9 l -0.9 1.2 l 0.9 2.2 l 1.7 0.9 l 0.8 -1.2 z m -4.1 -30.6 l -0.7 -1.6 l -1.3 -0.8 l -0.6 0.9 l 0.6 1.7 l 1.3 0.8 l 0.7 -1 h 0 z m -8 -40.7 l -0.4 -1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.9 0.4 l 0.4 -0.6 z m -0.1 -5.2 l -0.4 -0.9 l -0.7 -0.5 l -0.4 0.6 l 0.4 0.9 l 0.7 0.5 l 0.4 -0.6 z m 0.2 10.4 l -0.5 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.7 z m -0.6 -20.3 l 0.3 -0.4 l -0.3 -0.9 l -0.7 -0.3 l -0.3 0.4 l 0.3 0.8 l 0.7 0.4 z m 0.6 25.5 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.3 l 0.9 0.5 l 0.5 -0.7 z m 0.2 10.4 l -0.6 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.8 z m -0.1 -5.2 l -0.5 -1.3 l -1.1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1.1 0.6 l 0.5 -0.8 h 0 z m 7.9 35.5 l -0.7 -1.8 l -1.4 -0.8 l -0.8 1 l 0.8 1.8 l 1.4 0.9 l 0.7 -1.1 h 0 z m -8.3 -61.5 l -0.3 -0.8 l -0.7 -0.4 l -0.3 0.4 l 0.3 0.9 l 0.7 0.4 l 0.3 -0.5 h 0 z m 8.4 71.9 l -0.7 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.7 -1.1 z m -7.9 -35.5 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.1 0.6 l 0.6 -0.8 z m 8 40.7 l -0.8 -2.1 l -1.6 -0.9 l -0.9 1.1 l 0.9 2.1 l 1.6 1 l 0.8 -1.2 h 0 z m 0.2 15.6 l -0.9 -2.4 l -1.8 -1 l -1 1.3 l 1 2.4 l 1.8 1 l 0.9 -1.3 z m -0.1 -10.4 l -0.9 -2.2 l -1.7 -1 l -0.8 1.3 l 0.8 2.1 l 1.7 1 l 0.9 -1.2 h 0 z m 0 5.2 l -0.8 -2.3 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1 l 0.8 -1.3 z m -0.2 -20.8 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m 5.8 -16 v -2.4 l -0.4 -0.3 l -0.6 0.9 l 0.6 1.6 l 0.4 0.2 z m 0 -5.2 v -2.3 l -0.4 -0.3 l -0.6 0.8 l 0.6 1.5 l 0.4 0.3 z m 0 -5.2 v -2.2 l -0.4 -0.2 l -0.5 0.7 l 0.5 1.4 l 0.4 0.3 z m 0 -5.3 v -2 l -0.3 -0.2 l -0.5 0.7 l 0.5 1.3 l 0.3 0.2 z m 0 20.9 v -2.6 l -0.5 -0.2 l -0.6 0.9 l 0.6 1.7 l 0.5 0.2 h 0 z m 0 10.5 v -2.9 l -0.5 -0.3 l -0.7 1 l 0.7 1.9 l 0.5 0.3 z m -2.3 -15.8 l -0.6 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.6 l 1.3 0.8 l 0.6 -0.9 h 0 z m 1.6 41.5 l 0.5 0.3 l 0.2 -2.4 v -1 l -0.7 -0.4 l -0.9 1.2 l 0.9 2.3 z m 0.7 -20.5 v -3 l -0.6 -0.3 l -0.7 1 l 0.7 2 l 0.6 0.3 z m -90.9 -35.1 l -0.4 0.6 v 0.2 c 0 0.7 0.1 1.4 0.2 2.1 l 0.2 0.6 l 1.8 1.1 l 0.9 -1.3 l -0.9 -2.3 l -1.8 -1 h 0 z m 90.9 -22.4 v -1.5 h -0.2 l -0.4 0.5 l 0.4 1 h 0.2 z m 0 15.7 v -1.9 l -0.3 -0.2 l -0.5 0.7 l 0.5 1.2 l 0.3 0.2 z m 0 -5.2 v -1.8 l -0.3 -0.2 l -0.4 0.7 l 0.4 1.1 l 0.3 0.2 z m -0.5 -16.7 l 0.3 0.9 h 0.2 v -1.4 h -0.2 l -0.3 0.5 z m 0.5 11.5 V 190 h -0.2 l -0.4 0.6 l 0.4 1 l 0.2 0.1 h 0 z m 0 41.8 v -2.8 l -0.5 -0.3 l -0.7 1 l 0.7 1.8 l 0.5 0.3 z m -2.5 -31.4 l -0.6 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.6 -0.7 z m -0.1 -5.2 l -0.5 -1.2 l -1 -0.6 l -0.4 0.7 l 0.4 1.2 l 1 0.6 l 0.5 -0.7 z m -0.1 -5.2 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.1 l 0.9 0.5 l 0.4 -0.6 z m 0 -5.2 l -0.5 -1.1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1.1 l 0.8 0.5 l 0.5 -0.6 z m 0.4 31.2 l -0.7 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.2 0.7 l 0.7 -0.8 h 0 z m 2.3 31.4 V 246 l -0.6 -0.4 l -0.8 1.2 l 0.8 2 l 0.6 0.3 h 0 z m -2.5 -41.8 l -0.5 -1.4 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.4 l 1.1 0.7 l 0.5 -0.8 z m 0.1 5.2 l -0.6 -1.5 l -1.2 -0.7 l -0.5 0.8 l 0.5 1.5 l 1.2 0.7 l 0.6 -0.8 z m 1.7 53.5 h 0 l -1 1.3 v 0.2 c 0.4 -0.4 0.8 -0.9 1 -1.5 z m 0.7 -6.4 v -3.4 l -0.7 -0.4 l -0.8 1.2 l 0.8 2.2 l 0.7 0.4 h 0 z m -2.8 -78.3 l -0.4 -1 l -0.8 -0.4 l -0.3 0.5 l 0.3 1 l 0.8 0.4 l 0.4 -0.5 z m 2.8 73.1 v -3.3 l -0.6 -0.4 l -0.8 1.2 l 0.8 2.1 l 0.6 0.4 z m -2.9 -78.3 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m -0.4 -4.7 l 0.4 -0.5 l -0.2 -0.3 l -1 -0.6 v 0.2 l 0.3 0.8 l 0.5 0.4 h 0 z m -13.9 53.2 l -0.7 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.9 l 1.4 0.8 l 0.7 -1 z M 356.9 200 l -0.6 -1.5 l -1.2 -0.6 l -0.5 0.8 l 0.5 1.5 l 1.2 0.7 l 0.6 -0.9 z m 0.1 5.2 l -0.7 -1.5 l -1.2 -0.8 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.7 -0.9 z m 0.1 10.4 l -0.7 -1.7 l -1.4 -0.8 l -0.6 1 l 0.6 1.7 l 1.4 0.8 l 0.7 -1 z m -0.1 -5.2 l -0.6 -1.6 l -1.3 -0.8 l -0.7 0.9 l 0.7 1.7 l 1.3 0.8 l 0.6 -1 h 0 z m 0.4 26 l -0.9 -2.1 l -1.6 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.6 1 l 0.9 -1.2 h 0 z m -0.2 -10.4 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m 0 -5.2 l -0.8 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.8 l 0.8 -1 z m 0.1 10.4 l -0.8 -2 l -1.6 -0.9 l -0.7 1.1 l 0.7 2 l 1.6 0.9 l 0.8 -1.1 z m -0.8 -62.3 l -0.4 -1 l -0.8 -0.5 l -0.3 0.6 l 0.3 1 l 0.8 0.4 l 0.4 -0.5 z m -0.5 -10 l 0.4 -0.4 l -0.4 -0.8 l -0.6 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.6 0.3 h 0 z m 0.6 15.2 l -0.5 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.5 l 0.5 -0.6 z m 0 5.2 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.2 l 0.9 0.5 l 0.4 -0.6 z m 0.2 15.5 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.8 z m 0 -5.1 l -0.6 -1.4 l -1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1 0.6 l 0.6 -0.7 h 0 z m -0.1 -5.2 l -0.5 -1.3 l -1 -0.5 l -0.4 0.6 l 0.4 1.3 l 1 0.5 l 0.5 -0.6 z m -3.7 0.2 l -0.5 -1.3 l -1 -0.6 l -0.6 0.7 l 0.6 1.4 l 1 0.6 l 0.5 -0.8 h 0 z m -0.1 -10.4 l -0.5 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.7 z m 3.5 -10.6 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m -3.5 15.8 l -0.4 -1.2 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.5 l 0.4 -0.7 z m 0.2 10.4 l -0.6 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.8 z m 0.2 15.6 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m -0.2 -10.4 l -0.5 -1.5 l -1.2 -0.6 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.5 -0.9 z m 0.1 5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.7 0.9 l 0.7 1.6 l 1.2 0.7 l 0.6 -0.9 z m 4.4 51.7 l -1 -2.4 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1.1 l 1 -1.3 h 0 z m -4.8 -82.9 l -0.4 -1 l -0.8 -0.5 l -0.5 0.6 l 0.5 1.1 l 0.8 0.4 l 0.4 -0.6 z m 19.2 44.8 l -0.6 -1.6 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.3 0.7 l 0.6 -0.9 z m -14.5 32.9 l -0.9 -2.3 l -1.8 -1 l -0.8 1.3 l 0.8 2.2 l 1.8 1.1 l 0.9 -1.3 z m -4.8 -88 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.7 0.4 l 0.4 -0.4 h 0 z m -0.4 -4.8 l 0.3 -0.4 v -0.3 l -1 -0.6 h -0.2 l 0.4 0.8 l 0.5 0.5 h 0 z m 0.4 10 l -0.3 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.4 l 0.3 -0.5 z m 4.7 77.6 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m 10.3 -74.2 l -0.4 -0.9 l -0.6 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.6 0.4 l 0.4 -0.5 z m -0.4 -4.7 l 0.3 -0.5 v -0.2 l -1 -0.6 h -0.1 l 0.3 0.8 l 0.5 0.5 h 0 z m 5.3 98 l -0.9 -2.4 l -1.9 -1.1 l -0.9 1.4 l 0.9 2.3 l 1.9 1.1 l 0.9 -1.3 z m -0.1 -5.2 l -0.9 -2.3 l -1.7 -1 l -0.9 1.2 l 0.9 2.3 l 1.7 1 l 0.9 -1.2 z m -4.6 -72.5 l -0.5 -1.1 l -0.8 -0.6 l -0.5 0.7 l 0.5 1.1 l 0.8 0.6 l 0.5 -0.7 z m -0.1 -5.2 l -0.4 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.5 l 0.4 -0.6 z m 0.2 10.4 l -0.5 -1.2 l -1 -0.6 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.5 -0.7 z m -0.2 -15.6 l -0.4 -1 l -0.8 -0.4 l -0.4 0.6 l 0.4 0.9 l 0.8 0.5 l 0.4 -0.6 z m 4.4 56.9 l -0.7 -1.8 l -1.5 -0.9 l -0.7 1 l 0.7 1.9 l 1.5 0.8 l 0.7 -1 z m -0.1 -5.2 l -0.7 -1.8 l -1.3 -0.7 l -0.7 0.9 l 0.7 1.8 l 1.3 0.8 l 0.7 -1 z m 0 -5.2 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m 0.2 20.8 l -0.8 -2 l -1.5 -0.9 l -0.8 1.1 l 0.8 2 l 1.5 0.9 l 0.8 -1.1 z m 0 -5.2 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m 0.1 10.4 l -0.8 -2.1 l -1.7 -1 l -0.8 1.2 l 0.8 2.1 l 1.7 0.9 l 0.8 -1.1 h 0 z m 0.1 5.2 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -4.4 -51.7 l -0.6 -1.4 l -1 -0.6 l -0.6 0.7 l 0.6 1.5 l 1 0.6 l 0.6 -0.8 z m 0.6 46.8 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -0.1 -5.2 l -0.8 -2.1 l -1.6 -1 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.8 -1.1 h 0 z m -0.1 -10.4 l -0.8 -2 l -1.5 -0.8 l -0.7 1 l 0.7 2 l 1.5 0.8 l 0.8 -1 z m 0.1 5.2 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m 0.3 26 l -1 -2.5 l -1.9 -1.1 l -0.9 1.4 l 0.9 2.4 l 1.9 1.1 l 1 -1.3 z m -0.1 -5.2 l -0.9 -2.4 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1.1 l 0.9 -1.3 z m 0 -5.2 l -0.9 -2.3 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.9 -1.2 z m -0.5 -36.4 l -0.7 -1.7 l -1.2 -0.7 l -0.7 0.9 l 0.7 1.7 l 1.2 0.7 l 0.7 -0.9 z m -15 -3.5 l -0.6 -1.7 l -1.4 -0.8 l -0.7 0.9 l 0.7 1.8 l 1.4 0.8 l 0.6 -1 z m 14.9 -1.7 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m -9.7 47.9 l 1.9 1.1 l 1 -1.4 l -1 -2.4 l -1.9 -1.1 l -0.9 1.3 l 0.9 2.5 z m 9.7 -53.1 l -0.6 -1.5 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.2 0.6 l 0.6 -0.8 z m -0.2 -10.4 l -0.5 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.5 -0.7 z m 0.4 26 l -0.7 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 z m -48.5 0.5 l -0.9 -2.2 l -1.7 -1 l -0.8 1.3 l 0.8 2.1 l 1.7 1 l 0.9 -1.2 h 0 z m -23.2 -59.8 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.8 z m -0.1 -5.2 l -0.5 -1.3 l -1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1 0.6 l 0.5 -0.8 z m 0.2 10.4 l -0.6 -1.5 l -1.2 -0.6 l -0.5 0.8 l 0.5 1.5 l 1.2 0.7 l 0.6 -0.9 z m -0.9 -42.3 l -0.6 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.6 0.3 l 0.3 -0.4 l -0.3 -0.8 z m 0.7 26.8 l -0.5 -1.3 l -1 -0.5 l -0.4 0.6 l 0.4 1.3 l 1 0.5 l 0.5 -0.6 z m 7.2 -21.7 l -0.4 -0.8 l -0.6 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.6 0.4 l 0.4 -0.5 h 0 z m -3.9 -5.2 l -1 -0.6 v 0.2 l 0.3 0.8 l 0.6 0.3 l 0.3 -0.4 l -0.2 -0.3 h 0 z m -5.6 51.3 l 0.7 1.7 l 1.3 0.8 l 0.6 -1 l -0.6 -1.6 l -1.3 -0.8 l -0.7 0.9 h 0 z m 0.7 -6 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.7 -0.9 l -0.7 -1.6 l -1.2 -0.7 z m 22.8 -32.6 l -0.3 0.5 l 0.3 0.8 l 0.7 0.3 l 0.3 -0.4 l -0.3 -0.8 l -0.7 -0.4 h 0 z m -23.5 43.7 v 0.2 l 0.6 1.6 l 1.4 0.8 l 0.7 -1 l -0.7 -1.7 l -1.4 -0.8 l -0.6 0.9 z m 2.1 -39.9 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.5 l 0.4 -0.6 z m 0 -5.2 l -0.4 -1 l -0.8 -0.5 l -0.3 0.6 l 0.3 1 l 0.8 0.4 l 0.4 -0.5 z m 0.1 10.4 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.2 l 0.9 0.5 l 0.4 -0.6 z m -0.5 -15.1 l 0.3 -0.5 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 h 0 z m 26.8 27.5 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.1 l 0.9 0.5 l 0.4 -0.6 z m 0.4 31.2 l -0.6 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.6 l 1.3 0.8 l 0.6 -0.9 h 0 z m -0.1 -5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.8 z m 0 -5.2 l -0.6 -1.5 l -1.2 -0.7 l -0.5 0.8 l 0.5 1.5 l 1.2 0.7 l 0.6 -0.8 z m -1.9 23.2 l -0.8 1 l 0.8 2 l 1.5 0.8 l 0.7 -1 l -0.7 -2 l -1.5 -0.8 z m 37.4 47 l -0.9 1.3 l 0.9 2.4 l 1.8 1 l 0.9 -1.3 l -0.9 -2.3 l -1.8 -1.1 h 0 z M 323 172.6 l -0.5 -1.4 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.4 l 1.1 0.7 l 0.5 -0.8 z m -0.6 -36.7 l -1 -0.6 v 0.2 l 0.3 0.8 l 0.6 0.4 l 0.3 -0.5 l -0.2 -0.3 h 0 z m 0.9 57.5 l -0.7 -1.8 l -1.4 -0.8 l -0.6 1 l 0.6 1.7 l 1.4 0.8 l 0.7 -0.9 z m -1 -51.5 l 0.3 -0.5 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 z m 0.4 4.7 l -0.4 -1 l -0.8 -0.4 l -0.3 0.5 l 0.3 1 l 0.8 0.4 l 0.4 -0.5 z m -1.5 49.3 l -0.7 1 l 0.7 1.8 l 1.4 0.9 l 0.7 -1 l -0.7 -1.9 l -1.4 -0.8 z m 1.7 -28.5 l -0.5 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.5 -0.7 z m 0 -5.2 l -0.5 -1.3 l -1 -0.5 l -0.4 0.7 l 0.4 1.2 l 1 0.6 l 0.5 -0.7 z m -0.2 -10.4 l -0.4 -1.1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1.1 l 0.8 0.5 l 0.4 -0.6 z m -28.4 32.5 v 0.5 l 0.6 1.5 l 1.4 0.8 l 0.8 -1 l -0.8 -1.8 l -1.4 -0.9 l -0.6 0.9 z m 0 20.1 v 1.6 l 0.5 1.1 l 1.7 1 l 0.8 -1.2 l -0.8 -2.2 l -1.7 -1 l -0.5 0.7 h 0 z m 6.8 1.9 l -0.9 -2.2 l -1.7 -0.9 l -0.8 1.2 l 0.8 2.2 l 1.7 0.9 l 0.9 -1.2 z m -0.2 -10.4 l -0.7 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.7 -1.1 z m 0.2 15.6 l -0.8 -2.3 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1 l 0.8 -1.3 z m 7.8 17.3 l 3.5 2 l -0.8 -2.1 l -1.9 -1.1 l -0.8 1.2 h 0 z m -7.7 -12.1 l -0.9 -2.3 l -1.8 -1.1 l -1 1.3 l 1 2.4 l 1.8 1 l 0.9 -1.3 h 0 z m 2.4 9 l 1.3 0.7 l -0.8 -2 l -1.9 -1.1 l -0.7 0.9 c 0.6 0.6 1.3 1.1 2.1 1.5 h 0 z m -2.3 -3.8 l -1 -2.4 l -1.9 -1.1 l -0.8 1.2 c 0.7 1.3 1.7 2.6 2.8 3.6 l 0.9 -1.3 z m -0.3 -20.8 l -0.8 -2.1 l -1.6 -0.9 l -0.9 1.1 l 0.9 2.1 l 1.6 1 l 0.8 -1.2 h 0 z m -0.5 -36.3 l -0.5 -1.5 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.5 -0.8 z m 0.4 25.9 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m -0.3 -20.7 l -0.6 -1.6 l -1.2 -0.7 l -0.7 0.8 l 0.7 1.6 l 1.2 0.7 l 0.6 -0.8 z m -0.1 -10.4 l -0.6 -1.4 l -1.1 -0.7 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.7 h 0 z m 0.2 15.6 l -0.7 -1.7 l -1.3 -0.8 l -0.6 1 l 0.6 1.6 l 1.3 0.8 l 0.7 -0.9 h 0 z m 0.1 10.3 l -0.7 -1.8 l -1.4 -0.8 l -0.8 1 l 0.8 1.8 l 1.4 0.9 l 0.7 -1.1 h 0 z m -0.1 -5.2 l -0.6 -1.7 l -1.4 -0.8 l -0.7 1 l 0.7 1.7 l 1.4 0.8 l 0.6 -1 z m 60.8 78.8 l 3.5 2 l -0.8 -2 l -1.9 -1.1 l -0.8 1.1 h 0 z m -35.1 -112.8 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.4 -0.5 z m -10 86.8 l 3.5 2 l -0.8 -2 l -1.9 -1.1 l -0.8 1.1 h 0 z m 47.8 24.5 l 0.9 -1.3 l -0.9 -2.3 l -1.9 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.9 1 z m 4.8 5.9 l 3.5 2 l -0.8 -2.1 l -1.9 -1.1 l -0.8 1.2 h 0 z m -74.7 -69.2 v 1.1 l 0.5 1.3 l 1.6 0.9 l 0.8 -1.1 l -0.8 -2 l -1.6 -0.9 l -0.5 0.7 z m 64.3 48.6 l -0.9 1.3 l 0.9 2.3 l 1.8 1 l 0.9 -1.3 l -0.9 -2.3 l -1.8 -1 z m -64.3 -43.6 v 1.4 l 0.5 1.2 l 1.6 1 l 0.9 -1.2 l -0.9 -2.1 l -1.6 -0.9 l -0.5 0.6 z m 2.2 15.6 l -1.5 -0.9 c 0.4 1.5 1 3 1.8 4.3 l 0.7 -1 l -1 -2.4 h 0 z m 34.9 26.9 l 3.5 2 l -0.8 -2.1 l -1.9 -1.1 l -0.8 1.2 h 0 z m -7.5 -4.4 l 3.5 2 l -0.8 -2 l -1.9 -1.1 l -0.8 1.1 h 0 z m -29.6 -48.1 v 0.8 l 0.6 1.4 l 1.5 0.9 l 0.7 -1.1 l -0.7 -1.9 l -1.5 -0.9 l -0.6 0.8 z m 44.7 56.8 l 3.4 2 l -0.7 -2 l -1.9 -1.1 l -0.8 1.1 z m -38.6 -91.7 l -0.5 -1.4 l -1 -0.5 l -0.6 0.7 l 0.6 1.3 l 1 0.6 l 0.5 -0.7 h 0 z m 46.1 96 l 3.5 2.1 l -0.8 -2.1 l -1.9 -1.1 l -0.8 1.1 h 0 z m 7.5 4.4 l 3.5 2 l -0.8 -2.1 l -1.9 -1.1 l -0.8 1.2 h 0 z m 21.5 -57.1 l -0.5 -1.3 l -1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1 0.6 l 0.5 -0.8 z m -0.1 -10.3 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.2 l 0.9 0.5 l 0.4 -0.6 z m 0.1 5.2 l -0.5 -1.3 l -1 -0.5 l -0.4 0.6 l 0.4 1.3 l 1 0.5 l 0.5 -0.6 z m 0.1 10.3 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.8 z m 0.2 15.6 l -0.6 -1.6 l -1.3 -0.8 l -0.7 0.9 l 0.7 1.7 l 1.3 0.8 l 0.6 -1 h 0 z m -0.1 -5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m 0 -5.2 l -0.6 -1.5 l -1.2 -0.6 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.6 -0.9 z m 0.2 15.6 l -0.7 -1.7 l -1.4 -0.8 l -0.7 0.9 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 z m -11 17 l -0.8 -2.1 l -1.7 -0.9 l -0.8 1.2 l 0.8 2.1 l 1.7 0.9 l 0.8 -1.2 z m -0.1 -5.1 l -0.8 -2.1 l -1.5 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.5 0.9 l 0.8 -1.1 z m -0.1 -5.2 l -0.7 -2 l -1.5 -0.8 l -0.8 1 l 0.8 2 l 1.5 0.8 l 0.7 -1 z m 10.6 -53.4 l -0.4 -1 l -0.8 -0.5 l -0.3 0.6 l 0.3 1 l 0.8 0.4 l 0.4 -0.5 z m -0.1 -5.2 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m 0.1 10.4 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.4 l 0.4 -0.5 z m -0.5 -15.2 l 0.3 -0.4 v -0.3 l -1 -0.6 v 0.2 l 0.3 0.8 l 0.4 0.3 h 0 z m 1.5 87.9 l -0.9 -2.3 l -1.8 -1 l -0.9 1.3 l 0.9 2.2 l 1.8 1.1 l 0.9 -1.3 h 0 z m 2.3 -83 l 0.3 -0.4 l -0.3 -0.8 l -0.6 -0.4 l -0.4 0.5 l 0.4 0.8 l 0.6 0.3 h 0 z m 0.4 10 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.4 l 0.4 -0.5 z m 0 -5.2 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.4 -0.5 z m -3.1 52.2 l -0.7 -1.8 l -1.4 -0.9 l -0.7 1.1 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 h 0 z m 0.5 36.4 l -0.9 -2.5 l -1.9 -1.1 l -1 1.4 l 1 2.4 l 1.9 1.1 l 0.9 -1.3 z m 9.2 -90.6 h -0.1 l -0.3 0.4 l 0.3 0.8 h 0.1 v -1.2 z m -6.4 17.6 l -0.5 -1.2 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.6 z m -0.5 -4.6 l 0.4 -0.6 l -0.4 -1.1 l -0.8 -0.5 l -0.5 0.6 l 0.5 1.1 l 0.8 0.5 z m -2.6 51.6 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m -0.1 -5.2 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m 0.1 10.4 l -0.8 -2.1 l -1.6 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.6 1 l 0.8 -1.2 h 0 z m 0.1 5.2 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m -11.5 -24.5 l -0.7 -1.9 l -1.5 -0.8 l -0.7 1 l 0.7 1.9 l 1.5 0.8 l 0.7 -1 z m 10.7 36.2 l 0.9 -1.3 l -0.9 -2.4 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1.1 z m -14.7 -56.7 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.8 z m 0.1 10.3 l -0.6 -1.7 l -1.4 -0.8 l -0.7 1 l 0.7 1.7 l 1.4 0.8 l 0.6 -1 z m -0.6 -46.7 l -0.3 -1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1 l 0.8 0.4 l 0.3 -0.5 z m 0.7 51.9 l -0.7 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.9 l 0.7 -1.1 h 0 z m -0.1 -10.3 l -0.7 -1.7 l -1.3 -0.8 l -0.6 1 l 0.6 1.6 l 1.3 0.8 l 0.7 -0.9 h 0 z m 0.2 15.5 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z m 0.1 10.4 l -0.8 -2.1 l -1.6 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.6 1 l 0.8 -1.2 h 0 z m 0 -5.2 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m -0.7 -51.9 l -0.5 -1.2 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.6 z m -0.1 -5.2 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.5 l 0.4 -0.6 z m 0.9 67.5 l -0.9 -2.2 l -1.7 -0.9 l -0.8 1.2 l 0.8 2.2 l 1.7 0.9 l 0.9 -1.2 z m -0.6 -41.5 l -0.5 -1.5 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.5 -0.8 z m -0.8 -35.9 l 0.4 -0.5 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 z m 0.8 30.7 l -0.6 -1.4 l -1.1 -0.7 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.7 h 0 z m -0.1 -5.2 l -0.5 -1.4 l -1 -0.5 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.5 -0.7 h 0 z m 4.1 30.9 l -0.7 -1.8 l -1.3 -0.8 l -0.7 1 l 0.7 1.7 l 1.3 0.8 l 0.7 -0.9 z m -4.2 -36.1 l -0.4 -1.3 l -1 -0.5 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.4 -0.7 z m 3.9 15.3 l -0.5 -1.4 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.4 l 1.1 0.7 l 0.5 -0.8 z m 0 -5.2 l -0.5 -1.3 l -1.1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1.1 0.6 l 0.5 -0.7 z m -0.1 -5.2 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.2 l 0.9 0.6 l 0.5 -0.7 z m 0.3 26 l -0.6 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.6 l 1.3 0.8 l 0.6 -0.9 h 0 z m -0.4 -31.2 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.1 l 0.9 0.5 l 0.4 -0.6 z m 0.3 20.8 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.1 0.7 l 0.6 -0.8 z m 0.1 5.2 l -0.6 -1.6 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.3 0.7 l 0.6 -0.8 h 0 z m -0.6 -41.6 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m -3.9 -10.4 l -1 -0.6 v 0.2 l 0.3 0.8 l 0.6 0.3 l 0.3 -0.4 l -0.2 -0.3 h 0 z m 2.4 85.2 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.3 l -0.8 -2.1 l -1.7 -1 h 0 z m 0 5 l -0.9 1.3 l 0.9 2.3 l 1.7 1 l 0.9 -1.3 l -0.9 -2.2 l -1.7 -1.1 z m 1.2 -84.5 l 0.3 -0.5 l -0.3 -0.8 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.8 l 0.7 0.4 z m 0.4 9.9 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.4 l 0.4 -0.5 z m 0.1 5.2 l -0.4 -1.1 l -0.9 -0.4 l -0.4 0.5 l 0.4 1.1 l 0.9 0.5 l 0.4 -0.6 z m 12.4 89.4 c 1 0.6 2.1 1 3.2 1.1 l -0.5 -1.1 l -1.9 -1.1 l -0.8 1.1 h 0 z M 320 230.3 l -0.9 -2.4 l -1.9 -1 l -0.9 1.3 l 0.9 2.4 l 1.9 1 l 0.9 -1.3 z m -0.1 -5.2 l -0.9 -2.3 l -1.7 -1 l -0.9 1.3 l 0.9 2.2 l 1.7 1.1 l 0.9 -1.3 z m -4.8 -88 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 l 0.3 -0.5 z m 0.1 10.4 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.4 l 0.4 -0.5 z m -0.5 -15.2 l 0.3 -0.4 v -0.3 l -1 -0.6 h -0.1 l 0.3 0.9 l 0.5 0.4 h 0 z m 5.1 82.4 l -0.8 -2.1 l -1.7 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.7 1 l 0.8 -1.2 h 0 z m -4.6 -72.4 l -0.4 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.4 l 0.4 -0.5 z m 0.1 10.4 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.6 l 0.5 1.2 l 0.9 0.5 l 0.4 -0.6 z m 4.1 30.8 l -0.6 -1.5 l -1.3 -0.7 l -0.6 0.8 l 0.6 1.6 l 1.3 0.7 l 0.6 -0.9 h 0 z m -0.1 -5.1 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.1 0.7 l 0.6 -0.8 z m 0.4 31.1 l -0.8 -2 l -1.5 -0.9 l -0.8 1.1 l 0.8 2 l 1.5 0.9 l 0.8 -1.1 z m -0.2 -20.8 l -0.7 -1.6 l -1.3 -0.8 l -0.6 0.9 l 0.6 1.7 l 1.3 0.8 l 0.7 -1 h 0 z m -19.2 -39.5 l -0.4 -1.3 l -1 -0.5 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.4 -0.7 z m 19.2 44.7 l -0.7 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.7 l 1.3 0.8 l 0.7 -1 z m 0.1 5.2 l -0.7 -1.8 l -1.5 -0.8 l -0.7 1 l 0.7 1.8 l 1.5 0.9 l 0.7 -1.1 h 0 z m -3.8 -10.1 l -0.7 -1.7 l -1.4 -0.8 l -0.7 0.9 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 z m 0.2 20.8 l -0.8 -2.1 l -1.6 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.6 1 l 0.8 -1.2 h 0 z m 0 -5.2 l -0.8 -2 l -1.6 -0.9 l -0.8 1.1 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 z m -0.1 -5.2 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m 0.3 26 l -0.9 -2.4 l -1.8 -1 l -0.9 1.3 l 0.9 2.3 l 1.8 1.1 l 0.9 -1.3 h 0 z m -0.4 -31.2 l -0.7 -1.8 l -1.4 -0.9 l -0.7 1.1 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 h 0 z m 0.4 26 l -0.9 -2.3 l -1.8 -1 l -0.9 1.3 l 0.9 2.2 l 1.8 1.1 l 0.9 -1.3 z m -0.1 -5.2 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m 3.2 -41.8 l -0.6 -1.5 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.6 -0.7 z m -3.8 -5 l -0.5 -1.4 l -1.1 -0.6 l -0.6 0.8 l 0.6 1.4 l 1.1 0.6 l 0.5 -0.8 z m 0.1 5.2 l -0.6 -1.5 l -1.2 -0.6 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.6 -0.9 z m -0.2 -15.6 l -0.5 -1.2 l -1 -0.5 l -0.5 0.6 l 0.5 1.3 l 1 0.5 l 0.5 -0.7 h 0 z m 0 5.2 l -0.5 -1.3 l -1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1 0.6 l 0.5 -0.8 z m 0.3 20.8 l -0.6 -1.6 l -1.3 -0.8 l -0.7 0.9 l 0.7 1.7 l 1.3 0.7 l 0.6 -0.9 h 0 z m -0.1 -5.2 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m 11 -16.7 l -0.5 -1.1 l -0.9 -0.6 l -0.4 0.7 l 0.4 1.1 l 0.9 0.5 l 0.5 -0.6 h 0 z m 0.4 31.2 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m -7.8 -25.1 l -0.5 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.3 l 1.1 0.6 l 0.5 -0.7 h 0 z m 8.1 51.1 l -0.8 -2.1 l -1.6 -1 l -0.9 1.2 l 0.9 2.1 l 1.6 0.9 l 0.8 -1.1 h 0 z m -0.1 -10.4 l -0.8 -2 l -1.5 -0.8 l -0.7 1 l 0.7 2 l 1.5 0.8 l 0.8 -1 z m -0.1 -5.2 l -0.7 -1.9 l -1.4 -0.8 l -0.8 1 l 0.8 1.9 l 1.4 0.8 l 0.7 -1 z m 0.1 10.4 l -0.7 -2.1 l -1.6 -0.9 l -0.8 1.2 l 0.8 2 l 1.6 0.9 l 0.7 -1.1 h 0 z m -0.4 -31.2 l -0.5 -1.5 l -1.2 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.2 0.7 l 0.5 -0.8 z m 0.2 15.6 l -0.6 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.7 l 0.6 -0.9 z m -0.6 -46.8 l -0.3 -1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1 l 0.8 0.5 l 0.3 -0.6 z m -0.4 -9.9 l 0.3 -0.5 l -0.3 -0.8 l -0.6 -0.3 l -0.4 0.4 l 0.4 0.8 l 0.6 0.4 h 0 z m 0.5 15.1 l -0.4 -1.1 l -0.8 -0.4 l -0.5 0.6 l 0.5 1 l 0.8 0.5 l 0.4 -0.6 z m 0.1 10.4 l -0.4 -1.2 l -1 -0.6 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.4 -0.7 z m 0.1 5.2 l -0.5 -1.3 l -1 -0.6 l -0.6 0.7 l 0.6 1.3 l 1 0.6 l 0.5 -0.7 z m -10.4 58.3 l -0.9 -2.5 l -1.9 -1.1 l -1 1.4 l 1 2.4 l 1.9 1.1 l 0.9 -1.3 h 0 z m 10.5 -53.1 l -0.6 -1.4 l -1.1 -0.7 l -0.5 0.8 l 0.5 1.4 l 1.1 0.7 l 0.6 -0.8 z m 0.1 10.4 l -0.6 -1.6 l -1.2 -0.7 l -0.7 0.9 l 0.7 1.6 l 1.2 0.7 l 0.6 -0.9 z m -8.4 -45.4 l 0.4 -0.5 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 z m 0.4 4.7 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.4 l 0.4 -0.5 z m 4.9 87.7 l -0.9 -2.4 l -1.9 -1.1 l -1 1.3 l 1 2.5 l 1.9 1.1 l 0.9 -1.4 h 0 z m -4.7 -77.3 l -0.5 -1.2 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.6 z m 0 5.2 l -0.5 -1.3 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.2 l 0.9 0.5 l 0.5 -0.6 h 0 z m 4.7 66.9 l -1 -2.3 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1 l 1 -1.3 h 0 z m -4.8 -77.3 l -0.4 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.9 0.5 l 0.4 -0.6 z m 3.7 57.7 l 0.8 -1.2 l -0.8 -2 l -1.6 -0.9 l -0.7 1.1 l 0.7 2.1 l 1.6 0.9 h 0 z m 4.8 24.5 l -0.9 -2.3 l -1.8 -1.1 l -1 1.3 l 1 2.4 l 1.8 1 l 0.9 -1.3 h 0 z m -0.1 -5.2 l -0.8 -2.2 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.8 -1.3 z m -3.8 -15.3 l -0.9 -2.1 l -1.6 -0.9 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.9 -1.2 z m 0.1 10.4 l -0.9 -2.2 l -1.8 -1.1 l -0.8 1.3 l 0.8 2.3 l 1.8 1 l 0.9 -1.3 z m -0.1 -5.2 l -0.8 -2.2 l -1.7 -0.9 l -0.9 1.2 l 0.9 2.2 l 1.7 0.9 l 0.8 -1.2 z m 3.8 5 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -7.7 -20 l -0.8 -1.9 l -1.5 -0.9 l -0.7 1.1 l 0.7 1.9 l 1.5 0.9 l 0.8 -1.1 z M 304 143.7 l -0.5 -1.1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1.1 l 0.8 0.5 l 0.5 -0.6 z m -0.1 -5.2 l -0.4 -1 l -0.7 -0.4 l -0.4 0.5 l 0.4 1 l 0.7 0.4 l 0.4 -0.5 z m -0.4 -4.7 l 0.3 -0.5 l -0.3 -0.9 l -0.7 -0.4 l -0.4 0.5 l 0.4 0.9 l 0.7 0.4 z m 0.5 15.1 l -0.4 -1.2 l -0.9 -0.5 l -0.5 0.7 l 0.5 1.1 l 0.9 0.5 l 0.4 -0.6 z m 0.2 15.6 l -0.5 -1.4 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.4 l 1.1 0.7 l 0.5 -0.8 z m 0 -5.2 l -0.6 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.6 -0.7 z m -0.1 -5.2 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.2 l 0.9 0.6 l 0.5 -0.7 z m 4.7 72.1 l -1 -2.4 l -1.9 -1.1 l -0.9 1.4 l 0.9 2.4 l 1.9 1.1 l 1 -1.4 z m -0.3 -25.9 l -0.8 -2 l -1.6 -1 l -0.8 1.2 l 0.8 2 l 1.6 0.9 l 0.8 -1.1 h 0 z m 0 5.2 l -0.8 -2.1 l -1.6 -1 l -0.8 1.2 l 0.8 2.1 l 1.6 0.9 l 0.8 -1.1 h 0 z m -0.1 -10.4 l -0.8 -2 l -1.5 -0.8 l -0.7 1 l 0.7 2 l 1.5 0.8 l 0.8 -1 z m 0.3 26 l -0.9 -2.4 l -1.8 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.8 1.1 l 0.9 -1.3 z m -0.1 -10.4 l -0.9 -2.2 l -1.7 -1 l -0.8 1.2 l 0.8 2.2 l 1.7 1 l 0.9 -1.2 z m -0.3 -20.8 l -0.7 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.9 l 1.4 0.8 l 0.7 -1 z m 0.4 26 l -0.9 -2.3 l -1.8 -1 l -0.9 1.2 l 0.9 2.3 l 1.8 1 l 0.9 -1.2 z m -4.4 -46.2 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.8 l 0.6 1.5 l 1.1 0.7 l 0.6 -0.8 z m -4.2 -36.1 l -0.3 -1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1 l 0.8 0.4 l 0.3 -0.5 z m 4.9 88 l -0.9 -2.3 l -1.9 -1.1 l -0.9 1.3 l 0.9 2.4 l 1.9 1 l 0.9 -1.3 h 0 z m -0.1 -5.2 l -0.9 -2.2 l -1.7 -1.1 l -0.9 1.3 l 0.9 2.3 l 1.7 1 l 0.9 -1.3 z m -5.2 -87.5 l 0.4 -0.5 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 h 0 z m 0.6 15.1 l -0.5 -1.2 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.5 -0.6 z m 4.5 67.2 l -0.8 -2.1 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 0.9 l 0.8 -1.2 h 0 z m -4.6 -72.4 l -0.4 -1.1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1.1 l 0.8 0.5 l 0.4 -0.6 z m 4.5 62 l -0.8 -2 l -1.5 -0.9 l -0.8 1.1 l 0.8 2.1 l 1.5 0.9 l 0.8 -1.2 h 0 z m 0.1 5.2 l -0.8 -2.1 l -1.7 -0.9 l -0.8 1.2 l 0.8 2.1 l 1.7 0.9 l 0.8 -1.2 z m -0.2 -15.5 l -0.8 -1.9 l -1.4 -0.8 l -0.7 1 l 0.7 1.9 l 1.4 0.8 l 0.8 -1 z m -0.2 -10.4 l -0.6 -1.7 l -1.3 -0.8 l -0.7 1 l 0.7 1.6 l 1.3 0.8 l 0.6 -0.9 h 0 z m 0.1 5.2 l -0.7 -1.8 l -1.3 -0.8 l -0.7 1 l 0.7 1.7 l 1.3 0.8 l 0.7 -0.9 z m -0.1 -10.4 l -0.7 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.2 0.7 l 0.7 -0.8 h 0 z m 0.2 20.8 l -0.7 -2 l -1.5 -0.8 l -0.8 1 l 0.8 2 l 1.5 0.8 l 0.7 -1 z m 6.7 -58.1 l -0.3 -0.8 l -0.7 -0.4 l -0.3 0.4 l 0.3 0.9 l 0.7 0.4 l 0.3 -0.5 h 0 z m 0.6 46.8 l -0.6 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.6 -0.9 z m 0.1 5.2 l -0.7 -1.8 l -1.3 -0.7 l -0.7 0.9 l 0.7 1.8 l 1.3 0.8 l 0.7 -1 z m -0.2 -15.6 l -0.6 -1.5 l -1.1 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.1 0.6 l 0.6 -0.8 z m 0.5 36.4 l -0.8 -2.1 l -1.7 -1 l -0.8 1.2 l 0.8 2.1 l 1.7 0.9 l 0.8 -1.1 h 0 z m -0.1 -5.2 l -0.8 -2 l -1.5 -0.9 l -0.8 1.1 l 0.8 2 l 1.5 0.9 l 0.8 -1.1 z m -0.1 -10.4 l -0.7 -1.8 l -1.5 -0.9 l -0.7 1 l 0.7 1.9 l 1.5 0.8 l 0.7 -1 z m 0 5.2 l -0.7 -1.9 l -1.5 -0.9 l -0.8 1.1 l 0.8 1.9 l 1.5 0.9 l 0.7 -1.1 z m -0.2 -20.8 l -0.6 -1.6 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.3 0.7 l 0.6 -0.9 z m -0.4 -31.2 l -0.4 -1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1 l 0.9 0.5 l 0.4 -0.6 z m -0.1 -5.2 l -0.4 -0.9 l -0.7 -0.5 l -0.4 0.6 l 0.4 0.9 l 0.7 0.5 l 0.4 -0.6 z m 0.3 26 l -0.5 -1.4 l -1.1 -0.6 l -0.5 0.8 l 0.5 1.4 l 1.1 0.6 l 0.5 -0.8 z m -0.7 -35.9 l 0.3 -0.4 l -0.3 -0.9 l -0.7 -0.3 l -0.3 0.4 l 0.3 0.8 l 0.7 0.4 z m 0.7 30.7 l -0.5 -1.3 l -1.1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1.1 0.6 l 0.5 -0.8 h 0 z m -0.1 -5.2 l -0.5 -1.2 l -0.9 -0.6 l -0.5 0.7 l 0.5 1.3 l 0.9 0.5 l 0.5 -0.7 z m -0.1 -5.2 l -0.4 -1.1 l -0.9 -0.5 l -0.4 0.6 l 0.4 1.2 l 0.9 0.5 l 0.4 -0.7 z m -3.4 15.9 l -0.6 -1.5 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.5 l 1.2 0.6 l 0.6 -0.8 z m -0.2 -10.4 l -0.5 -1.3 l -1 -0.6 l -0.5 0.7 l 0.5 1.3 l 1 0.6 l 0.5 -0.7 z m 0 -5.2 l -0.5 -1.2 l -1 -0.6 l -0.5 0.7 l 0.5 1.2 l 1 0.6 l 0.5 -0.7 z m 4.4 62.1 l -0.8 -2.2 l -1.7 -1 l -0.9 1.2 l 0.9 2.2 l 1.7 1 l 0.8 -1.2 z m -4.1 -36.1 l -0.7 -1.7 l -1.3 -0.7 l -0.6 0.9 l 0.6 1.7 l 1.3 0.7 l 0.7 -0.9 z m -0.4 -31.2 l -0.5 -1.1 l -0.9 -0.6 l -0.4 0.7 l 0.4 1.1 l 0.9 0.6 l 0.5 -0.7 z m 0.3 26 l -0.6 -1.6 l -1.2 -0.7 l -0.6 0.9 l 0.6 1.6 l 1.2 0.7 l 0.6 -0.9 z m 0.2 10.4 l -0.7 -1.8 l -1.4 -0.8 l -0.7 1 l 0.7 1.8 l 1.4 0.8 l 0.7 -1 z m -0.3 -20.8 l -0.6 -1.4 l -1.1 -0.6 l -0.5 0.7 l 0.5 1.4 l 1.1 0.7 l 0.6 -0.8 h 0 z m -0.3 -20.8 l -0.4 -1 l -0.8 -0.5 l -0.4 0.6 l 0.4 1 l 0.8 0.5 l 0.4 -0.6 z m 4.7 77.7 l -0.9 -2.3 l -1.7 -1 l -0.9 1.2 l 0.9 2.3 l 1.7 1 l 0.9 -1.2 z m -4.8 -88.1 l -0.4 -0.9 l -0.7 -0.4 l -0.3 0.5 l 0.3 0.9 l 0.7 0.4 l 0.4 -0.5 z m 4.9 93.3 l -0.9 -2.4 l -1.9 -1.1 l -0.9 1.4 l 0.9 2.3 l 1.9 1.1 l 0.9 -1.3 z m -5.3 -98 l 0.3 -0.5 v -0.2 l -1 -0.6 h -0.1 l 0.3 0.8 l 0.5 0.5 h 0 z m 0.5 9.9 l -0.4 -1 l -0.8 -0.4 l -0.4 0.5 l 0.4 1 l 0.8 0.5 l 0.4 -0.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 420.44 159.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-344.6, -137.15)",
    d: "M 293.6 3.9 h 0 z M 390.2 265 V 70.8 c 0 -8.9 -6.2 -19.7 -13.9 -24.1 l -72.7 -42 c -3.8 -2.2 -7.3 -2.4 -9.8 -1 c 0.9 -0.5 6.6 -3.5 7.5 -3.7 c 2.7 0 5.3 0.6 7.7 1.8 l 72.7 42 c 7.7 4.4 13.9 15.2 13.9 24.1 v 194.2 c 0 4.1 -1.3 7 -3.5 8.6 c -2 1.4 -4.2 2.7 -6.5 3.6 h -0.1 c 2.9 -1.3 4.7 -4.5 4.7 -9.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 297.88 199.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.59, -171.7)",
    d: "M 242.3 180.8 l 1.1 -0.9 l 0.4 -0.2 l 1.1 -0.3 c 0.7 -0.4 1.1 -1.1 1.1 -1.9 l -1 -14.3 c 0 -0.8 -0.6 -1.1 -1.4 -0.7 c -0.8 0.5 -1.3 1.4 -1.4 2.3 l -1 15.5 c -0.1 0.8 0.5 1 1.1 0.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 297.89 199.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.6, -171.7)",
    d: "M 241.7 180.8 l 0.4 -0.2 l 1.1 -0.9 l 0.5 -0.3 l 1.1 -0.3 c 0.6 -0.3 0.9 -0.9 0.9 -1.6 l -1 -14.3 c 0 -0.2 -0.1 -0.6 -0.4 -0.6 l -0.5 0.2 c -0.7 0.5 -1.2 1.2 -1.3 2.1 l -1 15.4 c 0 0.2 0 0.4 0.1 0.4 l 0.1 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 288.18 195.26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-235.7, -167.5)",
    d: "M 226.7 172 l 1 -15.5 c 0.1 -1 0.7 -1.8 1.5 -2.3 c 0.3 -0.2 0.7 -0.3 1 -0.1 l 14.5 8.3 c -0.4 -0.1 -0.8 -0.1 -1.1 0.1 c -0.8 0.5 -1.3 1.4 -1.4 2.3 l -1 15.5 c -0.1 0.3 0 0.5 0.2 0.7 l -14.4 -8.3 c -0.2 -0.2 -0.3 -0.4 -0.3 -0.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 297.95 191.95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,125,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.65, -164.55)",
    d: "M 244.9 165.1 l -2.5 1.4 v -1.6 c 0.1 -0.8 0.5 -1.6 1.2 -2.1 l 0.6 -0.2 c 0.3 0 0.4 0.4 0.4 0.6 l 0.3 1.9 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 297.4 192.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,110,49)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.2, -164.9)",
    d: "M 242.5 164.9 c 0 -0.6 0.2 -1.1 0.6 -1.6 h 0.1 c 0.4 0 0.6 0.3 0.6 0.8 l 0.2 1.5 l -1.6 0.9 l 0.1 -1.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 293.76 186.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-240.25, -160.1)",
    d: "M 241 160.6 l -1.6 -0.9 c -0.1 0 -0.1 -0.1 -0.1 -0.2 h 0.1 l 1.6 0.9 l 0.2 0.3 l -0.2 -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 292.97 187.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-239.6, -160.4)",
    d: "M 239.3 159.4 l 1.8 1.3 l -1.2 0.7 l -1.8 -1.3 l 1.2 -0.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 292.16 187.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,110,49)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.95, -160.8)",
    d: "M 239.8 161.4 l -1.6 -1 l -0.2 -0.2 h 0.2 l 1.6 1 c 0.1 0 0.1 0.1 0.1 0.2 h -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 286.25 182.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-234.14, -156.52)",
    d: "M 235 157.1 l -1.6 -0.9 l -0.2 -0.3 h 0.2 l 1.6 0.9 v 0.2 c 0.1 0.1 0.1 0.2 0 0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 285.52 183.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-233.55, -156.85)",
    d: "M 233.3 155.9 l 1.8 1.2 l -1.2 0.7 l -1.9 -1.2 l 1.3 -0.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 284.85 183.71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,110,49)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-233, -157.18)",
    d: "M 233.8 157.8 l -1.7 -0.9 v -0.2 c 0 -0.1 0.1 -0.2 0.1 -0.1 l 1.7 0.9 v 0.3 h -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 280.87 146.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.77, -124.4)",
    d: "M 231.8 136.8 l 0.9 -0.2 c 1 -0.4 1.6 -1.4 1.4 -2.5 v -0.8 l -2.5 -17.9 v -0.7 c -0.1 -0.3 -0.1 -0.5 -0.2 -0.8 c -0.6 -1.1 -1.7 -1.8 -2.9 -1.9 l -1.2 0.2 c -1.4 0.6 -2.2 2.1 -1.8 3.6 v 0.9 l 3.9 17.4 l 0.2 0.9 c 0 0.2 0 0.3 0.1 0.3 a 2.16 2.16 0 0 0 2.1 1.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 286.18 167.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-234.09, -142.56)",
    d: "M 237.1 152.6 c 0.4 0.1 0.8 -0.1 1 -0.4 c 0.3 -0.4 0.4 -1 0.2 -1.5 c -0.3 -1.4 -3.3 -12.9 -3.9 -15.2 v -1.1 c -0.2 -1.1 -1.1 -1.9 -2.2 -1.9 h -0.5 c -1.2 0.2 -2.1 1.3 -1.9 2.5 v 0.7 c 0.6 3.8 2.6 9.2 6.2 15.8 l 0.2 0.4 c 0.1 0.4 0.5 0.7 0.9 0.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 279.81 140.95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-228.91, -119.01)",
    d: "M 226.6 125.7 c -0.6 -1.7 -1.1 -6.6 -1.8 -9.8 c -0.4 -1.7 0.5 -3.5 2.2 -4.1 c 1.7 -0.7 3.7 0 4.5 1.7 h 0 c 0 0.1 0.1 0.2 0.1 0.3 c 0.1 0.3 0.2 0.5 0.2 0.8 c 0.6 3.7 0.5 6.5 1.3 10.3 c 0.2 1.3 -5.9 2.4 -6.5 0.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 290.3 179.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-237.43, -153.01)",
    d: "M 236.1 148.5 c 0.6 -0.2 1.3 0 1.6 0.5 v 0.3 l 1.1 2.7 l 1.1 3.4 c 0.1 0.1 0.1 0.2 0 0.3 h 0 l -0.4 1.9 l -2.8 -1 l -0.5 -1.1 l -0.5 -1.6 c -0.1 -0.1 -0.1 -0.3 -0.1 -0.5 v -1.7 l -0.6 -1.5 c -0.3 -0.7 0 -1.4 0.7 -1.7 h 0.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 289.93 184.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,177,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-237.13, -157.8)",
    d: "M 239.5 160.2 c 0.3 0 0.5 -0.2 0.5 -0.4 v -0.1 c 0 -0.1 -0.1 -3.2 -2.5 -4.1 c -1 -0.4 -2.1 -0.2 -3 0.4 c -0.2 0.1 -0.3 0.3 -0.2 0.5 c 0 0.1 0.1 0.1 0.1 0.2 c 0.1 0.3 0.4 0.3 0.7 0.1 c 0.6 -0.4 1.4 -0.5 2.1 -0.3 c 1.7 0.7 1.8 3.2 1.8 3.3 c 0.1 0.2 0.3 0.4 0.5 0.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 291.04 184.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.03, -157.72)",
    d: "M 238.1 158.4 l -0.8 -1.2 c -0.1 -0.2 0 -0.4 0.2 -0.4 h 0.3 l 0.6 0.8 l 0.4 1 h -0.2 c -0.2 0.1 -0.4 0 -0.5 -0.2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 289.9 183.61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-237.1, -157.1)",
    d: "M 237.8 157.9 v -0.8 l -0.3 -0.3 l -0.3 -0.8 c 0 -0.2 -0.1 -0.3 -0.2 -0.3 l -0.4 0.2 l -0.2 1.3 l 0.6 1.3 l 0.8 -0.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 288.84 183.17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-236.25, -156.7)",
    d: "M 236.4 156.8 v -1.2 c 0 -0.1 -0.1 -0.3 -0.2 -0.3 c -0.2 0 -0.3 0.1 -0.3 0.3 h 0 h 0 l -0.3 1.2 l 0.4 0.8 c 0.1 0.3 0.4 0.5 0.7 0.5 h 0.2 l -0.5 -1.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 288.11 183.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-235.65, -156.8)",
    d: "M 236.1 157.7 l -0.8 -0.4 c -0.1 0 -0.1 -0.1 -0.1 -0.3 v -0.9 l 0.2 -0.2 l 0.2 0.2 v 0.8 l 0.5 0.8 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 290.85 181.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-237.88, -155.55)",
    d: "M 236.9 151.9 a 3.75 3.75 0 0 0 0 2.1 l 0.6 2.1 v 1.1 l -0.5 0.7 c -0.1 0.3 -0.1 0.6 -0.1 0.9 c -0.1 0.1 0 0.3 0.2 0.4 c 0.2 0 0.3 -0.1 0.4 -0.2 c 0.2 -0.3 0.5 -0.6 0.8 -0.8 c 0.1 -0.1 0.1 -0.3 0.2 -0.6 l 0.5 -4.7 l -2.1 -1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 265.66 254.06)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    cx: 0,
    cy: 0,
    rx: 26.9,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 264.47 251.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(39,35,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-216.43, -217.75)",
    d: "M 211.4 222.5 l 2.6 -0.4 s -1.6 -4.9 -2.6 -4.9 s 0 5.3 0 5.3 h 0 h 0 z m 8.1 -3.5 l 2.4 -0.5 s -1.6 -5.6 -2.4 -5.5 s 0 6 0 6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 272.53 250.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.98, -217.2)",
    d: "M 227.3 219.2 l -0.6 3.5 c -0.3 1 -6 1.3 -6.3 -1.1 l -0.9 -7.2 v 4.7 l -0.8 -0.6 v -4.2 c -0.1 -1.1 0 -2.2 0.3 -3.2 c 0.5 -1.1 5.1 4.9 5.1 4.9 l 3.2 3.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 264.49 254.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-216.45, -220.05)",
    d: "M 222.9 222.3 l -0.5 3.4 c 0 0.3 -8.3 1 -8.6 -0.9 s -1.4 -5.3 -2.4 -6.3 v 3.9 c 0 0.5 -1.4 -0.7 -1.4 -0.7 v -7.6 c 0.2 -1 12.9 8.2 12.9 8.2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 267.09 247.79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.56, -214.4)",
    d: "M 225.6 205.3 v 7.5 c 0.2 1.8 2.1 5.3 1.6 6.7 s -4.5 1.6 -5.8 -0.5 c -0.6 -1.4 -1.1 -3 -1.4 -4.5 c -0.6 -1 -0.9 -2.2 -0.9 -3.4 c 0.1 -1.5 0.9 -3.6 0.9 -5.8 h 5.6 h 0 z m -14.7 2.8 l -0.2 3.7 c -0.7 1 -1 2.2 -0.8 3.4 l 4 6.1 c 1.4 1.4 3.3 2.2 5.3 2.2 c 2.2 0 3.4 -0.4 3.6 -1 c 0.2 -0.8 -0.1 -1.6 -0.8 -2.1 c -1.8 -1.4 -3.2 -3.3 -3.8 -5.5 s -1.1 -4.5 -1.3 -6.8 h -6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 266.71 239.18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,77,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.25, -206.72)",
    d: "M 210.9 208.1 l 0.2 0.2 c 0.9 0.5 1.8 0.6 2.8 0.5 c 1 0.1 1.9 -0.1 2.8 -0.4 l 0.2 -0.3 c 0 -0.1 0 -0.2 -0.1 -0.2 c -0.9 -0.4 -1.9 -0.5 -2.9 -0.5 c -0.9 0 -1.8 0.2 -2.7 0.4 l -0.3 0.3 z m 9.1 -2.8 h 0 c 0.3 0.4 1.4 0.6 2.8 0.6 c 1 0.1 2 -0.1 2.8 -0.6 h 0 c -0.1 -0.4 -1.3 -0.7 -2.8 -0.7 c -0.9 0 -1.9 0.1 -2.7 0.5 c -0.1 0 -0.1 0.1 -0.1 0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 264.5 226.97)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_840",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 279.573,
    y1: 344.314,
    x2: 268.869,
    y2: 344.314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_840)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-274.25, -344.31)",
    d: "M 268.9 356.8 c 0.9 0.5 1.8 0.6 2.8 0.5 c 1 0.1 1.9 -0.1 2.8 -0.4 c -0.1 -0.1 0 -0.3 0.1 -0.5 l 4.9 -21 h 0.1 c 0.1 -2.1 -1.6 -3.9 -3.7 -4.1 h 0 c -1.8 -0.1 -3.4 1 -3.9 2.7 h 0 l -3 22.3 c -0.1 0.2 -0.1 0.3 -0.1 0.5 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 275.14 223.42)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_841",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 288.072,
    y1: 341.142,
    x2: 277.832,
    y2: 341.142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_841)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-282.91, -341.14)",
    d: "M 277.8 353.9 c 0.3 0.4 1.4 0.6 2.8 0.6 c 1 0.1 2 -0.1 2.8 -0.6 h 0 l 4.6 -21.5 v -0.2 c 0.2 -2.1 -1.1 -4 -3.2 -4.4 c -2.1 -0.3 -4 1.1 -4.4 3.1 h 0 v 0.2 l -2.6 22.6 v 0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 277.04 191.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(239,194,204)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-226.65, -164.03)",
    d: "M 219.9 147.2 c 0.5 -3.7 3.8 -6.3 7.5 -5.9 c 3.1 0.4 5.6 2.8 6 5.9 v 0.6 l -2.9 35.5 c -0.1 2 -1.8 3.6 -3.8 3.5 c -2 0.1 -3.7 -1.5 -3.9 -3.5 l -2.8 -35.5 c -0.1 -0.1 -0.1 -0.4 -0.1 -0.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 266.34 194.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-217.95, -166.75)",
    d: "M 211.2 150.4 c -0.1 -3.7 2.9 -6.7 6.6 -6.8 h 0.2 a 6.7 6.7 0 0 1 6.7 6.7 h 0 v 0.5 l -2.9 35.5 c -0.1 2 -1.8 3.6 -3.8 3.6 c -2 0.1 -3.7 -1.5 -3.8 -3.5 l -2.9 -35.5 c 0 -0.2 -0.1 -0.3 -0.1 -0.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 271.16 191.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-221.87, -163.9)",
    d: "M 232.4 140.7 c 1.6 3.4 2.9 8.3 2.1 17.6 c -0.6 6.4 -2.6 14.6 -2.2 25.3 c 0.3 6.9 -23.7 7.3 -23.3 3.4 s 2.2 -13.1 2.4 -18.9 c 0.4 -10.7 -2.8 -20.6 2.2 -25.7 s 17.2 -5.1 18.8 -1.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 271.43 153.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.09, -130.59)",
    d: "M 234.3 144.6 c -0.3 -2.1 -1.9 -5 -3.1 -7.3 s -1 -5.2 0 -6.6 s 2.3 -3 1.3 -5.3 a 45.78 45.78 0 0 1 -1.8 -7.3 c -0.2 -1 0.1 -6.4 -2.3 -6.5 s -4.9 1.2 -8.2 2.6 s -9.4 4.4 -10.2 7.4 s 2.5 11.1 3.2 14.4 s -2.2 8.9 -2.2 12.2 s 23.7 0.1 23.3 -3.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 271.73 162.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.33, -138.62)",
    d: "M 228.6 148.2 l -2.1 0.5 l -1 0.3 l -1.5 0.3 h -0.1 l -1.4 0.3 h -0.1 l -1.4 0.3 h -1.5 l -1.6 0.2 H 211 v -0.9 c 0 -0.1 0 -0.2 0.1 -0.3 v -0.6 c 0.1 -0.1 0.1 -0.2 0.1 -0.3 c 0 -0.2 0.1 -0.4 0.1 -0.6 v -0.2 c 0.1 -0.3 0.2 -0.6 0.2 -0.9 l 0.3 -1 c 0.1 -0.2 0.1 -0.5 0.2 -0.8 s 0.1 -0.3 0.2 -0.4 s 0.1 -0.5 0.1 -0.7 c 0.1 -0.1 0.1 -0.2 0.1 -0.3 l 0.3 -1 l 0.3 -1.6 c 0 -0.3 0.1 -0.5 0.1 -0.8 s 0.1 -0.5 0.1 -0.7 s -0.1 -0.9 -0.1 -1.3 s -2.5 -8.9 -3 -10.4 s 3.7 8 9.4 6.7 c 3.4 -0.8 3.2 -2.6 5.9 -3.4 s 2.8 0.6 5.3 0 c 1 -0.2 1.8 -1 2.1 -1.9 v 0.5 h -0.1 c 0 0.3 -0.1 0.6 -0.2 0.9 h 0 l -0.5 0.9 h 0 l -0.6 0.7 l -0.2 0.3 h -0.1 l -0.2 0.3 h 0 v 1.2 c -0.1 0 -0.1 0.1 -0.1 0.2 v 0.5 h -0.1 v 0.5 c 0 0.3 0 0.7 0.1 1 h 0 v 0.4 c 0 0.1 0.1 0.1 0.1 0.2 s 0 0.3 0.1 0.4 h 0 c 0.1 0.3 0.1 0.6 0.2 0.8 l 0.3 0.7 l 0.5 0.9 c 0.1 0.3 0.3 0.7 0.5 0.9 l 0.4 1 l 0.5 0.9 l 0.3 0.7 h 0 l 0.3 0.6 l 0.2 0.6 h 0 c 0.1 0.1 0.1 0.2 0.1 0.4 h 0.1 c 0 0.2 0 0.3 0.1 0.4 h 0 c 0 0.2 0.1 0.3 0.1 0.5 v 0.2 h 0 l -0.3 0.4 h 0 l -0.2 0.2 l -0.7 0.6 h -0.2 l -0.6 0.4 l -1.1 0.5 l -1.7 0.7 l -1.2 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 270.09 138.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-221, -117.1)",
    d: "M 214.9 118.8 c 0.4 1.5 3.5 2 6.9 1.1 s 5.7 -3 5.3 -4.5 s -3.5 -2 -6.9 -1.1 s -5.7 3 -5.3 4.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 262.36 147.78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-214.71, -125.1)",
    d: "M 220.4 106.3 c 1.6 0 2.8 1.2 3 2.8 l 0.2 7.6 c 0.3 1.6 -0.7 3.2 -2.3 3.5 s -3.1 -0.7 -3.4 -2.3 c -0.1 -0.4 -0.1 -0.7 0 -1.1 l -0.2 -7.5 c -0.1 -1.5 1.1 -2.8 2.7 -3 h 0 z m -11.9 37.6 c 0.8 -0.2 1.5 -0.8 1.8 -1.6 v -0.8 l 5.5 -17.2 l 0.3 -0.8 c 0 -0.2 0.1 -0.4 0.1 -0.7 c 0 -0.8 -0.2 -1.6 -0.7 -2.2 c -0.6 -0.6 -1.3 -1 -2.1 -1.1 h -0.8 c -1.2 0.3 -2.2 1.2 -2.5 2.4 v 1 l -4.1 17.4 l -0.2 0.7 v 0.4 c -0.1 0.6 0.1 1.2 0.5 1.7 s 1 0.8 1.6 0.8 h 0.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 264.22 165.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-216.23, -140.91)",
    d: "M 226.5 138.9 c -0.3 -0.5 -0.9 -0.7 -1.5 -0.7 l -15.7 0.8 h -1.1 c -0.6 0 -1.2 0.3 -1.7 0.7 s -0.7 1 -0.7 1.6 c 0 0.4 0.1 0.8 0.3 1.1 c 0.3 0.7 1 1.2 1.8 1.2 h 0.7 c 3.9 0.2 9.5 -0.8 16.8 -2.9 h 0.3 c 0.4 0 0.7 -0.3 0.8 -0.7 c 0.2 -0.3 0.2 -0.8 0 -1.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 259.52 148.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-212.4, -125.9)",
    d: "M 216.7 123.7 l -2.7 8.5 c -0.7 1.7 -6.5 -0.5 -6.1 -2.1 l 1.9 -8.3 c 0.4 -1.9 2.4 -3.2 4.3 -2.7 c 1.8 0.4 3 2 2.8 3.8 c -0.1 0.3 -0.1 0.6 -0.2 0.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 282.42 159.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-231.02, -135.85)",
    d: "M 226.5 138.9 l 4.5 -5.1 a 0.55 0.55 0 0 1 0.5 -0.3 l 3.9 -0.7 c 0.1 0 0.2 0.1 0.1 0.2 l -4.4 5.2 l -4.6 0.7 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 277.43 162.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-226.96, -138.26)",
    d: "M 220.8 138.4 l 2.8 -0.3 l 2.5 -2.1 c 0.3 -0.3 0.7 -0.5 1.1 -0.6 l 1.7 -0.5 l 1.4 -0.3 l -0.7 0.8 l -0.4 0.4 l -1.4 0.7 l 1.6 -0.3 l 3 -1 l 0.4 0.2 c 0.1 0.1 0 0.3 -0.1 0.4 l -2.3 1.4 l 3.1 -1.7 h 0.3 c 0.2 0.2 0.2 0.4 0 0.5 l -1.3 1.1 c 0 0.1 0 0.2 -0.1 0.3 l -3.6 3 l -4.2 0.7 l -2.9 0.8 c -1.7 0.3 -2.4 -3.1 -0.9 -3.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 269.66 132.32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-220.65, -111.3)",
    d: "M 220.4 106.3 c 1.6 0 2.8 1.2 3 2.8 l 0.2 6.8 c -0.6 0.3 -1.3 0.4 -2 0.4 c -1.4 0 -2.7 -0.4 -3.7 -1.3 l -0.2 -5.7 c -0.1 -1.5 1.1 -2.8 2.7 -3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 279.07 127.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,100,149)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-228.3, -107.3)",
    d: "M 229.7 104.5 s 0 4.1 -0.9 5 c -0.4 0.6 -1.3 0.8 -1.9 0.4 l 1.4 -5.2 c 0 0 1.4 -0.2 1.4 -0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 267.97 116.36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-219.28, -97.05)",
    d: "M 218.9 99.1 c 1.8 0 3 -0.8 3.1 -1.9 a 2.22 2.22 0 0 0 -2.2 -2.2 h -0.4 c -1.7 0.1 -3.1 1.5 -2.8 2.6 s 2.3 1.5 2.3 1.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 265.82 119.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-217.53, -99.41)",
    d: "M 218.4 102 c 1.3 -0.3 2.2 -1.5 2.1 -2.8 c 0 -0.2 -0.1 -0.3 -0.1 -0.5 c -0.5 -1.4 -2 -2.2 -3.5 -1.9 l -0.4 0.2 c -1.5 0.5 -2.3 2 -1.8 3.5 v 0.1 h 0.1 c 0.4 1.3 1.9 1.8 3.6 1.3 v 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 269.63 118.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(53,35,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-220.62, -99.39)",
    d: "M 223.4 100.6 a 2.47 2.47 0 0 0 0.5 -2.2 c -0.3 -1.2 -1.5 -1.9 -2.7 -1.6 h 0 c -1.1 0.3 -3.6 1.9 -3.9 3.4 s 1.2 2 2.5 1.8 c 1.3 -0.3 2.5 -0.8 3.6 -1.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 271.58 128.95)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_842",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 228.563,
    y1: 108.298,
    x2: 215.703,
    y2: 108.298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_842)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.21, -108.3)",
    d: "M 224.9 116.7 h 1.1 c 0.1 -0.1 0.9 -1.7 1.3 -2.3 c 0.7 -0.8 1.1 -1.8 1.2 -2.9 c 0.1 -1.4 -0.3 -2.6 -0.2 -3.4 c 1.1 -3.2 -0.6 -6.7 -3.8 -7.9 c -1.1 -0.3 -2.3 -0.4 -3.4 -0.2 c -2.9 0.3 -5.1 2.7 -5.3 5.6 c -0.1 2.5 0.7 5 2.4 6.9 c 1.3 1.5 2.8 2.8 4.5 3.7 c 0.7 0.3 1.4 0.5 2.2 0.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 274.91 124.24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-224.92, -104.1)",
    d: "M 219.3 100 c -0.5 0.9 1 4.7 3.2 5.2 s 4.1 -0.7 5.7 1.4 c 0.6 0.8 0.8 1.9 0.6 2.9 c 0 0 2.1 -2.5 1.8 -4.4 c -0.4 -1.7 -1.6 -3.2 -3.3 -3.8 c 0 -1 -0.7 -1.9 -1.6 -2.3 c -2.2 -0.8 -5.9 0.1 -6.4 1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 268.74 127.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-219.91, -106.99)",
    d: "M 222.2 99.5 c -1.4 0.1 -2.8 0.4 -4.2 0.7 c -1.7 0.5 -3 1.8 -3.4 3.5 c -0.5 1.9 1.7 4.2 1.5 8.1 s 1.7 2.4 1.7 2.4 c 0.1 -1.3 0.4 -2.5 1 -3.7 c 0.9 -2.1 3.7 -1.3 5.9 -5.4 s -2.5 -5.6 -2.5 -5.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 267.63 131.86)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-218.99, -110.89)",
    d: "M 219.7 109.7 c -1.1 -0.7 -2.3 -0.7 -2.7 -0.1 s 0.1 1.8 1.2 2.5 s 2.4 0.7 2.8 0 s -0.2 -1.7 -1.3 -2.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 198.61 309.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-162.89, -269.16)",
    d: "M 172.8 266.9 l -0.3 -0.2 c -0.1 0 -0.1 -0.1 0 -0.2 l 1 -0.6 h 0.6 v 0.2 l -1 0.6 l -0.3 0.2 z m -1.3 1 l 1 -0.7 c 0.1 -0.1 0.1 -0.1 0 -0.2 h -0.6 l -1 0.6 c -0.1 0.1 -0.1 0.2 0 0.2 l 0.3 0.2 l 0.3 -0.1 z m -1.5 1 l 1 -0.7 v -0.2 h -0.4 c 0 -0.1 -0.2 -0.1 -0.2 0 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 l 0.3 -0.1 h 0 z m -1.6 1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -0.3 -0.2 h -0.3 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 h 0.3 z m -1.6 1 l 1.1 -0.7 h 0 l -0.4 -0.2 h -0.2 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 l 0.2 -0.1 h 0 z m -1.5 1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -0.3 -0.2 h -0.3 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 h 0.3 z m -1.6 1 l 1.1 -0.7 h 0 l -0.4 -0.2 h -0.2 l -1.1 0.7 h 0.1 l 0.3 0.2 h 0.2 h 0 z m -1.5 1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -0.3 -0.2 h -0.3 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 h 0.3 z m -1.6 1 l 1.1 -0.7 h -0.1 l -0.3 -0.2 h -0.2 l -1.1 0.7 h 0 l 0.4 0.2 h 0.2 h 0 z m -1.5 1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -0.3 -0.2 h -0.3 l -1 0.7 c -0.1 0 -0.1 0.1 0 0.1 l 0.3 0.2 h 0.3 z m -1.6 1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -0.3 -0.2 h -0.3 l -1 0.7 h 0 l 0.4 0.2 c 0 0.2 0.2 0.1 0.2 0.1 h 0 h 0 z m 17.1 -11.1 l 1 -0.6 c 0.1 -0.1 0.1 -0.1 0 -0.2 h -0.6 l -1 0.6 c -0.1 0.1 -0.1 0.1 0 0.2 l 0.4 0.2 l 0.2 -0.2 h 0 z m -7 3.7 l 1 -0.6 h 0 l -1.1 -0.5 h -0.1 l -1 0.6 h 0 l 1.1 0.5 h 0.1 z m -1.3 0.8 l 1 -0.6 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 h -0.2 l -1 0.6 h 0 l 1.2 0.6 h 0 z m -1.3 0.9 l 1.1 -0.7 h -0.1 l -1 -0.5 h -0.1 l -1 0.7 h 0 l 1 0.6 l 0.1 -0.1 z m -1.2 0.8 l 1 -0.7 h 0 l -1.1 -0.6 h -0.1 l -1 0.7 c -0.1 0 -0.1 0 0 0.1 l 1 0.5 h 0.2 h 0 z m -1.3 0.8 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 l -1 0.6 h 0 l 1.1 0.5 l 0.1 0.1 z m -1.3 0.8 l 1 -0.6 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 h -0.2 l -1 0.6 h 0 l 1.1 0.5 c 0 0.2 0.1 0.2 0.1 0.1 h 0 h 0 z m -1.2 0.9 l 1 -0.7 h 0 l -1.1 -0.5 h -0.1 l -1 0.6 c -0.1 0.1 -0.1 0.1 0 0.1 l 1 0.6 l 0.2 -0.1 h 0 z m -1.3 0.8 l 1 -0.7 h 0 l -1.1 -0.6 h -0.1 l -1 0.7 h 0 l 1.1 0.6 h 0.1 z m -2 1.3 l 1.7 -1.1 c 0.1 -0.1 0.1 -0.1 0 -0.1 l -1 -0.6 h -0.2 l -1.7 1.1 h 0 l 1.1 0.6 l 0.1 0.1 h 0 z m 8 -11.5 l 1 -0.6 c 0.1 -0.1 0.1 -0.1 0 -0.1 l -1 -0.5 h -0.2 l -1 0.6 h 0 l 1.1 0.5 l 0.1 0.1 h 0 z m -1.2 0.8 l 1 -0.6 h 0 l -1.1 -0.5 h -0.1 l -1 0.6 c -0.1 0.1 -0.1 0.1 0 0.1 l 1 0.5 l 0.2 -0.1 h 0 z m -1.3 0.9 l 1 -0.7 h 0 l -1.1 -0.5 h -0.1 l -1 0.7 h 0 l 1.1 0.6 l 0.1 -0.1 z m -7.6 4.9 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 l -1 0.7 c -0.1 0 -0.1 0 0 0.1 l 1 0.5 l 0.2 -0.1 h 0 z m -1.3 0.8 l 1 -0.6 h 0 l -1.1 -0.5 h -0.1 l -1 0.6 h 0 l 1.1 0.5 h 0.1 z m -2 1.3 l 1.7 -1.1 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 h -0.2 l -1.7 1.1 h 0 l 1.1 0.5 l 0.1 0.1 h 0 z m 3.9 0.8 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.1 -0.5 l -0.1 -0.1 h 0 z m 1.2 -0.8 l -1 0.6 h 0 l 1.1 0.6 h 0.1 l 1 -0.6 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 h -0.2 h 0 z m 1.3 -0.8 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 c 0.1 0 0 -0.1 0 -0.1 l -1.1 -0.5 l -0.1 0.1 z m 1.3 -0.9 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 z m 1.3 -0.8 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.2 -0.6 h 0 z m 1.2 -0.8 l -1 0.6 h 0 l 1.1 0.6 h 0.1 l 1 -0.7 c 0.1 0 0.1 0 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m 1.3 -0.8 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.5 h -0.1 z m 1.3 -0.8 l -1 0.6 c -0.1 0 -0.1 0.1 0 0.1 l 1 0.5 h 0.2 l 1 -0.6 h 0 l -1.2 -0.6 h 0 z m 1.2 -0.9 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.7 h 0 l -1 -0.6 l -0.2 0.1 h 0 z m 1.3 -0.8 l -1 0.7 h 0 l 1.1 0.6 h 0.1 l 1 -0.7 h 0 l -1.1 -0.5 l -0.1 -0.1 z m -1.9 -0.3 l -1 0.6 h 0 l 1.1 0.6 h 0.1 l 1 -0.6 h 0 l -1.1 -0.5 l -0.1 -0.1 z m -1.3 0.8 l -1 0.7 h 0 l 1.1 0.6 h 0.1 l 1 -0.7 c 0.1 0 0.1 0 0 -0.1 l -1 -0.5 h -0.2 h 0 z m -1.2 0.8 l -1 0.7 c -0.1 0 -0.1 0 0 0.1 l 1 0.5 h 0.2 l 1 -0.7 h 0 l -1.2 -0.6 h 0 z m -1.3 0.9 l -1 0.6 c -0.1 0 0 0.1 0 0.1 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 z m -1.3 0.8 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.5 h -0.1 z m -1.3 0.8 l -1 0.6 h 0 l 1.1 0.6 h 0.1 l 1 -0.7 c 0.1 0 0.1 0 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m -1.2 0.8 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.2 -0.6 h 0 z m -1.3 0.8 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 z m -1.3 0.9 l -1.7 1.1 h 0 l 1.1 0.6 h 0.1 l 1.7 -1.1 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 c -0.1 -0.1 -0.1 -0.1 -0.2 0 h 0 h 0 z m 11.5 -7.4 l -1 0.6 c -0.1 0 -0.1 0.1 0 0.1 l 1 0.5 h 0.2 l 1 -0.6 h 0 l -1.1 -0.5 l -0.1 -0.1 h 0 z m 5.1 -1.8 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m -1.2 0.8 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.1 -0.5 l -0.1 -0.1 h 0 z m 2.5 -1.6 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.5 c 0 -0.1 -0.1 -0.1 -0.1 0 z m 0.1 1.5 l -1 0.6 c -0.1 0 -0.1 0.1 0 0.1 l 1 0.5 h 0.2 l 1 -0.6 h 0 l -1.1 -0.5 c 0 -0.2 -0.1 -0.2 -0.1 -0.1 h 0 h 0 z m -5.4 -2.8 l -1 0.7 h 0 l 0.5 0.3 h 0.1 l 1 -0.7 h 0 l -0.5 -0.2 l -0.1 -0.1 h 0 z m -1.3 0.8 l -1 0.7 h 0 l 0.5 0.2 h 0.1 l 1 -0.7 h 0 l -0.5 -0.3 l -0.1 0.1 h 0 z m 2.6 -1.6 l -1 0.6 c -0.1 0.1 -0.1 0.1 0 0.1 l 0.4 0.3 h 0.2 l 1 -0.6 h 0 l -0.5 -0.2 l -0.1 -0.2 h 0 z m -0.6 1.2 l -1 0.6 h 0 l 0.5 0.2 h 0.1 l 1 -0.6 h 0 l -0.5 -0.2 h -0.1 z m 3.4 3.2 l -1 0.6 h 0 l 1.1 0.6 h 0.1 l 1 -0.7 h 0 l -1.1 -0.5 h -0.1 z m 2.5 -1.7 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 c 0.1 -0.1 0.1 -0.1 0 -0.1 l -1 -0.6 l -0.2 0.1 h 0 z m -5.6 3.5 l 1.7 -1.1 h 0 l -1.1 -0.6 l -1.3 -0.7 h -0.2 l -1 0.7 h 0 l 1.3 0.6 h 0 l -0.6 0.3 c -0.1 0.1 -0.1 0.1 0 0.1 l 1 0.6 l 0.2 0.1 h 0 z m -2.2 -3.1 l -2.6 1.8 h 0 l 1 0.6 h 0.2 l 2.6 -1.7 h 0 l -1.2 -0.7 h 0 h 0 z m -4.1 2.7 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.2 -0.6 h 0 z m -1.3 0.8 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 h 0 l -1.1 -0.6 h -0.1 z m -1.3 0.9 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m -1.3 0.8 l -1 0.6 h 0.1 l 1 0.6 h 0.1 l 1 -0.7 c 0.1 0 0.1 -0.1 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m -1.2 0.8 l -1 0.7 h 0 l 1 0.6 h 0.2 l 1 -0.7 h 0 l -1.2 -0.6 h 0 z m -1.3 0.8 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.7 h 0 l -1.1 -0.6 l -0.1 0.1 z m -1.3 0.9 l -1 0.6 h 0 l 1.1 0.5 h 0.1 l 1 -0.6 c 0.1 -0.1 0.1 -0.1 0 -0.1 l -1 -0.5 l -0.2 0.1 h 0 z m -1.2 0.8 l -1.4 0.9 c -0.1 0 -0.1 0 0 0.1 l 1 0.5 h 0.2 l 1.4 -0.9 h 0 l -1.1 -0.5 l -0.1 -0.1 h 0 z m 10.1 -6.6 l -1 0.7 h 0 l 1.1 0.5 h 0.1 l 1 -0.7 h 0 l -1.1 -0.6 l -0.1 0.1 z m 5.9 2.3 l 2.2 -1.5 h 0 l -1 -0.6 h -0.2 l -2.2 1.5 c -0.1 0 -0.1 0 0 0.1 l 1 0.5 h 0.2 z m -13.1 2.2 l 6.1 -4 h 0 l -1 -0.6 h -0.2 l -6.1 4 h 0.1 l 1.1 0.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 179.4 247.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-147.26, -214.45)",
    d: "M 146.6 216.9 s 2.5 -1.1 2.2 -3.1 s -3.1 -1.8 -3.1 -1.8 l 0.9 4.9 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 184.79 272.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-151.65, -236.48)",
    d: "M 151.6 246.9 c 0 -0.2 -0.1 -0.3 -0.1 -0.4 l -6.4 -16.9 c -0.8 -1.9 0 -4.1 1.9 -5 c 2 -1 4.4 -0.2 5.5 1.7 c 0.1 0.2 0.1 0.4 0.2 0.6 l 5.6 17.1 c 0.6 1.7 -0.2 3.6 -1.8 4.4 c -1.8 0.9 -3.9 0.2 -4.9 -1.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 193.52 289)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-158.75, -251.2)",
    d: "M 164.7 260 c -1.3 0.9 -3.1 0.6 -4.1 -0.7 l -8.5 -11.4 v -0.2 c -1.2 -1.7 -0.8 -4 0.9 -5.1 l 0.1 -0.1 a 3.82 3.82 0 0 1 5.2 1 h 0 v 0.2 l 7.4 12.2 c 0.8 1.4 0.3 3.2 -1.1 4.1 h 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 198.62 296.14)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_843",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 165.644,
    y1: 257.576,
    x2: 160.534,
    y2: 257.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(247,247,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(238,238,246)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_843)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-162.89, -257.58)",
    d: "M 161.7 255.6 a 2.53 2.53 0 0 1 3.4 0.8 c 0.5 1.3 -0.1 2.7 -1.4 3.3 c -0.9 0.4 -2 0.2 -2.7 -0.6 h 0 c -0.8 -1 -0.6 -2.5 0.4 -3.3 h 0.3 v -0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 215.8 360.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(12,12,17)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-176.86, -315.25)",
    d: "M 170.7 312.2 c 0 0.2 0 0.5 0.1 0.7 c 0.9 0.9 1.8 1.6 2.9 2.2 c 1.2 1 2.7 1.5 4.2 1.5 c 1.8 0 4 -0.3 4.6 -1 c 0.2 -0.2 0.3 -0.5 0.2 -0.8 h -0.1 s 0.4 0.1 0.5 1.2 c 0 0.7 -0.3 1.3 -0.9 1.7 a 9.26 9.26 0 0 1 -7.3 -0.3 c -1.7 -1 -1.5 -1.5 -2.5 -2.1 s -1.6 -1 -1.7 -1.6 c -0.1 -0.5 -0.1 -1 0 -1.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 226.4 347.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-185.48, -303.48)",
    d: "M 178.5 298.1 c -0.1 1.2 -0.3 2.4 -0.6 3.6 c -0.5 1.2 -0.7 2.5 -0.6 3.8 c 0 0 0.1 0.8 2.5 1.2 s 3.4 0.5 4.6 1.1 c 1.4 1 3.1 1.5 4.8 1.6 c 2.3 0.1 4.1 -0.4 4.4 -1.1 s -0.2 -1.1 -1 -1.5 s -4.2 -1.8 -5.3 -2.9 c -1.3 -1.5 -2.4 -3.3 -3.3 -5.1 c -0.6 -1.3 -5.4 -1.7 -5.5 -0.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 226.24 352.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(12,12,17)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-185.35, -307.88)",
    d: "M 193.6 308 v 0.3 c -0.3 0.7 -2.1 1.2 -4.4 1.1 c -1.7 -0.1 -3.4 -0.6 -4.8 -1.6 c -1.2 -0.6 -2.2 -0.7 -4.6 -1.1 s -2.5 -1.2 -2.5 -1.2 v -0.2 l -0.2 1.6 c 0.4 0.5 1 0.8 1.7 0.8 a 25.85 25.85 0 0 1 4 0.9 c 1.3 0.3 3.2 1.5 4.5 1.7 c 4.3 0.5 5.8 -0.3 6 -0.6 c 0.2 -0.5 0.3 -1.1 0.3 -1.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 216.95 351.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-177.8, -307.18)",
    d: "M 179.3 303.6 l -1.8 -0.2 c 0.1 -0.6 0.2 -1.1 0.4 -1.7 c 0.3 -1.2 0.5 -2.4 0.6 -3.6 c 0.1 -1 4.9 -0.6 5.5 0.7 c 0.2 0.7 0.6 1.3 1 1.8 a 6.49 6.49 0 0 1 -5.7 3 h 0 h 0 z m -8.7 2.5 c 0.1 1.1 0.1 2 0.1 2.8 s -0.2 3.5 0.1 4 c 0.9 0.9 1.8 1.6 2.9 2.2 c 1.3 1.1 2.9 1.7 4.6 1.7 c 1.8 0.1 3.8 -0.3 4.4 -1.2 s -0.2 -1.2 -0.9 -1.6 c -1.4 -0.9 -2.7 -1.9 -3.9 -3.1 c -1.6 -1.7 -2.5 -5 -3.4 -5.7 s -3.9 -0.2 -3.9 0.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 211.86 352.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-173.66, -308.25)",
    d: "M 174.5 305.2 c 0.7 0.5 1.3 2.4 2.2 4 c -1.2 1.7 -3.2 2.6 -5.3 2.5 h -0.7 c -0.1 -0.9 -0.1 -1.9 0 -2.8 v -2.8 c -0.1 -1.1 2.6 -1.8 3.8 -0.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 198.88 319.91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-163.1, -278.8)",
    d: "M 141.2 260.6 c 1.2 -3.7 5 -5.7 8.7 -4.6 h 0.1 l 31.8 10.3 c 1.4 0.6 2.6 1.7 3.2 3.1 c 0 0.1 0.1 0.3 0.1 0.4 c 0.2 0.5 0.3 1 0.3 1.5 c 0 10.1 -0.9 18.4 -0.3 28.5 c 0.1 2.8 -8.5 2.8 -8.5 0 c 0 -8.7 -0.9 -16.2 -1.2 -24.6 l -28.9 -5.6 h -0.7 c -3.7 -1.1 -5.8 -5 -4.7 -8.7 c 0.1 -0.1 0.1 -0.1 0.1 -0.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 188.93 325.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-155.02, -283.78)",
    d: "M 134.4 260.2 c 2.2 -3.2 6.4 -4.1 9.7 -2.1 h 0.1 l 28 18.2 l 1.1 1 v 0.2 l 0.3 0.4 c 0.4 0.7 0.7 1.4 0.8 2.2 c 1.2 10 1.2 18.1 2.4 28 c 0.3 2.8 -7.7 3.4 -8 0.6 c -1.1 -9.1 -2.8 -16.1 -4 -24.8 l -27.6 -13.6 l -0.7 -0.3 c -3.3 -2.1 -4.3 -6.5 -2.1 -9.8 c -0.1 0 -0.1 0 0 0 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 173.58 283.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-142.54, -246.66)",
    d: "M 151.6 225.6 c -1 -2.5 -7.5 -1.4 -12.6 0.5 s -9.5 4.7 -10.9 8.6 c -0.5 1.2 1.9 9 3.1 17.3 l 2.5 16.6 c 0.5 2.8 24.5 -5.3 23.3 -9.6 a 93.82 93.82 0 0 1 -3.3 -16.6 c -0.2 -1.3 -0.2 -12.1 -2.1 -16.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 203.48 305.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-166.85, -265.7)",
    d: "M 166.1 263.4 l -3.6 14.9 c -0.1 0.3 -0.1 0.5 -0.2 0.6 s 0 0.1 -0.1 0.2 l -0.3 0.4 h -0.2 l -0.3 0.3 c -0.7 0.4 -1.5 0.4 -2.2 0 l -11.7 -6 c -0.1 0 -0.2 0 -0.2 -0.2 h 0 v -0.5 c 0 -0.1 0.1 0.2 0.2 0.1 l 20 -13.1 h 0.3 l 1.9 0.9 l 10.1 5.2 a 2.56 2.56 0 0 0 2.1 0 l 0.6 -0.4 c 0.3 -0.3 0.6 -0.7 0.7 -1.2 l 3.2 -13.3 l -20.3 12.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 203.42 304.91)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_844",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 244.24,
    y1: 413.9,
    x2: 205.04,
    y2: 413.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(247,247,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(238,238,246)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_844)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-224.6, -413.9)",
    d: "M 244.2 399.5 l -3.2 13.3 c -0.1 0.5 -0.4 0.9 -0.7 1.2 l -0.6 0.4 a 2.56 2.56 0 0 1 -2.1 0 l -10.2 -5.2 l -1.8 -0.9 h -0.3 l -20 13.1 c -0.2 0 -0.3 0.1 -0.3 0.3 s 0.1 0.3 0.3 0.3 h 0 l 11.7 6 a 1.99 1.99 0 0 0 2.1 0 l 0.4 -0.3 h 0.1 c 0.2 -0.1 0.3 -0.3 0.4 -0.4 v -0.3 c 0.1 -0.1 0.1 -0.3 0.2 -0.6 l 5.3 -14.2 l 18.7 -12.7 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 202.74 300.97)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_845",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 228.765,
    y1: 410.382,
    x2: 219.252,
    y2: 410.382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    style: {
      stopColor: "rgb(236,180,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    style: {
      stopColor: "rgb(235,176,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(233,165,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_845)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-224.04, -410.38)",
    d: "M 222.9 405.5 c 1.1 1.3 2.3 2.5 3.5 3.7 l 1.7 1.3 l 0.7 2.3 v 0.6 c -0.1 0.3 -0.2 0.5 -0.4 0.5 l -0.2 1.1 c 0 0.2 -0.1 0.3 -0.3 0.3 v 0.4 c 0 0.2 -0.1 0.3 -0.3 0.3 l -0.3 -0.2 l -1.1 -3.4 l -0.6 -0.7 l 0.3 0.8 l 1 3.1 c 0.1 0.2 -0.1 0.4 -0.3 0.5 h 0 c -0.2 0.1 -0.4 0 -0.5 -0.2 l -1.7 -3.2 l -2 -1.7 l 0.8 1.7 l 1 0.9 l 0.3 1.1 c 0.1 0.1 0 0.2 -0.1 0.3 h -0.6 l -0.7 -0.7 l -0.9 -0.6 l -1.1 -1.3 l -0.9 -2.9 c -0.4 -1 -0.7 -2 -0.9 -3 c -0.2 -1.5 2 -2.8 3.6 -1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 212.34 304.26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-174.05, -264.83)",
    d: "M 161.7 279.2 l -0.5 0.7 l 0.6 -0.3 l 20.1 -13.7 l 0.6 -0.4 c 0.3 -0.3 0.6 -0.7 0.7 -1.2 l 3.7 -14.2 s -0.5 -0.5 -0.7 -0.3 l -16.6 10.9 l -3.2 2.1 c -0.2 0.2 -0.4 0.3 -0.4 0.5 l -3.5 14.6 c -0.1 0.3 -0.1 0.5 -0.2 0.6 s -0.1 0.1 -0.1 0.2 s -0.2 0.3 -0.4 0.4 l -0.1 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 212.85 304.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,228,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-174.46, -264.74)",
    d: "M 162 279.5 l 20.2 -13.3 l 0.6 -0.4 c 0.3 -0.3 0.6 -0.7 0.7 -1.2 l 3.4 -14.3 c 0.1 -0.2 -0.2 -0.4 -0.4 -0.3 L 170 260.9 l -3.3 2.2 a 0.55 0.55 0 0 0 -0.3 0.5 l -3.6 14.6 c -0.1 0.3 -0.1 0.5 -0.2 0.6 h -0.1 l -0.3 0.5 l -0.2 0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 214.56 302.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,249,252)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-175.85, -263.6)",
    d: "M 177.6 262.7 c 0.1 -1.1 -0.6 -1.6 -1.6 -1.1 c -1.1 0.6 -1.8 1.7 -1.9 2.9 c -0.1 1.1 0.6 1.6 1.6 1.1 c 1.1 -0.6 1.8 -1.7 1.9 -2.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 207.62 305.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.3
    },
    transform: " translate(-170.21, -266.1)",
    d: "M 170 260.9 l -3.3 2.2 a 0.55 0.55 0 0 0 -0.3 0.5 l -3 12.3 c 8.4 -2.8 14 -10.8 13.6 -19.6 l -7 4.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 171.13 258.09)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_846",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 202.086,
    y1: 372.098,
    x2: 194.651,
    y2: 372.098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    style: {
      stopColor: "rgb(236,180,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_846)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-198.35, -372.1)",
    d: "M 195 378.8 v -0.3 l -0.4 -9.5 c -0.1 -1.9 1.5 -3.5 3.4 -3.6 h 0 c 1.9 -0.1 3.6 1.4 3.7 3.3 h 0 l 0.4 9.4 c 0 0.2 -0.1 0.3 -0.1 0.5 l -7 0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 174.24 293.24)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_847",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 200.874,
    y1: 417.746,
    x2: 200.874,
    y2: 390.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,148,89)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47%",
    style: {
      stopColor: "rgb(254,153,96)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(254,162,111)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_847)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-200.87, -403.48)",
    d: "M 211.4 411.5 c -6.5 3.8 -19.5 7.6 -19.9 5.6 l -2.5 -16.6 c -0.6 -4.1 -1.5 -8.1 -2.2 -11.2 h 2.9 s 4.4 7.3 8.6 7 s 10.4 -4.2 12.6 -5.6 l 0.6 -0.7 v 0.9 c 0.1 0.5 0.1 1.3 0.3 2.5 s 0.1 0.5 0.1 0.8 s 0.6 3.9 1.2 6.8 s 1 4.1 1.7 6.5 s -1.2 2.5 -3.4 4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 162.38 281.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-133.43, -244.67)",
    d: "M 131.9 254.9 c -0.1 -0.1 -0.1 -0.2 -0.1 -0.4 l -3.8 -17.6 c -0.5 -2 0.6 -4.1 2.6 -4.7 c 2.1 -0.7 4.3 0.4 5.1 2.5 h 0 c 0.1 0.2 0.1 0.4 0.2 0.6 l 3 17.8 c 0.4 2 -0.9 3.8 -2.9 4.2 h -0.1 c -1.7 0.3 -3.5 -0.7 -4 -2.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 170.9 297.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.36, -258.96)",
    d: "M 147.9 266.4 c -1.1 1.2 -2.9 1.3 -4.1 0.2 l -0.1 -0.1 l -10.6 -9.5 c -0.1 0 -0.1 0 -0.1 -0.1 h 0 a 3.87 3.87 0 0 1 0 -5.3 a 3.87 3.87 0 0 1 5.3 0 h 0.1 l 9.6 10.5 c 1.1 1.2 1 3 -0.1 4.2 v 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 178.06 304.05)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_848",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 148.87,
    y1: 264.63,
    x2: 143.648,
    y2: 264.63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(247,247,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(238,238,246)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_848)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-146.18, -264.63)",
    d: "M 144.4 262.9 c 0.9 -1 2.5 -1.2 3.5 -0.2 c 1 0.9 1.2 2.5 0.3 3.5 h 0 l -0.5 0.4 c -1 0.9 -2.5 0.8 -3.4 -0.2 l -0.1 -0.1 c -0.9 -1 -0.8 -2.5 0.2 -3.4 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 171.07 256.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.5, -222.27)",
    d: "M 136.9 221.5 c 0 -1.9 1.6 -3.5 3.5 -3.7 c 1.5 0 2.8 0.8 3.5 2.1 v 0.4 l 0.2 5.9 c -1 0.5 -2 0.6 -3.1 0.5 c -1.5 0 -2.9 -0.6 -4 -1.5 l -0.1 -3.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 172.99 252.13)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_849",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 148.369,
    y1: 218.277,
    x2: 135.669,
    y2: 218.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_849)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-142.05, -218.28)",
    d: "M 145.4 226.3 l 1.1 -0.3 c 0.1 0 0.7 -1.7 1 -2.2 a 5.29 5.29 0 0 0 0.9 -3 c 0 -1.3 -0.5 -2.4 -0.4 -3.2 c 0.3 -1.4 0.1 -2.9 -0.5 -4.2 c -1.4 -2.5 -4.3 -3.7 -7.1 -2.9 c -2.7 0.6 -4.7 3 -4.7 5.8 c 0.2 2.4 1.2 4.6 2.9 6.3 c 1.3 1.4 2.9 2.5 4.7 3.2 l 2.1 0.5 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 175.97 244.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(19,16,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-144.48, -211.32)",
    d: "M 147.4 213.3 s -1.6 -1.8 -6.1 0 c 0 0 2.6 -4.5 4.9 -3.9 s 1.2 3.9 1.2 3.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 171.34 249.27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.71, -215.72)",
    d: "M 135.7 210.3 c 0.8 -0.5 1.7 -0.9 2.6 -1.1 l 0.6 -0.5 c 1.6 -1.1 3.5 -0.3 4.4 -0.1 s 2.4 -0.5 4 0.6 s 0.1 4.1 0.1 4.1 s -0.5 -2.8 -2.5 -2.7 s -2.7 4.2 -4.1 4.5 h -0.9 c 0 0.7 -0.2 1.4 -0.5 2.1 c -0.2 0.4 -1.3 1 -1.3 2 v 1.7 s -0.4 2.3 -0.9 2.4 s -2 -2.7 -3 -5.8 c -0.4 -1.1 -0.6 -2.2 -0.6 -3.4 h -0.1 c -0.4 -0.2 0.2 -2.3 2.2 -3.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 167.35 254.44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,172,200)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-137.47, -220.34)",
    d: "M 138.5 219.5 c 0.8 1 1 2.2 0.4 2.6 c -0.9 0.4 -2 0.1 -2.5 -0.8 c -0.8 -0.9 -0.9 -2.2 -0.4 -2.7 s 1.7 0 2.5 0.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 169.4 266.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-139.14, -230.76)",
    d: "M 137.1 226.4 c 0.6 2.2 2.7 3.7 5 3.5 c 0 0 0.3 5 -0.3 5.2 s -5.6 -2.6 -5.7 -5 c 0.1 -1.3 0.4 -2.5 1 -3.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 175.02 265.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-143.71, -230.26)",
    d: "M 142.1 229.9 s 1.5 4.9 2.3 4.3 s 1.1 -3.5 0.8 -5 s -0.6 -1.9 -1 -2.8 s 0 2.8 -2.1 3.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 186.18 307.21)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_850",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 160.875,
    y1: 267.457,
    x2: 144.525,
    y2: 267.457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    style: {
      stopColor: "rgb(236,180,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    style: {
      stopColor: "rgb(235,176,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(233,165,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_850)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-152.77, -267.46)",
    d: "M 146 266.9 l 1.7 0.6 l 5.1 3.3 l 2.7 1.4 l 1.3 -0.3 l 0.2 -0.2 h 0.4 l 0.9 -0.3 l 0.4 -0.7 l 0.7 0.2 c 0.2 0.1 0.4 0 0.5 -0.2 s 0.1 -0.4 0 -0.6 h -0.1 l -2.1 -1.8 l 2.5 1.4 c 0.3 0.1 0.5 0.1 0.7 -0.2 s 0 -0.3 -0.1 -0.5 l -1.4 -1.7 l -3.4 -2.1 l -7.7 -2.1 l -1.1 -0.3 c -1 -0.3 -2 0.2 -2.4 1.2 c -0.5 1 -0.2 2.2 0.8 2.7 c 0.1 0 0.1 0.1 0.2 0.1 h 0.2 v 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 325.68 334.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-266.2, -291.9)",
    d: "M 266 297.7 h 0.4 v -11.6 l -0.4 0.3 v 11.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 328.4 312.01)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_851",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 275.704,
    y1: 271.743,
    x2: 261.144,
    y2: 271.743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_851)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-268.41, -271.74)",
    d: "M 273 281.2 c 0.5 -0.2 1.7 -3.5 2.2 -4.5 s -0.1 -2.5 0.1 -4.1 c 0.7 -2.4 0.4 -5 -0.9 -7.1 c -2.1 -2.9 -6.9 -4.1 -9.8 -2.5 s -4.1 6.7 -3.1 10 s 8.5 7.3 8.5 7.3 l 3 0.9 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 332.27 319.81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-271.55, -278.7)",
    d: "M 273.1 281.1 h -0.1 l -3 -0.9 l 1.6 -3.9 c 0.3 1.7 0.8 3.3 1.5 4.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 324.86 323.39)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_852",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 270.764,
    y1: 281.9,
    x2: 260.324,
    y2: 281.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_852)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.53, -281.9)",
    d: "M 268.3 273.8 c 1.8 0.7 2.8 2.7 2.3 4.6 l -3.1 9.3 c -0.7 1.9 -2.8 2.9 -4.7 2.3 c -1.9 -0.7 -2.9 -2.7 -2.3 -4.6 l 3.2 -9.3 c 0.7 -1.9 2.7 -2.9 4.6 -2.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 325.5 325.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-266.05, -283.51)",
    d: "M 259.9 282.6 l 2.4 -4.6 c 0.7 -1.2 6.4 1.8 7.4 4.3 l 2.5 7 l -12.3 -6.7 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 346.37 330.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-283.02, -288.31)",
    d: "M 280.7 285.9 l 3.4 -1.9 v 1 l -1.5 1 h 1.7 l 2.8 1.3 c 0.4 0.1 0 0.9 -0.5 0.8 l -2.7 -0.7 l -1.5 0.4 l 1.8 0.3 l 2.1 0.9 c 0.2 0.1 0.1 0.6 -0.4 0.6 l -1.4 -0.3 v 0.7 l -2 0.2 c -0.4 0 -0.8 0.1 -1.1 0.3 c -0.7 0.8 -1.5 1.5 -2.4 2.1 c -1 0.4 1.7 -6.7 1.7 -6.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 340.01 331.23)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_853",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 283.1,
    y1: 288.9,
    x2: 272.495,
    y2: 288.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    style: {
      stopColor: "rgb(236,180,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    style: {
      stopColor: "rgb(235,176,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(233,165,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_853)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-277.85, -288.9)",
    d: "M 272.6 292.3 l 4.1 -3.2 c 1.3 -1.4 2.4 -2.9 3.4 -4.5 c 0.3 -0.4 2.7 -2.3 3 -2.6 l -0.5 1.6 a 9.51 9.51 0 0 0 -1.5 2 c 0.3 1.7 0.3 3.5 -0.1 5.2 c 0 0.6 -1.9 2.2 -4.8 3.1 l -2.1 1.9 l -1.5 -3.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 348.44 327.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(50,42,141)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-284.7, -285.3)",
    d: "M 280.7 288.8 l 3.2 -8.7 c 0.1 -0.3 0.5 -0.5 0.8 -0.4 l 3.6 1.3 c 0.3 0.1 0.5 0.5 0.4 0.8 l -3.2 8.7 c -0.1 0.3 -0.5 0.5 -0.8 0.4 l -3.6 -1.3 c -0.3 -0.1 -0.5 -0.5 -0.4 -0.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 348.38 327.14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,228,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-284.65, -285.25)",
    d: "M 280.9 288.1 l 2.8 -7.5 l 4.7 1.8 l -2.7 7.5 l -4.8 -1.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 343.08 331.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-280.35, -289.17)",
    d: "M 277.6 288.3 c 0.4 -0.4 0.9 -0.7 1.5 -1 l 2.4 -0.4 l 1.9 -0.7 c 0.2 0 0.8 0.5 0.4 1 c -0.4 0.6 -1 0.9 -1.7 1.1 l -1.5 0.6 c -0.5 1.4 -1.6 2.6 -3 3.2 c -1.9 0.5 0 -3.8 0 -3.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 337.98 334.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,228,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-276.2, -292)",
    d: "M 276.3 289.3 c -1.4 -0.1 -2.6 1 -2.8 2.4 v 0.2 c -0.1 1.4 1 2.7 2.4 2.8 h 0.2 c 1.5 0 2.7 -1.2 2.8 -2.7 c 0 -1.4 -1.1 -2.6 -2.5 -2.7 h -0.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 328.62 341.13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(248,230,186)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-268.58, -297.74)",
    d: "M 277 291.2 c -1 -1.3 -2.9 -1.5 -4.2 -0.6 h 0 l -11.6 8.2 h -0.1 a 3.78 3.78 0 0 0 -0.8 5.2 h 0.1 c 1.2 1.6 3.6 1.9 5.2 0.7 l 0.1 -0.1 h 0.1 l 10.8 -9.3 c 1.1 -1.1 1.3 -2.8 0.4 -4.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 328.39 438.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    cx: 0,
    cy: 0,
    rx: 26.9,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 338.04 439.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-276.24, -385.6)",
    d: "M 269.4 381.9 a 13.33 13.33 0 0 1 -0.3 2.8 c -0.3 0.6 -1.6 3.3 -1.2 5.1 c 0 0 0.6 1 2.8 0.9 s 3.9 -0.8 6.2 -0.7 s 5.8 -0.2 7 -1.6 s 0.8 -2.3 0 -2.6 s -2.4 0.2 -3.7 -0.4 s -3.6 -2.6 -4.1 -4.2 s -6.6 -0.1 -6.7 0.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 333.8 436.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-272.8, -383.2)",
    d: "M 276.1 381.2 c -0.5 -1.6 -6.6 -0.1 -6.7 0.7 a 13.33 13.33 0 0 1 -0.3 2.8 c -0.1 0.1 -0.2 0.3 -0.2 0.5 c 0.8 0.5 1.7 0.7 2.6 0.7 c 2.3 0 4.4 -1.4 5.2 -3.6 c -0.3 -0.3 -0.5 -0.7 -0.6 -1.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 338.29 444.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(21,15,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-276.45, -389.6)",
    d: "M 284.6 386.6 c 0.2 0.4 0 1 -0.7 1.8 s -4.7 1.7 -7 1.6 s -4.1 0.6 -6.2 0.7 s -2.8 -0.9 -2.8 -0.9 v 1.6 c 0 0.3 0.4 1.1 2.6 1.2 s 5.6 -0.6 7.2 -0.7 s 4.9 -0.4 5.8 -1 c 0.7 -0.6 1.2 -1.3 1.5 -2.2 c 0 -0.7 -0.2 -1.4 -0.4 -2.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 317.01 431.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-259.15, -378.66)",
    d: "M 252.8 382.6 c 1.2 1.1 3.1 0.6 5.2 -0.9 s 4.3 -1.6 6.4 -3.2 s 2.3 -3.7 0.4 -4.2 s -4.3 0.3 -5.6 0.1 s -4.1 -0.8 -5.4 1.9 s -2.3 5.2 -1 6.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 314.86 429.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-257.4, -376.98)",
    d: "M 256.4 379.7 c 3 0 5.4 -2.4 5.5 -5.4 c -0.9 0.2 -1.8 0.2 -2.7 0.1 c -1.2 -0.1 -4.1 -0.8 -5.4 1.9 l -0.9 2.2 c 1 0.8 2.2 1.3 3.5 1.2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 316.89 433.63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(21,15,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-259.05, -380.33)",
    d: "M 252.1 382.8 v -1.6 c 0 0.5 0.2 1.1 0.6 1.4 c 1.2 1.1 3.1 0.6 5.2 -0.9 s 4.3 -1.6 6.4 -3.2 a 3.94 3.94 0 0 0 1.7 -2.5 v 1.5 h 0 c 0 0.8 -0.6 1.6 -1.7 2.5 s -4.3 1.8 -6.4 3.2 s -4 2 -5.2 0.9 c -0.4 -0.3 -0.6 -0.9 -0.6 -1.4 v 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 320.1 391.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(19,58,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-261.66, -342.56)",
    d: "M 256.3 347.3 v -33.5 c 0 -0.3 0.1 -0.5 0.1 -0.8 c 0.5 -4 4 -6.8 8 -6.4 c 3.9 0.5 6.8 4 6.4 8 h 0 l -4.2 34.2 l -0.3 1.2 c -1.5 9.4 -3.3 13.9 -4.5 26.2 c -0.3 2.8 -9.7 3.3 -9.3 0.5 c 1.7 -10.2 2.3 -19.1 3.8 -29.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 335.41 399.45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(19,58,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-274.1, -349.82)",
    d: "M 266.9 322.2 c 0 -0.3 -0.1 -0.5 -0.1 -0.8 c 0.1 -4 3.5 -7.2 7.5 -7.1 c 4 0.2 7.2 3.5 7.1 7.5 h 0 l -1.3 34.4 v 0.4 c -1 10.3 -2.7 17.3 -2.6 26.5 c 0.1 2.8 -10 3.1 -9.7 0.2 c 1 -10.2 1 -17.2 1.9 -27.3 l -2.8 -33.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 327.51 350.32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.68, -305.95)",
    d: "M 282.3 326.2 c 0.2 1.9 1.9 6.5 -8.9 6.5 s -18 -7.3 -18 -9.6 c 0.1 -7.4 0.3 -12.4 -0.3 -17.2 s -4.3 -23.4 -0.7 -25.9 s 10 1.6 12.3 3 s 9.9 6.6 12 9.1 s 2.6 6.6 1.5 10.8 c -0.6 3 -0.5 6.1 0.2 9.1 c 0.5 2.1 1.7 12.3 1.9 14.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 328.89 365.44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,32,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-268.81, -319.45)",
    d: "M 275 312.2 c 1.8 0.1 3.5 -0.1 5.2 -0.8 c 0.1 0.2 0.1 0.4 0.2 0.6 c 0.5 2.1 1.7 12.3 1.9 14.2 s 1.9 6.5 -8.9 6.5 s -18 -7.3 -18 -9.6 c 0.1 -7.3 0.3 -12.2 -0.3 -16.9 c 5.8 2.5 15 6 19.9 6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 327.3 312.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.51, -271.77)",
    d: "M 262.9 276.4 c 0.1 1.2 3.9 2.1 5 0.9 s 2.8 -5 4 -4.9 c 0.7 0.2 1.2 0.9 1.2 1.6 l 0.9 -0.4 c -0.1 -1.1 -0.1 -2.2 0.2 -3.2 c 0.4 -0.9 0.8 -1.5 -0.2 -1.7 s -11.3 -4.5 -12.6 -2.5 c -1.2 1.9 -1.3 4.3 -0.4 6.4 c 0.7 2.1 1.9 2.4 1.9 3.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 329.4 304.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-269.22, -265.26)",
    d: "M 262.5 266.7 c -1 -0.6 -1.4 -2 -0.8 -3 c 0 0 0 -0.1 0.1 -0.1 c 0 -0.1 0 -0.1 0.1 -0.2 l 0.3 -0.4 c 1.1 -1.2 4 -1.4 5.6 -1.2 s 5.4 1.3 6.4 0.7 c 0.8 -0.5 1.9 -0.3 2.5 0.5 l 0.3 0.8 c 0.1 1.7 0.1 4.5 -4 4.9 s -8.9 -0.8 -10.5 -2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 347.66 381.56)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_854",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 287.615,
    y1: 333.84,
    x2: 280.882,
    y2: 333.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3%",
    style: {
      stopColor: "rgb(236,180,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    style: {
      stopColor: "rgb(235,176,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(233,165,191)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_854)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-284.07, -333.84)",
    d: "M 284.5 327.8 l 0.4 1.4 l 2.6 4.9 v 4.1 l -1.3 1.5 l -1 0.9 h -0.5 c -0.1 -0.1 -0.1 -0.2 0 -0.4 v -0.2 l -1.5 0.7 c -0.1 0.1 -0.2 0 -0.3 -0.1 h 0 c -0.1 0 -0.1 -0.2 0 -0.2 h 0 l 0.4 -0.5 l -1.4 0.7 c -0.1 0.1 -0.2 0 -0.3 -0.1 h -0.1 c 0 -0.1 0 -0.2 0.1 -0.3 l 1.1 -1.1 l 0.8 -1 v -2.2 l -0.5 2.2 l -1.7 1.7 h -0.4 c -0.1 0 -0.2 -0.1 -0.2 -0.2 h 0 c 0.1 0 0.1 0 0.1 -0.1 h 0 l 1 -2 v -2.1 s -1.7 -3.8 -1 -6 c -0.3 -1.1 0.4 -2.2 1.5 -2.4 c 0.8 -0.2 1.6 0.1 2.2 0.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 345.78 376.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,228,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-282.54, -329.34)",
    d: "M 280.8 327.5 c -1 0.9 -1.1 2.5 -0.2 3.5 h 0.1 c 0.8 1 2.4 1.2 3.4 0.3 l 0.1 -0.1 h 0.1 c 1 -1 1.1 -2.6 0.1 -3.6 s -2.6 -1.1 -3.6 -0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 341.05 367.35)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_855",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 342.598,
    y1: 469.656,
    x2: 330.263,
    y2: 469.656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(85,42,220)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(100,98,220)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_855)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-336.49, -469.66)",
    d: "M 340.8 479.3 c 1.5 -0.6 2.2 -2.3 1.7 -3.8 l -4.9 -13.4 v -0.2 c -0.8 -1.8 -2.9 -2.7 -4.7 -2 h -0.2 c -1.8 0.7 -2.8 2.7 -2.2 4.5 c 0 0.1 0 0.1 0.1 0.1 h 0 v 0.5 l 6.2 12.8 c 0.5 1.4 2 2.2 3.4 1.7 c 0.1 0 0.1 0 0.2 -0.1 h 0.4 v -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 338.66 349.55)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_856",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 338.672,
    y1: 453.761,
    x2: 330.372,
    y2: 453.761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(85,42,220)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(100,98,220)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_856)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-334.55, -453.76)",
    d: "M 330.4 463.7 v -19.1 c 0.2 -2.3 2.2 -4 4.5 -3.8 c 1.8 0.2 3.4 1.5 3.8 3.3 v 0.7 l -0.8 18.6 c -0.3 2.1 -2.2 3.6 -4.2 3.3 h -0.1 c -1.6 -0.2 -2.9 -1.4 -3.2 -3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 506.43 332.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-413.15, -290.35)",
    d: "M 411.6 286.9 l -0.2 1 c -0.2 0.4 -0.1 0.9 0.2 1.2 l 0.6 0.5 l 0.5 -2.2 l -1.1 -0.5 z m 0.3 4.7 l 1.2 2 c 0.1 0.2 0.2 0.2 0.4 0.2 h 0.1 c 0.1 0 0.2 -0.2 0.2 -0.3 l -0.4 -1.2 l -0.5 -1.5 l 1.5 2 c 0.1 0.2 0.3 0.2 0.5 0.1 c 0.1 -0.1 0.1 -0.3 0.1 -0.5 l -0.9 -1.5 l -0.7 -1.4 l 1.1 1.2 c 0.2 0.1 0.4 0 0.5 -0.2 v -0.3 l -1.9 -2.4 l -1.2 3.8 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 508.31 328.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-414.67, -286.76)",
    d: "M 413.7 279.4 l -1.2 3 c -0.1 0.3 -1 5.2 -1.1 5.6 v 2.9 l 0.5 2.7 c 0.2 0.9 0.4 0.4 0.6 0.3 l 0.2 -0.4 l -0.3 -3 l 1 -3 l 1.1 -0.6 l 0.9 1.2 l 0.4 1.1 l 1.2 1.2 a 0.61 0.61 0 0 0 0.8 0 c 0.2 -0.2 0.2 -0.5 0 -0.7 l -0.7 -1.1 l -0.5 -1.7 l -1.6 -3.8 l 2 -3.4 l -3.3 -0.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 512.95 293.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,148,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-418.45, -255.3)",
    d: "M 419.1 242.2 c -2.2 -0.4 -4.4 1 -4.8 3.3 h 0 c -0.1 0.2 -0.1 0.5 -0.1 0.7 v 18.7 c 0 2 1.7 3.7 3.8 3.6 h 0.2 h 0 c 1.7 -0.1 3.1 -1.3 3.5 -3 v -0.4 l 1 -18.7 c 0 -2.1 -1.5 -3.9 -3.5 -4.3 l -0.1 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 507.71 322.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,239,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-414.19, -280.88)",
    d: "M 414.8 278.4 c 1.3 0.3 2.1 1.4 1.9 2.7 h 0 v 0.2 c -0.2 1.3 -1.3 2.3 -2.7 2.1 c -0.1 0 -0.2 0 -0.2 -0.1 h -0.1 c -1.4 -0.2 -2.3 -1.5 -2 -2.9 v -0.1 h 0 c 0.3 -1.4 1.7 -2.2 3.1 -1.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 510.58 312.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,125,43)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-416.52, -272.19)",
    d: "M 414 282.5 a 3.18 3.18 0 0 1 -2.4 -3.5 l 2.5 -14.1 v -0.2 c 0.5 -2 2.5 -3.2 4.5 -2.8 c 1.9 0.4 3.2 2.3 2.8 4.3 h 0 v 0.2 l -3.8 13.7 c -0.4 1.6 -1.9 2.7 -3.6 2.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 528.38 398.76)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    cx: 0,
    cy: 0,
    rx: 27,
    ry: 15.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 516 390.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-420.92, -341.85)",
    d: "M 427.9 337 c 0 1.1 0.1 2.3 0.4 3.4 c 0.3 1.2 0.4 2.4 0.4 3.6 c 0 0 -0.1 0.8 -2.4 1.1 c -1.5 0 -3.1 0.3 -4.5 0.9 c -1.4 0.8 -2.9 1.3 -4.5 1.3 c -2.2 0 -3.9 -0.5 -4.1 -1.1 s 0.2 -1.3 0.8 -1.5 h 0.1 c 0.7 -0.3 4.1 -1.5 5.1 -2.5 c 1.3 -1.5 2.5 -3.1 3.4 -4.8 c 0.6 -1.2 5.2 -1.3 5.3 -0.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 526.72 399.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(21,15,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-429.64, -349.42)",
    d: "M 413.1 345.9 c 0 0.2 0 0.3 0.1 0.3 s 1.9 1.1 4.1 1.1 c 1.6 0 3.1 -0.5 4.5 -1.3 c 1.4 -0.6 3 -0.9 4.5 -0.9 c 2.3 -0.3 2.4 -1.1 2.4 -1.1 v 1.4 c 0 0.2 -0.5 0.6 -1.6 0.7 l -3.8 0.6 c -1.3 0.4 -3.2 1.4 -4.3 1.5 c -4.2 0.4 -5.6 -0.5 -5.7 -0.8 c -0.2 -0.5 -0.3 -1 -0.2 -1.5 h 0 h 0 z m 33.1 2.1 l -0.3 2.1 c -0.5 1.8 -3.6 2.5 -6.1 2.3 s -2.2 -1 -1.9 -1.7 c -0.3 0.8 -0.4 1.7 -0.5 2.5 c 0.1 0.9 0.6 1.4 2.6 1.6 s 4.8 -0.5 5.6 -1.8 s 0.6 -5 0.6 -5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 541.7 395.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,20,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-441.82, -346.03)",
    d: "M 445.7 339.2 c 0.2 0.7 1.1 8 0.2 11.1 s -3.4 3.3 -6.4 2.9 s -2.1 -1.9 -1.7 -2.7 c 0.8 -1.7 1.5 -3.5 2 -5.3 c 0.4 -1.6 0.9 -5.4 1.8 -6 s 3.9 -0.7 4.1 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 531.47 389.63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,29,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-433.5, -341.05)",
    d: "M 441.3 345.5 l -1.5 -0.2 h 0 c 0.4 -1.6 0.9 -5.4 1.8 -6 s 3.9 -0.7 4.1 0 c 0.3 1.3 0.5 2.7 0.5 4.1 c -1.2 1.4 -3 2.2 -4.9 2.1 z m -16.1 -3.7 c -1.6 0 -3.2 -0.5 -4.4 -1.6 c 0.8 -1.1 1.5 -2.3 1.8 -2.8 s 5.2 -1.3 5.3 -0.4 c 0 1.1 0.1 2.3 0.4 3.4 c 0 0.2 0.1 0.4 0.1 0.6 c -1 0.6 -2.1 0.8 -3.2 0.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 518.19 369.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,56,98)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-422.7, -323.41)",
    d: "M 428.7 339 c -1 -10.4 -0.7 -19.4 -1.7 -29.8 c -0.5 -2.8 -3.2 -4.6 -6 -4 h -0.1 c -2.4 0.4 -4.2 2.5 -4.2 5 c 1 10.4 2.7 19.5 3.7 29.9 c 0.3 2.8 8.6 1.7 8.3 -1.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 527.64 350.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,56,98)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-430.39, -305.92)",
    d: "M 429.1 275.5 a 1.1 1.1 0 0 0 0 -0.8 c 0.2 -4 -2.8 -7.4 -6.8 -7.7 s -7.4 2.6 -7.8 6.6 v 0.2 h 0 c -0.1 0.5 0 1.1 0.1 1.6 h 0 l 2.1 34.5 c 0.2 2.8 2.6 5 5.4 4.9 c 2.7 -0.1 4.8 -2.2 5 -4.9 l 2 -34.4 h 0 h 0 z m 17.2 66.7 c -1.6 -10.3 -2 -19 -3.5 -29.3 c -0.6 -2.8 -3.2 -4.7 -6 -4.4 c -2.8 0.5 -4.8 3.1 -4.3 6 h 0 c 1.5 10.3 4.4 16.1 6 28.7 c 0.3 2.8 8.2 1.8 7.8 -1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 532.32 338.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,56,98)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-434.19, -295.53)",
    d: "M 442.8 313.2 l -2.7 -34.4 c 0 -0.3 -0.1 -0.5 -0.1 -0.8 c -0.9 -3.9 -4.6 -6.4 -8.5 -5.8 c -3.8 0.7 -6.4 4.3 -5.9 8.2 h 0.1 v 0.2 h 0 l 6.8 33.9 c 0.3 2.8 2.9 4.8 5.7 4.4 h 0.2 c 2.8 -0.4 4.8 -3 4.4 -5.9 v 0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 524.48 304.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,239,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-427.82, -264.73)",
    d: "M 437.6 286.5 c 0.8 0.1 1.6 0.1 2.4 -0.2 c 0.2 -5.7 0.9 -34 0.3 -36 s -6.6 -5.2 -12.3 -6.5 c -2.3 -0.6 -4.7 -0.9 -7.1 -0.9 c -3.3 0 -4.6 0.7 -4.8 1.4 c -1 3.9 -0.3 11.6 0 15.3 c 0.1 1 0.2 1.7 0.2 2.1 s -0.3 4.1 -0.6 8.6 l -0.6 10.2 c 0 0.3 0.1 0.5 0.3 0.5 c 2.6 2.8 15.9 5.5 22.2 5.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 524.33 306.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,152,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-427.7, -266.63)",
    d: "M 431.1 243.7 c 4.8 1.6 9.5 4.3 10.1 6.3 s -0.9 13 -0.7 24.6 c 0.2 6.6 1.6 12.7 1.6 13.7 s -9.9 4.3 -17.5 2.5 c 0.1 -14.4 6.7 -47.1 6.5 -47.1 h 0 h 0 z m -15.8 18 c 0 -1.4 -1.4 -12.5 -0.1 -17.6 c 0.5 -2.2 4.3 -2.5 9 -1.9 c -1.9 1.5 -1.6 9.7 -1.9 13.7 c -1 11.3 -1 23.8 -1.1 33.7 c -4.5 -1.2 -8 -5.4 -7.9 -7 c 0.5 -8.4 2 -19.6 2 -20.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 523.16 284.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-426.75, -247.09)",
    d: "M 432.9 247.9 c -0.2 1.5 -3.1 2.3 -6.5 1.9 s -6 -2.1 -5.8 -3.5 s 3.1 -2.4 6.5 -1.9 s 6 2 5.8 3.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 515.41 297.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,125,43)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-420.45, -258.95)",
    d: "M 423.6 242 l -2.2 33.9 c -2 -8.8 -3.4 -17.7 -4.1 -26.7 l 3.4 -0.3 l -2.4 -2.6 c 1.3 -1.7 5.3 -4.3 5.3 -4.3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 523.6 277.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-427.1, -240.8)",
    d: "M 427.1 232.2 a 3.9 3.9 0 0 1 3.7 3.7 v 9.8 a 3.76 3.76 0 0 1 -3.7 3.7 h 0 c -2 0.1 -3.6 -1.5 -3.7 -3.5 v -0.2 v -9.8 a 3.9 3.9 0 0 1 3.7 -3.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 515.37 265.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-420.41, -230.04)",
    d: "M 421.2 227.2 c -2.1 -0.4 -3.2 2.7 -2.5 3.9 s 2 0.7 2.7 1.7 s 1.8 -5.2 -0.2 -5.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 523.6 273.44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,148,190)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-427.1, -237.31)",
    d: "M 427.1 231.2 a 3.9 3.9 0 0 1 3.7 3.7 v 7.8 c -1 0.5 -2.2 0.8 -3.3 0.7 c -1.4 0.1 -2.9 -0.3 -4.1 -1.1 v -7.4 a 3.9 3.9 0 0 1 3.7 -3.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 521.57 269.97)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_857",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 432.1,
    y1: 234.202,
    x2: 418.6,
    y2: 234.202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(230,148,190)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    style: {
      stopColor: "rgb(235,158,193)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    style: {
      stopColor: "rgb(246,178,200)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(253,190,205)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,194,206)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_857)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-425.45, -234.2)",
    d: "M 422 242.7 c -0.4 0.1 -0.8 0 -1.2 -0.2 c -0.1 0 -0.8 -1.8 -1.1 -2.4 c -0.7 -0.9 -1 -2 -1 -3.1 c 0 -1.4 0.5 -2.7 0.4 -3.4 c -0.4 -1.5 -0.2 -3.2 0.5 -4.6 c 1.5 -2.6 4.6 -3.9 7.5 -3.1 c 3 0.5 5.1 3.1 5.1 6.1 c -0.2 2.6 -1.3 5 -3.1 6.8 c -1.4 1.5 -3.1 2.6 -4.9 3.4 c -0.7 0.4 -1.4 0.5 -2.2 0.5 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 528.03 270.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-430.71, -234.85)",
    d: "M 434.1 229.8 c 0.7 2.3 -1.7 5.7 -1.7 7.8 s -1.6 3.1 -1.6 2.9 v -5.2 s -0.6 -0.7 -1.2 1 s -1.3 0.4 -1.2 -0.3 c 0.2 -0.8 0.3 -1.7 0.2 -2.5 c -0.1 -0.6 -1.1 -0.7 -1.4 -1.8 s 6.5 -3.7 6.9 -1.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 521.86 263.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-425.69, -228.18)",
    d: "M 432.8 229.8 c 1.4 -0.9 1.6 -3.1 -2.5 -4.4 c -1.2 -0.4 -7.6 -0.2 -8.5 -0.4 s -2.2 -0.6 -3.3 0.1 s -1.9 4.3 3 5.9 c 3.8 1.2 7.9 0.7 11.3 -1.2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 526.99 298.36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,125,43)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-429.87, -259.55)",
    d: "M 430.5 252.7 l 3.3 2.2 l -8.1 22.2 c 0.1 -0.4 -2.3 -15.4 2.9 -26 c 1.4 -2.8 2.2 -5.9 2.2 -9.1 c 0 0 3.3 5.3 3.7 9.5 l -4 1.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 539.33 300.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,125,43)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-439.9, -261.46)",
    d: "M 445.5 270.7 c 0 -0.1 -0.1 -0.2 -0.1 -0.4 l -2.8 -18.5 c -0.5 -2.2 -2.7 -3.7 -4.9 -3.2 h -0.1 c -1.9 0.4 -3.2 2.1 -3.3 4 h 0 c 0 0.2 0.1 0.4 0.1 0.6 l 3.6 18.3 c 0.5 2 2.5 3.3 4.6 2.8 c 1.7 -0.4 2.9 -1.9 2.9 -3.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 533.25 311.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-434.95, -270.9)",
    d: "M 424.4 270 c 0.1 -1.6 1.4 -2.9 3 -2.9 h 14.5 c 2.1 0.2 3.7 1.9 3.6 4 h 0 c -0.1 2 -1.8 3.7 -3.8 3.6 h -0.3 l -14.2 -1.3 c -1.6 -0.1 -2.9 -1.4 -2.8 -3 v -0.1 h 0 v -0.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 533.25 311.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-434.95, -270.9)",
    d: "M 424.4 270 c 0.1 -1.6 1.4 -2.9 3 -2.9 h 14.5 c 2.1 0.2 3.7 1.9 3.6 4 h 0 c -0.1 2 -1.8 3.7 -3.8 3.6 h -0.3 l -14.2 -1.3 c -1.6 -0.1 -2.9 -1.4 -2.8 -3 v -0.1 h 0 v -0.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 523.33 310.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,162,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-426.89, -270.11)",
    d: "M 429.7 270.3 c -0.1 1.4 -1.2 2.5 -2.6 2.4 h -0.1 c -1.4 0.2 -2.6 -0.7 -2.9 -2.1 v -0.2 c -0.2 -1.4 0.8 -2.7 2.2 -2.9 h 1 c 1.3 0.1 2.4 1.3 2.4 2.6 h 0 v 0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 533.25 311.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,125,43)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-434.95, -270.9)",
    d: "M 424.4 270 c 0.1 -1.6 1.4 -2.9 3 -2.9 h 14.5 c 2.1 0.2 3.7 1.9 3.6 4 h 0 c -0.1 2 -1.8 3.7 -3.8 3.6 h -0.3 l -14.2 -1.3 c -1.6 -0.1 -2.9 -1.4 -2.8 -3 v -0.1 h 0 v -0.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 523.33 310.19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,239,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-426.89, -270.11)",
    d: "M 429.7 270.3 c -0.1 1.4 -1.2 2.5 -2.6 2.4 h -0.1 c -1.4 0.2 -2.6 -0.7 -2.9 -2.1 v -0.2 c -0.2 -1.4 0.8 -2.7 2.2 -2.9 h 1 c 1.3 0.1 2.4 1.3 2.4 2.6 h 0 v 0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 510.43 306.26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-416.4, -266.6)",
    d: "M 422 269.4 l -5.9 -5.2 l -0.6 -0.2 l -4.5 -0.2 c -0.1 0.1 -0.2 0.2 -0.2 0.3 h 0.1 l 5.8 5.2 l 5.3 0.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 515.98 308.43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-420.91, -268.55)",
    d: "M 427.4 268.1 l -2.4 -0.4 l -2.9 -1.7 l -1.3 -0.5 l -2.1 -0.3 h -1.6 l 0.9 0.8 l 0.5 0.4 l 1.7 0.5 h -1.8 l -3.6 -0.7 l -0.4 0.2 c -0.1 0.2 -0.1 0.5 0.1 0.6 h 0.1 l 2.8 1.1 l -3.8 -1.4 c 0 -0.1 -0.1 -0.2 -0.2 -0.1 s -0.2 0.1 -0.2 0.2 s -0.1 0.4 0.1 0.5 l 1.7 1 c -0.1 0.2 0 0.3 0.1 0.4 l 4.6 2.8 l 4.9 0.2 l 2.6 0.2 c 1.9 -0.1 1.9 -3.5 0.2 -3.8 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 519.56 275.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,31,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-423.82, -239.3)",
    d: "M 428.9 236 s 0.4 3.4 -0.8 4.6 c -1.8 1.4 -4 2.3 -6.3 2.6 c -1.6 0.1 -1.9 -0.9 -2.3 -2.2 c -0.4 -0.9 -0.6 -1.9 -0.8 -2.9 c -0.3 -1 1.6 -0.9 2.5 -0.5 c 1.4 0.9 3.1 1.2 4.7 0.8 c 1.8 -0.6 2.6 -3 2.6 -3 l 0.4 0.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 527.57 272.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,180,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-430.33, -236.49)",
    d: "M 429.1 235.7 c -0.7 1.1 -0.8 2.4 -0.1 2.8 s 1.8 0 2.5 -1.1 s 0.9 -2.4 0.2 -2.9 s -1.8 0.1 -2.6 1.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 560 260.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(87,92,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-456.7, -226.19)",
    d: "M 445.4 209.6 l 22.6 13 c 0.6 0.4 1 1.1 1 1.8 v 17.8 c 0 0.6 -0.4 0.9 -1 0.6 l -7.9 -4.6 c -0.4 -0.2 -0.7 -0.2 -0.9 0.1 l -1.6 2.3 c -0.4 0.5 -1.4 0 -1.8 -1 l -1.6 -4.2 c -0.2 -0.4 -0.5 -0.8 -0.9 -1.1 l -7.9 -4.6 c -0.6 -0.3 -1 -1 -1 -1.7 v -17.8 c 0 -0.7 0.5 -0.9 1 -0.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 560 261.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-456.7, -226.55)",
    d: "M 462.2 227.9 c 0.9 0.7 1.4 1.6 1.6 2.7 c 0 1.1 -0.7 1.5 -1.6 1 c -0.9 -0.6 -1.5 -1.7 -1.6 -2.8 c 0 -1 0.7 -1.5 1.6 -0.9 z m -7.1 -2.3 c 0.1 1.1 0.7 2.2 1.6 2.8 c 0.9 0.5 1.6 0.1 1.6 -0.9 c 0 -1.1 -0.6 -2.2 -1.6 -2.8 c -0.9 -0.5 -1.6 -0.1 -1.6 0.9 z m -5.5 -3.2 a 3.19 3.19 0 0 0 1.6 2.8 c 0.9 0.5 1.6 0.1 1.6 -0.9 c -0.1 -1.1 -0.7 -2.1 -1.6 -2.8 c -0.9 -0.5 -1.6 -0.1 -1.6 0.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 561.91 260.31)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_858",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 502.6 356.86)",
    x1: 24.210000000000083,
    y1: 27.55313708498993,
    x2: 2.6900000000000093,
    y2: 6.888284271247483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(222, 222, 238, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(255, 8, 193, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_858)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-516.05, -374.08)",
    d: "M 526.8 390.7 v -17.8 c 0 -0.7 -0.4 -1.4 -1 -1.8 l -22.6 -13 c -0.2 -0.1 -0.4 -0.2 -0.6 -0.1 l 2.6 -1.1 c 0.2 -0.1 0.4 0 0.6 0.1 l 22.7 13 c 0.5 0.5 0.9 1.1 1 1.8 v 17.8 c 0 0.3 -0.2 0.6 -0.4 0.7 l -2.6 1 c 0.2 -0.1 0.3 -0.4 0.3 -0.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 562.89 275.77)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_859",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.5 0 0 -2.64 280.2 1956.09)",
    x1: 68.001,
    y1: 594.552,
    x2: 67.351,
    y2: 593.442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(222,222,238)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_859)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-516.85, -387.88)",
    d: "M 515.4 389.1 l 1.6 -2.3 c 0.2 -0.3 0.5 -0.3 0.9 -0.1 l 0.7 0.4 l -0.6 0.9 h -0.2 l -2.7 1.2 l 0.3 -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 181.47 217.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(87,92,169)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-148.95, -187.35)",
    d: "M 160.3 170.8 l -22.7 13 c -0.6 0.4 -1 1.1 -1 1.8 v 17.8 c 0 0.6 0.5 0.9 1 0.5 l 8 -4.5 c 0.3 -0.2 0.7 -0.2 0.8 0 l 1.7 2.4 c 0.4 0.5 1.3 -0.1 1.7 -1.1 l 1.7 -4.1 c 0.1 -0.4 0.4 -0.8 0.8 -1.1 l 8 -4.6 c 0.6 -0.4 1 -1.1 1 -1.8 v -17.7 c 0 -0.7 -0.5 -1 -1 -0.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 181.47 217.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-148.95, -187.7)",
    d: "M 145.1 190 a 3.66 3.66 0 0 1 -1.6 2.7 c -0.9 0.5 -1.6 0.1 -1.6 -0.9 c 0.1 -1.1 0.7 -2.1 1.6 -2.8 c 0.8 -0.5 1.6 -0.1 1.6 1 z m 3.8 -4.1 c -0.9 0.7 -1.4 1.6 -1.6 2.7 c 0 1.1 0.8 1.5 1.6 1 c 1 -0.6 1.6 -1.7 1.7 -2.8 c 0 -1 -0.8 -1.4 -1.7 -0.9 z m 5.5 -3.2 c -0.9 0.7 -1.5 1.7 -1.6 2.8 c 0 1 0.7 1.4 1.6 0.9 c 0.9 -0.6 1.5 -1.7 1.6 -2.8 c 0 -1 -0.7 -1.4 -1.6 -0.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 178.6 216.86)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_860",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 191.8 318.06)",
    x1: 23.94099999999998,
    y1: 27.897551298552262,
    x2: 2.9589999999999974,
    y2: 6.543870057685098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(26, 26, 164, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(216, 0, 156, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_860)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.25, -335.28)",
    d: "M 194.4 351.9 v -17.8 c 0 -0.7 0.4 -1.4 1 -1.8 l 22.7 -13 c 0.2 -0.1 0.4 -0.2 0.6 -0.1 l -2.6 -1.1 c -0.2 -0.1 -0.5 0 -0.7 0.1 l -22.6 13 c -0.6 0.4 -1 1.1 -1 1.8 v 17.8 c 0 0.2 0.1 0.5 0.3 0.6 l 2.6 1.1 c -0.2 -0.1 -0.3 -0.4 -0.3 -0.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 178.58 232.3)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_861",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.6 0 0 -2.65 -34.76 1925.7)",
    x1: 66.588,
    y1: 595.122,
    x2: 66.328,
    y2: 594.662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(222,222,238)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_861)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-204.4, -349.08)",
    d: "M 205.9 350.3 l -1.7 -2.4 c -0.1 -0.2 -0.5 -0.2 -0.8 0 l -0.8 0.4 l 0.6 0.9 h 0.2 l 2.8 1.2 l -0.3 -0.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 238.05 119.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,142,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-194.95, -99.61)",
    d: "M 206.2 83 l -22.6 13.1 c -0.6 0.4 -1 1 -1 1.7 v 17.8 c 0 0.7 0.5 0.9 1 0.6 l 8 -4.6 c 0.3 -0.2 0.7 -0.2 0.8 0.1 l 1.7 2.3 c 0.4 0.6 1.3 0 1.7 -1 l 1.6 -4.2 c 0.2 -0.4 0.5 -0.8 0.9 -1.1 l 7.9 -4.6 c 0.6 -0.4 1 -1 1.1 -1.7 V 83.6 c 0 -0.6 -0.5 -0.9 -1.1 -0.6 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 236.21 118.63)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_862",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 237.8 230.36)",
    x1: 23.941000000000006,
    y1: 27.897551298552237,
    x2: 2.9590000000000005,
    y2: 6.543870057685092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(222, 222, 238, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(0, 0, 61, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_862)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.25, -247.58)",
    d: "M 240.4 264.1 v -17.8 c 0 -0.7 0.4 -1.3 1 -1.7 l 22.6 -13.1 h 0.7 l -2.6 -1.1 c -0.2 -0.1 -0.4 0 -0.7 0.1 l -22.6 13 c -0.6 0.4 -1 1 -1 1.7 V 263 c 0 0.4 0.1 0.6 0.3 0.7 l 2.6 1.1 c -0.2 -0.2 -0.3 -0.4 -0.3 -0.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 235.1 134.04)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_863",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.5 0 0 -2.75 13.7 1913.5)",
    x1: 68.339,
    y1: 601.88,
    x2: 68.069,
    y2: 601.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(222,222,238)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_863)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-250.35, -261.33)",
    d: "M 251.9 262.5 l -1.7 -2.3 c -0.1 -0.3 -0.5 -0.3 -0.8 -0.1 l -0.8 0.5 l 0.6 0.8 l 0.2 0.2 c 0.1 0 2.7 1.2 2.7 1.1 s -0.2 0 -0.2 -0.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 237.68 118.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(151,18,62)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-194.65, -99.3)",
    d: "M 195.4 104 v 1.6 l -1.2 0.6 v -1.6 c -1 0.5 -2.1 0.6 -3.1 0.2 l 0.7 -2 a 3.31 3.31 0 0 0 2.4 0 v -2.4 c -1.4 0.2 -2.9 0.4 -2.9 -1.6 a 4.98 4.98 0 0 1 2.9 -4.3 v -1.6 l 1.2 -0.5 v 1.5 c 0.8 -0.3 1.7 -0.3 2.5 -0.2 l -0.7 2 c -0.6 -0.1 -1.2 -0.1 -1.8 0.1 v 2.4 c 1.3 -0.3 2.8 -0.4 2.8 1.6 c -0.1 1.8 -1.2 3.4 -2.8 4.2 h 0 h 0 z m -1.2 -5.7 v -2 c -0.5 0.3 -0.9 0.9 -0.9 1.5 c 0 0.5 0.3 0.6 0.9 0.5 z m 2.1 2.5 c 0 -0.5 -0.4 -0.6 -0.9 -0.6 v 2 c 0.5 -0.3 0.8 -0.8 0.9 -1.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 320.46 275.62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,142,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-261.95, -239.25)",
    d: "M 250.6 222.7 l 22.6 13 c 0.6 0.4 1 1.1 1.1 1.8 v 17.7 c 0 0.7 -0.5 1 -1.1 0.6 l -7.9 -4.5 c -0.2 -0.2 -0.5 -0.2 -0.8 -0.1 h -0.1 l -1.6 2.3 c -0.4 0.6 -1.3 0 -1.7 -1 l -1.7 -4.2 a 1.59 1.59 0 0 0 -0.8 -1 l -8 -4.6 c -0.6 -0.4 -1 -1.1 -1 -1.8 v -17.7 c 0 -0.6 0.5 -0.9 1 -0.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 322.3 274.98)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_864",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 307.8 369.96)",
    x1: 23.94100000000003,
    y1: 27.897551298552216,
    x2: 2.9590000000000036,
    y2: 6.543870057685087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(222, 222, 238, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(21, 21, 255, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_864)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-321.25, -387.18)",
    d: "M 332.1 403.7 V 386 c -0.1 -0.7 -0.5 -1.4 -1.1 -1.8 l -22.6 -13 c -0.2 -0.1 -0.4 -0.2 -0.6 -0.1 l 2.6 -1.1 c 0.2 -0.1 0.5 0 0.7 0.1 l 22.6 13 c 0.6 0.4 1 1.1 1 1.8 v 17.7 c 0 0.4 -0.1 0.6 -0.4 0.7 l -2.5 1.1 c 0.2 -0.2 0.3 -0.4 0.3 -0.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 323.34 290.37)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_865",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.62 0 0 -2.61 82.43 1949.75)",
    x1: 65.89,
    y1: 592.776,
    x2: 65.25,
    y2: 591.646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(222,222,238)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_865)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-322.09, -400.92)",
    d: "M 320.6 402.1 l 1.6 -2.3 c 0.2 -0.2 0.5 -0.2 0.8 -0.1 h 0.1 l 0.8 0.4 l -0.6 0.8 l -0.2 0.2 c -0.1 0 -2.7 1.2 -2.8 1.1 s 0.2 0.1 0.3 -0.1 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 320.46 276.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,217,227)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-261.95, -240.41)",
    d: "M 262.7 243.4 l -2.3 -1.4 c 0 -1.8 -2.5 -3.6 -2.5 -6.4 s 1.5 -2.4 3.8 -1.1 c 1.9 1.2 3.4 2.9 4.3 4.9 l -1.8 0.2 c -0.4 -1.1 -1.2 -2 -2.2 -2.6 s -1.7 -0.4 -1.7 0.4 s 2.4 3.5 2.4 6 h 0 h 0 z m -1.1 3.7 c -0.9 -0.5 -1.5 -1.4 -1.5 -2.4 c 0 -0.9 0.6 -1.3 1.5 -0.8 c 0.8 0.6 1.3 1.4 1.4 2.4 c 0 0.9 -0.6 1.3 -1.4 0.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 327.71 88.17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,142,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.85, -71.88)",
    d: "M 255.4 53.6 L 280.3 68 c 0.6 0.5 1 1.2 1.1 1.9 v 19.6 c 0 0.7 -0.5 1 -1.1 0.6 l -8.8 -5 c -0.4 -0.2 -0.7 -0.2 -0.9 0.1 l -1.8 2.5 c -0.4 0.6 -1.5 0 -1.9 -1.1 l -1.8 -4.6 c -0.2 -0.5 -0.6 -0.9 -1 -1.2 l -8.7 -5 c -0.7 -0.4 -1.1 -1.2 -1.1 -2 V 54.3 c 0 -0.7 0.5 -1 1.1 -0.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 329.75 87.52)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_866",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 312.5 200.9)",
    x1: 26.34400000000002,
    y1: 30.617999999999988,
    x2: 3.2560000000000024,
    y2: 7.181999999999997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(222, 222, 238, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(23, 23, 106, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_866)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-327.3, -219.8)",
    d: "M 339.2 238 v -19.6 c -0.1 -0.7 -0.5 -1.4 -1.1 -1.9 l -24.9 -14.4 h -0.7 l 2.8 -1.2 h 0.8 l 24.9 14.5 c 0.7 0.4 1.1 1.1 1.1 1.9 v 19.5 c 0 0.3 -0.2 0.6 -0.4 0.7 l -2.9 1.2 c 0.2 -0.1 0.4 -0.4 0.4 -0.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 330.91 104.47)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_867",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.9 0 0 -2.94 81.56 2045.25)",
    x1: 63.018,
    y1: 615.25,
    x2: 62.368,
    y2: 614.15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(222,222,238)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(211,211,232)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_867)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-328.25, -234.93)",
    d: "M 326.6 236.2 l 1.8 -2.5 c 0.2 -0.3 0.5 -0.3 0.9 -0.1 l 0.9 0.5 l -0.7 0.9 l -0.2 0.2 c -0.1 0 -2.9 1.3 -3 1.2 l 0.3 -0.2 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 326.97 87.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(169,27,67)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.25, -71.72)",
    d: "M 267.4 67.7 v 8.4 l -1.7 -0.8 v -3.5 l -3.4 -1.7 v 3.5 l -1.7 -0.9 v -8.4 l 1.7 0.9 v 3.3 l 3.4 1.7 v -3.3 l 1.7 0.8 z m 1.4 0.8 c 0 -0.6 0.4 -0.9 1 -0.6 a 1.78 1.78 0 0 1 1 1.6 c 0 0.6 -0.4 0.8 -1 0.5 c -0.6 -0.2 -1 -0.8 -1 -1.5 z m 0.2 2 l 1.6 0.8 v 6.5 l -1.6 -0.9 v -6.4 z m 2.9 6.9 c 0 -0.6 0.4 -0.8 1 -0.5 a 1.78 1.78 0 0 1 1 1.6 c 0 0.6 -0.4 0.8 -1 0.5 a 1.78 1.78 0 0 1 -1 -1.6 z m 0 -7.3 l 2 0.9 l -0.3 5.4 l -1.3 -0.7 l -0.4 -5.6 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 422.38 152.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(52,6,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-344.81, -129.3)",
    d: "M 382.3 97.5 l -2 -0.7 h 0 c 0.3 -2.4 0 -4.9 -0.9 -7.2 c -1.4 -3.4 -4.4 -7.2 -10.6 -8.7 h 0.1 c -2.1 -3.7 -5.3 -6.8 -9.1 -8.7 a 17.54 17.54 0 0 0 -9.8 -2 v -1.6 c 0.9 -0.1 1.6 -0.8 1.6 -1.7 c 0.1 -0.9 -0.5 -1.6 -1.4 -1.8 h -0.1 c -1 0 -1.8 0.8 -1.9 1.8 c -0.1 0.8 0.5 1.6 1.3 1.7 h 0.1 v 1.7 h -0.4 l -4.4 0.8 c -2.2 -0.5 -4.4 -0.5 -6.6 -0.1 l -17.1 4 l -2.5 0.6 h -0.2 c -2.7 1.2 -4 4 -4.6 6 l -3.6 1.5 h -0.2 c -0.4 0.3 -0.6 0.7 -0.6 1.1 c 0 0 -1.1 11.2 -1 12.6 c -0.2 0.8 0.3 1.6 1.1 1.8 h 0.1 l 2.3 0.7 c -0.2 3.4 0.6 6.9 2.2 9.9 c -4.4 2.4 -7.4 6.1 -7.8 11.6 c -1.1 15 9.4 44.3 19.4 59.9 c 5.4 8.6 11.2 11.9 16.5 12.6 s 11.1 -0.2 16.5 -6.8 c 10 -12.2 20.4 -37.8 19.4 -53.2 c -0.4 -5.2 -2.9 -9.6 -6.8 -13.4 h 0.2 c 1.7 -1.1 2.9 -2.9 3.2 -4.9 l 6.5 -1.6 s 0.9 -0.2 1.1 -2.1 l 1.1 -12.1 c 0 -0.7 -0.5 -1.4 -1.1 -1.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 384.11 197.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(139,33,254)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-313.7, -169.3)",
    d: "M 318.5 167.3 s -4.1 7.9 -9.6 1.5 c 3.2 1.7 7.1 1.1 9.6 -1.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 382.09 168.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-312.06, -143.58)",
    d: "M 308.1 164.5 s -10.7 -29.7 -0.1 -41.1 c 0 0 5.3 -5.2 9.5 1.7 s 3 9.9 3.3 12.9 c 0 0 -1.1 22.9 -2.3 24.6 c 0 0 -2.3 5.3 -10.4 1.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 381.28 169.62)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_868",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 360.737,
    y1: 152.61,
    x2: 297.773,
    y2: 142.314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,254,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(249,248,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69%",
    style: {
      stopColor: "rgb(233,231,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(217,212,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_868)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-311.4, -144.61)",
    d: "M 307.5 166.4 s -10.9 -31 -0.2 -42.9 c 0 0 5.2 -5.3 9.5 1.9 s 3 10.3 3.4 13.5 c 0 0 -1.1 23.8 -2.2 25.5 c 0 0 -2.3 5.6 -10.5 2 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 376 170.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-307.11, -145.4)",
    d: "M 309.8 162.6 c -5.6 -10.6 -6.9 -22.9 -3.6 -34.4 c 0 0 2.5 33.5 3.6 34.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 383.19 195.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,40,116)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-312.95, -167.8)",
    d: "M 307.5 166.4 s 1.9 6.5 5.1 6.4 c 0 0 5.2 0 5.8 -10 c 0 0 -1.9 7.6 -10.9 3.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 413.87 174.67)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_869",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 297.659,
    y1: 140.993,
    x2: 371.359,
    y2: 156.024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,254,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(217,212,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_869)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-337.89, -149.12)",
    d: "M 302 120.4 c 1 -14.7 21 -16.6 35.9 -14.9 c 14.9 3.5 34.9 12.4 35.9 27.4 s -9.4 41 -19.4 53.2 c -5.4 6.7 -11.2 7.9 -16.5 6.8 s -11.1 -4 -16.5 -12.5 c -10 -15.7 -20.5 -44.9 -19.4 -60 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.23 -1.1 1.21 0.21 413.92 143.02)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 15.5,
    ry: 29.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 422.49 150.51)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_870",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 402.85,
    y1: 275.888,
    x2: 402.612,
    y2: 268.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_870)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-402.7, -276.05)",
    d: "M 400.4 281.5 l 7 -9.4 l -9.4 -1.5 l 2.4 10.9 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 441.56 138.7)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_871",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.22 0 0 -15.8 -238.11 12263.5)",
    x1: 32.217,
    y1: 759.761,
    x2: 31.797,
    y2: 760.391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_871)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-418.21, -265.5)",
    d: "M 428.3 260.7 s 0.5 5.1 -3.3 7.3 s -10.7 5.4 -10.7 5.4 l -6.2 -4.1 l 3 -11.7 l 14.5 2 l 2.7 1.1 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 451.22 127.56)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_872",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(18.21 0 0 -20.7 -178.07 16135.6)",
    x1: 33.792,
    y1: 766.519,
    x2: 32.935,
    y2: 767.428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_872)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-426.06, -255.55)",
    d: "M 416.1 251.2 s 3.3 0.7 3.3 2.2 s -1.4 13.7 -1.4 13.7 l 16.6 -5.6 s 1 -0.2 1.2 -2.1 l 1.1 -12.1 c 0.1 -0.8 -0.4 -1.5 -1.1 -1.8 l -4 -1.5 l -16.6 5.8 l 0.9 1.4 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 441.09 109.34)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_873",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(32.09 0 0 -21.03 -536.41 16378.5)",
    x1: 30.02,
    y1: 767.023,
    x2: 29.669,
    y2: 767.674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_873)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-417.83, -239.29)",
    d: "M 433.8 244.7 c 0.2 -2.4 -0.1 -4.9 -0.9 -7.2 c -1.5 -3.5 -4.6 -7.4 -11.1 -8.8 s -7.7 -1.1 -7.7 -1.1 l -12.3 7.2 l 3 5.1 l 10.2 6.4 l 1.2 4.7 l 17.6 -6.3 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 377.1 99.84)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_874",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.6 0 0 -3 101.54 2084.81)",
    x1: 57.759,
    y1: 617.601,
    x2: 57.509,
    y2: 618.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_874)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-365.8, -230.8)",
    d: "M 366.8 232.3 l -3.3 -1.1 l 4.6 -1.9 l -1.3 3 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 399.92 91.61)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_875",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.6 0 0 -8.19 -480.46 6191.52)",
    x1: 30.283,
    y1: 728.486,
    x2: 30.156,
    y2: 729.014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_875)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-384.35, -223.45)",
    d: "M 376.5 226.3 l -1.5 -0.5 l -3.1 -2.2 l 13.8 -3.2 s 4.8 -1 7.9 0.7 s 3.2 3.1 3.2 3.1 l -19.4 2.6 l -0.9 -0.5 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 423.16 95.4)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_876",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(38.3 0 0 -14.83 -706.88 11454.86)",
    x1: 29.246,
    y1: 756.438,
    x2: 28.821,
    y2: 757.737
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(193,183,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(226,207,236)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_876)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-403.25, -226.83)",
    d: "M 422.4 228.8 l -17 6.8 l -21.3 -13.7 l 13.6 -2.7 l 5 -1 c 2.4 -0.1 5.8 -0.7 10.6 1.9 c 3.8 2 7 5 9.1 8.7 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 408.85 123.79)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_877",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 420.494,
    y1: 252.188,
    x2: 362.653,
    y2: 252.188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(215,210,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_877)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-391.61, -252.19)",
    d: "M 415.5 266.4 s 0.1 13.3 -10.9 10.2 l -3 -0.9 l -1.2 5.8 l -6.2 -8 l -18.7 -9.5 s -10.2 -2.7 -10.1 -16.5 l -1.1 -0.4 c -0.8 -0.2 -1.3 -0.9 -1.3 -1.7 l -0.1 -13.1 c 0 -0.7 0.6 -1.3 1.3 -1.3 h 0.4 l 2.2 0.7 s 0.7 -6.4 5.3 -8.3 c 2.7 -0.9 5.6 -0.6 8.1 0.6 c 0 0 2.4 -2.5 11.1 0.6 s 11.2 5.6 14.3 10.6 c 0 0 5.9 1 8.9 5.6 c 1.9 3 2.8 6.6 2.4 10.1 l 2.4 0.6 s 1.2 0.2 1 3.1 l -0.9 11.3 c -0.1 0.7 -0.7 1.3 -1.4 1.2 h -0.4 l -2.1 -0.7 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 407.99 121.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(194,0,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-333.12, -101.66)",
    d: "M 316.8 109.2 l 29.7 13.6 c 2.1 1.1 4.5 0.3 5.4 -1.8 h 0 c 0.2 -0.3 0.3 -0.7 0.3 -1.1 l 2.2 -15.9 c 0.3 -3.4 -1.5 -6.9 -4.6 -8.5 l -32.5 -15 c -3.1 -1.4 -5.5 0.4 -5.5 3.9 v 17.1 c 0.1 3.2 2.1 6.2 5 7.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 406.99 129.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-332.3, -108.68)",
    d: "M 342.4 113 s -10.9 4 -20.2 -9.2 c 0 0 9.7 10.5 20.2 9.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 408.16 116.18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-333.25, -96.89)",
    d: "M 342.5 112.9 c -7.8 0.8 -14.8 -4.1 -18.3 -7.2 c 3.3 3 9.9 7.6 17.3 7.3 c -1.8 0.5 -3.8 0.6 -5.7 0.3 c -3.3 -0.6 -8.2 -2.5 -12.9 -8.7 l -1.2 -1.2 c 3.5 4.9 7 7.5 9.9 8.9 c 3.6 1.7 7.5 2 11 0.8 l 0.9 -0.3 l -1 0.1 z m 11 -1.8 l 1.1 -8.1 s 0.1 -5.1 -4.4 -7.5 l -33.5 -15.4 s -4.2 -1.3 -4.8 3.8 V 92 s 0.5 -7.6 5.6 -7.3 L 349 99.6 s 4 3.6 4.5 11.5 z m -27.7 -14.6 l -2.6 2 c -0.3 0.3 -0.9 0.1 -1.2 -0.4 l -2.5 -3.9 c -0.4 -0.6 -0.4 -1.3 0 -1.6 l 2.6 -2.2 c 0.4 -0.3 0.9 -0.1 1.3 0.5 l 2.4 4 c 0.3 0.7 0.3 1.4 0 1.6 z m 17.9 8.4 l -2.8 2.4 a 0.95 0.95 0 0 1 -1.3 -0.2 l -2.5 -3.7 c -0.4 -0.5 -0.3 -1.2 0.2 -1.6 l 3.2 -2.3 c 0.4 -0.3 1 -0.1 1.3 0.4 l 2.1 3.6 c 0.3 0.5 0.2 1.1 -0.2 1.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 406.84 118.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-332.18, -98.93)",
    d: "M 326 96.4 l -2.5 2.1 c -0.3 0.3 -0.9 0.1 -1.2 -0.4 l -2.2 -3.6 c -0.3 -0.5 -0.3 -1.2 0.1 -1.5 l 2.6 -2.2 c 0.4 -0.3 0.9 -0.1 1.2 0.4 l 2.1 3.7 c 0.3 0.6 0.2 1.2 -0.1 1.5 z m 18.1 8.2 l -2.8 2.4 c -0.4 0.3 -1 0.3 -1.2 -0.2 l -2.2 -3.4 c -0.3 -0.5 -0.2 -1.2 0.3 -1.5 l 3.1 -2.3 c 0.4 -0.3 1 -0.1 1.2 0.3 l 1.8 3.3 c 0.3 0.5 0.2 1.1 -0.2 1.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 423.17 86.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(67,29,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-345.45, -70.05)",
    d: "M 345.4 67.3 h 0.4 l -0.3 5.5 h -0.4 l 0.3 -5.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 422.82 80.97)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_878",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.39 0.06 -0.06 3.57 785.17 -2846.15)",
    cx: -44.644,
    cy: 937.846,
    r: 1.33,
    fx: -44.644,
    fy: 937.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(201,201,201)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(240,240,240)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_878)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-345.17, -65.45)",
    d: "M 343.7 64.6 c 0.5 -0.9 1.6 -1.2 2.4 -0.7 s 1.1 1.6 0.5 2.4 c -0.5 0.9 -1.6 1.2 -2.4 0.7 c -0.8 -0.4 -1 -1.5 -0.5 -2.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 446.19 186.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-364.16, -159.29)",
    d: "M 368.1 180.1 s 10.8 -29.7 0.1 -41.1 c 0 0 -4.6 -4.8 -9.5 1.7 c -3.4 4.5 -3.3 9.9 -3.3 13 c 0 0 1.2 22.8 2.3 24.5 c 0 0 2.3 5.4 10.4 1.9 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 447.07 187.19)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_879",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 313.406,
    y1: 168.557,
    x2: 376.074,
    y2: 158.423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,254,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.999999999999996%",
    style: {
      stopColor: "rgb(249,248,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69%",
    style: {
      stopColor: "rgb(233,231,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(217,212,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_879)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-364.88, -160.3)",
    d: "M 368.7 182 s 11 -31 0.3 -42.8 c 0 0 -4.8 -5.1 -9.6 1.8 c -3.1 4.5 -3.4 9.6 -3.3 13.5 c 0 0 1 23.8 2.2 25.5 c 0 0 2.3 5.6 10.4 2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 452.37 187.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(204,204,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-369.19, -161)",
    d: "M 366.5 178.2 c 5.6 -10.6 6.9 -22.9 3.6 -34.4 c 0 0 -2.5 33.5 -3.6 34.4 h 0 h 0 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 445.12 213.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(82,40,116)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-363.3, -183.4)",
    d: "M 368.8 182 s -1.9 6.5 -5.1 6.4 c 0 0 -5.3 0 -5.9 -10 c 0 0 1.9 7.7 11 3.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 561.71 151.07)",
    style: {}
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 19,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 113.44 100.51)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.12 377.28 321.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(221,221,240)",
      fillRule: "nonzero",
      opacity: 0.5
    },
    transform: " translate(-296.54, -279.71)",
    d: "M 307.3 312.9 l -17.4 -10.1 c -0.5 -0.2 -0.7 -0.8 -0.5 -1.3 l 0.5 -0.5 l 17.4 -10.1 c 0.7 -0.3 1.6 -0.3 2.3 0 L 327 301 c 0.5 0.2 0.7 0.8 0.5 1.3 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10.1 c -0.4 0.2 -0.8 0.3 -1.2 0.3 c -0.4 0.1 -0.8 0 -1.1 -0.3 z m 0.4 -21.2 l -17.4 10.1 h -0.1 c 0 0.1 0 0.1 0.1 0.1 l 17.4 10.1 a 1.71 1.71 0 0 0 1.4 0 l 17.4 -10.1 h 0 l -17.4 -10.1 h -1.4 v -0.1 z m -75.6 -23.4 l -17.4 -10 c -0.4 -0.1 -0.7 -0.5 -0.7 -0.9 c 0 -0.1 0 -0.1 0.1 -0.2 c 0 -0.1 0.1 -0.2 0.1 -0.3 c 0.1 -0.2 0.3 -0.4 0.5 -0.5 l 17.4 -10 c 0.7 -0.3 1.6 -0.3 2.3 0 l 17.4 10 c 0.5 0.3 0.7 0.9 0.5 1.4 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10 c -0.4 0.2 -0.8 0.3 -1.2 0.3 c -0.4 0.1 -0.8 0 -1.1 -0.3 z m 0.4 -21.1 l -17.3 10 h -0.2 l 0.2 0.2 l 17.3 10 a 1.71 1.71 0 0 0 1.4 0 l 17.4 -10 l 0.2 -0.2 h -0.2 l -17.4 -10 l -0.7 -0.2 l -0.7 0.2 z m 126.3 63.5 l -17.4 -10.1 c -0.5 -0.2 -0.7 -0.8 -0.5 -1.3 l 0.5 -0.5 l 17.4 -10.1 c 0.7 -0.3 1.6 -0.3 2.3 0 l 17.4 10.1 c 0.5 0.2 0.7 0.8 0.5 1.3 c -0.1 0.2 -0.3 0.4 -0.5 0.5 l -17.4 10.1 c -0.4 0.2 -0.7 0.4 -1.1 0.3 c -0.4 0 -0.8 -0.1 -1.2 -0.3 h 0 h 0 z m 0.5 -21.2 l -17.4 10.1 h 0 l 17.4 10.3 a 1.71 1.71 0 0 0 1.4 0 l 17.3 -10.1 h 0 l -17.3 -10.1 h -1.4 v -0.2 h 0 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a644dc2012d37aa17f72ae03744d7134.svg";
export { ForwardRef as ReactComponent };